import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { TLCode, Page } from '../../common/enums';
import { Instance } from 'mobx-state-tree';
import {
  Button,
  ButtonGroup,
  Card,
  Tab,
  Tabs,
  TabId,
  Tooltip,
  Position,
  InputGroup,
  NumericInput,
  Icon,
} from '@blueprintjs/core';
import withTranslate, { WithTranslateProps } from '../common/WithTranslate';
import TranslatedMessage from '../common/translation/TranslatedMessage';
import MainSectionLayout from '../layout/MainSectionLayout';
import styled from '@emotion/styled';
import { css } from 'emotion';
import {
  ApplicationStore,
  ScoreStore,
  MatchStore,
  IndictmentStore,
  UiStore,
  PharmacyStore,
  PlannerStore,
  AuthenticationStore,
  SecretariatStore,
  ModalStore,
} from '../../store';
import { renderGridDateTimeWithDetails } from '../../store/utils';
import { groupByKeys } from '../../store/utils';
import { ICellRendererParams } from 'ag-grid-community';
import DateInput from '../common/input/DateInput';
import { IconNames } from '@blueprintjs/icons';
import {
  Scatter,
  ScatterChart,
  LineChart,
  Line,
  CartesianGrid,
  XAxis,
  YAxis,
  Legend,
  Tooltip as ChartTooltip,
  Label,
  ReferenceLine,
} from 'recharts';
import Select from 'react-select';
import { getSemester, getFirstMonday, getFirstSunday } from '../../common/utils';
import XLSX from 'xlsx';
import * as ExcelJs from 'exceljs';
import FileSaver from 'file-saver';
import moment from 'moment';
import DataGrid, {
  Button as DGButton,
  Column,
  FilterRow,
  FilterPanel,
  Grouping,
  GroupPanel,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
  Export,
  Summary,
  SortByGroupSummaryInfo,
  TotalItem,
  GroupItem,
  Scrolling,
} from 'devextreme-react/data-grid';
import { ColumnChooser } from 'devextreme-react/cjs/tree-list';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
import saveAs from 'file-saver';

//import { Summary } from 'glamorous';


const getWithDiff = (newNumber, oldNumber) => {
  const diff = newNumber - oldNumber;
  if (diff === 0) return newNumber;
  else return newNumber + ' (' + (diff > 0 ? '+' : '') + diff + ')';
};

const dateCellRenderer = (params: ICellRendererParams) => {
  return params.getValue() ? params.getValue().split('T')[0] : '';
};

interface AnalysisPageProps extends WithTranslateProps {
  PharmacyStore?: Instance<typeof PharmacyStore>;
  PlannerStore?: Instance<typeof PlannerStore>;
  ApplicationStore?: Instance<typeof ApplicationStore>;
  ScoreStore?: Instance<typeof ScoreStore>;
  MatchStore?: Instance<typeof MatchStore>;
  IndictmentStore?: Instance<typeof IndictmentStore>;
  UiStore?: Instance<typeof UiStore>;
  AuthenticationStore?: Instance<typeof AuthenticationStore>;
  SecretariatStore?: Instance<typeof SecretariatStore>;
  ModalStore?: Instance<typeof ModalStore>;
}

interface AnalysisPageState {
  isLoading: boolean;
  saving: boolean;
  isMounted: boolean;
  planningId: number;
  selectedPlanningId: any;
  selectedTabId: string;
  selectedSubTabId: string;
  selectedDutyCountSubTabId: string;
  selectedUnbalancedCountSubTabId: string;
  startDate: Date;
  endDate: Date;
  prevStartDate: Date;
  prevEndDate: Date;
  ruleFilter: string;
  selectedDate?: Date;
  offset: number;
  savedPlanningId: number;
  savedPrevPlanningId: number;
  status: any;
  distribution: any;
  selectedStartRuleTransgressionDate: Date;
  selectedEndRuleTransgressionDate: Date;
  lowerGapLimit: number;
  upperGapLimit: number;
  nbrPharmaciesWithGapBelow: number;
  nbrPharmaciesWithGapAbove: number;
  semesterYear: number;
  runFilterText: string;
  nbrPharmacies: number;
  suStdev: number;
  saStdev: number;
  nbrNBeforeBP: number;
  nbrDutiesOnDisp: number;
  nbrDutiesOnBP: number;
  nbrDutiesOnPrefOff: number;
  nbrJN0: number;
  nbrJN1plus: number;
  lowerDistanceLimit: number;
  filteredData: any;
}

function getNextStartDate() {
  // JAN0 FEB1 MAR2 APR3 MAY4 JUN5 JUL6 AUG7 SEP8 OCT9 NOV10 DEC11
  const now = new Date();
  if (now.getMonth() < 6) {
    now.setMonth(6);
    now.setDate(1);
  } else {
    now.setFullYear(now.getFullYear() + 1);
    now.setMonth(0);
    now.setDate(1);
  }
  return now;
}

function getNextEndDate() {
  // JAN0 FEB1 MAR2 APR3 MAY4 JUN5 JUL6 AUG7 SEP8 OCT9 NOV10 DEC11
  const now = new Date();
  if (now.getMonth() < 6) {
    now.setFullYear(now.getFullYear() + 1);
    now.setMonth(0);
    now.setDate(1);
  } else {
    now.setFullYear(now.getFullYear() + 1);
    now.setMonth(6);
    now.setDate(1);
  }
  return now;
}

function getSemesterStartDate(date) {
  // JAN0 FEB1 MAR2 APR3 MAY4 JUN5 JUL6 AUG7 SEP8 OCT9 NOV10 DEC11
  const year = date.getFullYear();
  const now = new Date(date);
  if (now.getMonth() >= 6) {
    var S2Start = getFirstMonday(year, 6);
    return S2Start;
  } else {
    var S1Start = getFirstMonday(year, 0);
    return S1Start;
  }
}

function getSemesterEndDate(date) {
  // JAN0 FEB1 MAR2 APR3 MAY4 JUN5 JUL6 AUG7 SEP8 OCT9 NOV10 DEC11
  const year = date.getFullYear();
  const now = new Date(date);
  if (now.getMonth() >= 6) {
    var S2End = getFirstSunday(year+1, 0);
    return S2End;
  } else {
    var S1End = getFirstSunday(year, 6);
    return S1End;
  }
}

function getSemesterStartDateNOK(date) {
  // JAN0 FEB1 MAR2 APR3 MAY4 JUN5 JUL6 AUG7 SEP8 OCT9 NOV10 DEC11
  const now = new Date(date);
  if (now.getMonth() >= 6) {
    now.setMonth(6);
    now.setDate(1);
  } else {
    // now.setFullYear(now.getFullYear() + 1);
    now.setMonth(0);
    now.setDate(1);
  }

  return now;
}

function getSemesterEndDateNOK(date) {
  // JAN0 FEB1 MAR2 APR3 MAY4 JUN5 JUL6 AUG7 SEP8 OCT9 NOV10 DEC11
  const now = new Date(date);
  if (now.getMonth() >= 6) {
    // now.setFullYear(now.getFullYear() + 1);
    now.setMonth(11);
    now.setDate(31);
  } else {
    //    now.setFullYear(now.getFullYear() + 1);
    now.setMonth(5);
    now.setDate(30);
  }

  return now;
}

function balanceComparator(balanceA, balanceB) {
  const intBalanceA = parseInt(balanceA.split('('));
  const intBalanceB = parseInt(balanceB.split('('));
  return intBalanceA > intBalanceB ? 1 : intBalanceA < intBalanceB ? -1 : 0;
}

enum TAB {
  PROBLEMS = 'P',
  SCORES = 'S',
  MATCHES = 'M',
  TRANSGRESSIONS = 'T',
  RULES = 'R',
}
enum SUBTAB {
  TOOCLOSEDUTIES = 'D',
  ABNORMALDUTYCOUNTS = 'C',
  DUTYCOUNTCHANGES = 'DC',
  UNBALANCEDNEIGHBORS = 'N',
  SPECIALISSUES = 'S',
  DISTANCES = 'DIS',
  SUMMARY = 'SU',
  GROUPANALYSIS = 'GA',
  INSUFFICIENTGEOCOVERAGE = 'G',
  UNEVEN_DUTY_INTERVALS = 'UDI',
}

enum SUBSUBTAB {
  TOOCLOSEDUTIESGRID = 'DGRI',
  TOOCLOSEDUTIESGRAPHS = 'DGRA',
  DUTYCOUNTCHANGESGRID = 'DCGRI',
  DUTYCOUNTCHANGESGRAPHS = 'DCGRA',
  UNBALANCEDNEIGHBORSGRID = 'UNGRI',
  UNBALANCEDNEIGHBORSGRAPHS = 'UNGRA',
  GROUPRULETRANSGRESSIONS = 'GRPTRA',
  GROUPDUTYCOUNTS = 'GRPDC',
  GROUPTARGETS = 'GRPTGT',
}

enum columnColors {
  targetColor = 'eaea26',
  countColor = 'f9f998',
  dayTargetColor = '8db4f2',
  dayCountColor = 'c5d9f1',
  nightTargetColor = 'bfbfbf',
  nightCountColor = 'd9d9d9',
  saturdayCountColor = 'dbf7ac',
  sundayCountColor = '85d008',
}

let phBelow: Array<number> = [];
let phAbove: Array<number> = [];
let phBelowCount: Array<number> = [];
let phAboveCount: Array<number> = [];
let gapBelowCount: number;
let gapAboveCount: number;
let nbrJN0: number;
let nbrJN1plus: number;

let totalCount: number[];
let totalDayCount: number[];
let minTotalCount: number;
let maxTotalCount: number;
let minTotalCountSwaps: number;
let maxTotalCountSwaps: number;
let deltaTotalTable: number[];
let minDayCount: number;
let maxDayCount: number;
let totalNightCount: number[];
let minNightCount: number;
let maxNightCount: number;
let minDayCountSwap: number;
let maxDayCountSwap: number;
let deltaDayTable: number[];
let minNightCountSwap: number;
let maxNightCountSwap: number;
let deltaTable: number[];
let minSaturdaySwap: number;
let maxSaturdaySwap: number;
let saturdayTable: number[];
let minSundaySwap: number;
let maxSundaySwap: number;
let sundayTable: number[];
let totalSaturdayCount: number[];
let totalSundayCount: number[];
let saStdevCount: number[];
let minSACount: number;
let maxSACount: number;
let suStdevCount: number[];
let minSUCount: number;
let maxSUCount: number;
let grpBkhStdevCount: number[];
let grpYearBkhStdevCount: number[];
let bkhStdevCount: number[];
let minBkhCount: number;
let maxBkhCount: number;
let yearBkhStdevCount: number[];
let ecarts: number[];
let count = 0;
let grpTarget = 0;
let grpTargetDay = 0;
let grpTargetNight = 0;

const calculateCustomSummary = (options) => {
  // Calculating "customSummary1"
  if (options.name == 'countStdev') {
    switch (options.summaryProcess) {
      case 'start':
        // Initializing "totalValue" here
        totalCount = [];
        break;
      case 'calculate':
        // Modifying "totalValue" here
        totalCount.push(options.value);
        break;
      case 'finalize':
        // Assigning the final value to "totalValue" here
        const moyenne = totalCount.reduce((sum, value) => sum + value, 0) / totalCount.length;
        const variance =
          totalCount.reduce((sum, value) => sum + Math.pow(value - moyenne, 2), 0) / (totalCount.length - 1);
        options.totalValue = Math.sqrt(variance);
        break;
    }
  } else if (options.name == 'dayCountStdev') {
    switch (options.summaryProcess) {
      case 'start':
        // Initializing "totalValue" here
        totalDayCount = [];
        break;
      case 'calculate':
        // Modifying "totalValue" here
        totalDayCount.push(options.value);
        break;
      case 'finalize':
        // Assigning the final value to "totalValue" here
        const moyenne = totalDayCount.reduce((sum, value) => sum + value, 0) / totalDayCount.length;
        const variance =
          totalDayCount.reduce((sum, value) => sum + Math.pow(value - moyenne, 2), 0) / (totalDayCount.length - 1);
        options.totalValue = Math.sqrt(variance);
        break;
    }
  } else if (options.name == 'dayCountRange') {
    switch (options.summaryProcess) {
      case 'start':
        // Initializing "totalValue" here
        minDayCount = 999;
        maxDayCount = -999;
        break;
      case 'calculate':
        // Modifying "totalValue" here
        minDayCount = Math.min(minDayCount, options.value);
        maxDayCount = Math.max(maxDayCount, options.value);
        break;
      case 'finalize':
        // Assigning the final value to "totalValue" here
        options.totalValue = maxDayCount - minDayCount;
        break;
    }
  } else if (options.name == 'totalCountRange') {
    switch (options.summaryProcess) {
      case 'start':
        // Initializing "totalValue" here
        minTotalCount = 999;
        maxTotalCount = -999;
        break;
      case 'calculate':
        // Modifying "totalValue" here
        minTotalCount = Math.min(minTotalCount, options.value);
        maxTotalCount = Math.max(maxTotalCount, options.value);
        break;
      case 'finalize':
        // Assigning the final value to "totalValue" here
        options.totalValue = maxTotalCount - minTotalCount;
        break;
    }
    // Calculating "customSummary2"
  } else if (options.name == 'nightCountStdev') {
    switch (options.summaryProcess) {
      case 'start':
        // Initializing "totalValue" here
        totalNightCount = [];
        break;
      case 'calculate':
        // Modifying "totalValue" here
        totalNightCount.push(options.value);
        break;
      case 'finalize':
        // Assigning the final value to "totalValue" here
        const moyenne = totalNightCount.reduce((sum, value) => sum + value, 0) / totalNightCount.length;
        const variance =
          totalNightCount.reduce((sum, value) => sum + Math.pow(value - moyenne, 2), 0) / (totalNightCount.length - 1);
        options.totalValue = Math.sqrt(variance);
        break;
    }
  } else if (options.name == 'nightCountRange') {
    switch (options.summaryProcess) {
      case 'start':
        // Initializing "totalValue" here
        minNightCount = 999;
        maxNightCount = -999;
        break;
      case 'calculate':
        // Modifying "totalValue" here
        minNightCount = Math.min(minNightCount, options.value);
        maxNightCount = Math.max(maxNightCount, options.value);
        break;
      case 'finalize':
        // Assigning the final value to "totalValue" here
        options.totalValue = maxNightCount - minNightCount;
        break;
    }
  } else if (options.name == 'totalCountSwaps') {
    switch (options.summaryProcess) {
      case 'start':
        // Initializing "totalValue" here
        minTotalCountSwaps = 999;
        maxTotalCountSwaps = -999;
        deltaTotalTable = []
        break;
      case 'calculate':
        // Modifying "totalValue" here
        minTotalCountSwaps = Math.min(minTotalCountSwaps, options.value);
        maxTotalCountSwaps = Math.max(maxTotalCountSwaps, options.value);
        deltaTotalTable.push(options.value);
        break;
      case 'finalize':
        // Assigning the final value to "totalValue" here
        options.totalValue = countPossibleSwaps(minTotalCountSwaps, maxTotalCountSwaps, deltaTotalTable); //maxTotalCountSwaps - minTotalCountSwaps;
        break;
    }
  } else if (options.name == 'dayCountSwaps') {
    switch (options.summaryProcess) {
      case 'start':
        // Initializing "totalValue" here
        minDayCountSwap = 999;
        maxDayCountSwap = -999;
        deltaDayTable = []
        break;
      case 'calculate':
        // Modifying "totalValue" here
        minDayCountSwap = Math.min(minDayCountSwap, options.value);
        maxDayCountSwap = Math.max(maxDayCountSwap, options.value);
        deltaDayTable.push(options.value);
        break;
      case 'finalize':
        // Assigning the final value to "totalValue" here
        options.totalValue = countPossibleSwaps(minDayCountSwap, maxDayCountSwap, deltaDayTable);
        break;
    }
  } else if (options.name == 'nightCountSwaps') {
    switch (options.summaryProcess) {
      case 'start':
        // Initializing "totalValue" here
        minNightCountSwap = 999;
        maxNightCountSwap = -999;
        deltaTable = []
        break;
      case 'calculate':
        // Modifying "totalValue" here
        minNightCountSwap = Math.min(minNightCountSwap, options.value);
        maxNightCountSwap = Math.max(maxNightCountSwap, options.value);
        deltaTable.push(options.value);
        break;
      case 'finalize':
        // Assigning the final value to "totalValue" here
        options.totalValue = countPossibleSwaps(minNightCountSwap, maxNightCountSwap, deltaTable);
        break;
    }
  } else if (options.name == 'saturdaySwaps') {
    switch (options.summaryProcess) {
      case 'start':
        // Initializing "totalValue" here
        minSaturdaySwap = 999;
        maxSaturdaySwap = -999;
        saturdayTable = []
        break;
      case 'calculate':
        // Modifying "totalValue" here
        minSaturdaySwap = Math.min(minSaturdaySwap, options.value);
        maxSaturdaySwap = Math.max(maxSaturdaySwap, options.value);
        saturdayTable.push(options.value);
        break;
      case 'finalize':
        // Assigning the final value to "totalValue" here
        options.totalValue = countPossibleSwaps(minSaturdaySwap, maxSaturdaySwap, saturdayTable);
        break;
    }
  } else if (options.name == 'sundaySwaps') {
    switch (options.summaryProcess) {
      case 'start':
        // Initializing "totalValue" here
        minSundaySwap = 999;
        maxSundaySwap = -999;
        sundayTable = []
        break;
      case 'calculate':
        // Modifying "totalValue" here
        minSundaySwap = Math.min(minSundaySwap, options.value);
        maxSundaySwap = Math.max(maxSundaySwap, options.value);
        sundayTable.push(options.value);
        break;
      case 'finalize':
        // Assigning the final value to "totalValue" here
        options.totalValue = countPossibleSwaps(minSundaySwap, maxSundaySwap, sundayTable);
        break;
    }
  } else if (options.name == 'currSaturdaysStdev') {
    switch (options.summaryProcess) {
      case 'start':
        // Initializing "totalValue" here
        totalSaturdayCount = [];
        break;
      case 'calculate':
        // Modifying "totalValue" here
        totalSaturdayCount.push(options.value);
        break;
      case 'finalize':
        // Assigning the final value to "totalValue" here
        const moyenne = totalSaturdayCount.reduce((sum, value) => sum + value, 0) / totalSaturdayCount.length;
        const variance =
          totalSaturdayCount.reduce((sum, value) => sum + Math.pow(value - moyenne, 2), 0) /
          (totalSaturdayCount.length - 1);
        options.totalValue = Math.sqrt(variance);
        break;
    }
  } else if (options.name == 'saturdayCountRange') {
    switch (options.summaryProcess) {
      case 'start':
        // Initializing "totalValue" here
        minSACount = 999;
        maxSACount = -999;
        break;
      case 'calculate':
        // Modifying "totalValue" here
        minSACount = Math.min(minSACount, options.value);
        maxSACount = Math.max(maxSACount, options.value);
        break;
      case 'finalize':
        // Assigning the final value to "totalValue" here
        options.totalValue = maxSACount - minSACount;
        break;
    }
  } else if (options.name == 'currSundaysStdev') {
    switch (options.summaryProcess) {
      case 'start':
        // Initializing "totalValue" here
        totalSundayCount = [];
        break;
      case 'calculate':
        // Modifying "totalValue" here
        totalSundayCount.push(options.value);
        break;
      case 'finalize':
        // Assigning the final value to "totalValue" here
        const moyenne = totalSundayCount.reduce((sum, value) => sum + value, 0) / totalSundayCount.length;
        const variance =
          totalSundayCount.reduce((sum, value) => sum + Math.pow(value - moyenne, 2), 0) /
          (totalSundayCount.length - 1);
        options.totalValue = Math.sqrt(variance);
        break;
    }
  } else if (options.name == 'sundayCountRange') {
    switch (options.summaryProcess) {
      case 'start':
        // Initializing "totalValue" here
        minSUCount = 999;
        maxSUCount = -999;
        break;
      case 'calculate':
        // Modifying "totalValue" here
        minSUCount = Math.min(minSUCount, options.value);
        maxSUCount = Math.max(maxSUCount, options.value);
        break;
      case 'finalize':
        // Assigning the final value to "totalValue" here
        options.totalValue = maxSUCount - minSUCount;
        break;
    }
  } else if (options.name == 'suStdev') {
    switch (options.summaryProcess) {
      case 'start':
        // Initializing "totalValue" here
        suStdevCount = [];
        break;
      case 'calculate':
        // Modifying "totalValue" here
        suStdevCount.push(options.value);
        break;
      case 'finalize':
        // Assigning the final value to "totalValue" here
        const moyenne = suStdevCount.reduce((sum, value) => sum + value, 0) / suStdevCount.length;
        const variance =
          suStdevCount.reduce((sum, value) => sum + Math.pow(value - moyenne, 2), 0) / (suStdevCount.length - 1);
        options.totalValue = Math.sqrt(variance);
        break;
    }
  } else if (options.name == 'saStdev') {
    switch (options.summaryProcess) {
      case 'start':
        // Initializing "totalValue" here
        saStdevCount = [];
        break;
      case 'calculate':
        // Modifying "totalValue" here
        saStdevCount.push(options.value);
        break;
      case 'finalize':
        // Assigning the final value to "totalValue" here
        const moyenne = saStdevCount.reduce((sum, value) => sum + value, 0) / saStdevCount.length;
        const variance =
          saStdevCount.reduce((sum, value) => sum + Math.pow(value - moyenne, 2), 0) / (saStdevCount.length - 1);
        options.totalValue = Math.sqrt(variance);
        break;
    }
  } else if (options.name == 'bkhStdevGrp') {
    switch (options.summaryProcess) {
      case 'start':
        // Initializing "totalValue" here
        grpBkhStdevCount = [];
        break;
      case 'calculate':
        // Modifying "totalValue" here
        grpBkhStdevCount.push(options.value);
        break;
      case 'finalize':
        // Assigning the final value to "totalValue" here
        const moyenne = grpBkhStdevCount.reduce((sum, value) => sum + value, 0) / grpBkhStdevCount.length;
        const variance =
          grpBkhStdevCount.reduce((sum, value) => sum + Math.pow(value - moyenne, 2), 0) /
          (grpBkhStdevCount.length - 1);
        options.totalValue = Math.sqrt(variance);
        break;
    }
  } else if (options.name == 'bkhCountRange') {
    switch (options.summaryProcess) {
      case 'start':
        // Initializing "totalValue" here
        minBkhCount = 999;
        maxBkhCount = -999;
        break;
      case 'calculate':
        // Modifying "totalValue" here
        minBkhCount = Math.min(minBkhCount, options.value);
        maxBkhCount = Math.max(maxBkhCount, options.value);
        break;
      case 'finalize':
        // Assigning the final value to "totalValue" here
        options.totalValue = maxBkhCount - minBkhCount;
        break;
    }
  } else if (options.name == 'yearBkhStdevGrp') {
    switch (options.summaryProcess) {
      case 'start':
        // Initializing "totalValue" here
        grpYearBkhStdevCount = [];
        break;
      case 'calculate':
        // Modifying "totalValue" here
        grpYearBkhStdevCount.push(options.value);
        break;
      case 'finalize':
        // Assigning the final value to "totalValue" here
        const moyenne = grpYearBkhStdevCount.reduce((sum, value) => sum + value, 0) / grpYearBkhStdevCount.length;
        const variance =
          grpYearBkhStdevCount.reduce((sum, value) => sum + Math.pow(value - moyenne, 2), 0) /
          (grpYearBkhStdevCount.length - 1);
        options.totalValue = Math.sqrt(variance);
        break;
    }
  } else if (options.name == 'bkhStdev') {
    switch (options.summaryProcess) {
      case 'start':
        // Initializing "totalValue" here
        bkhStdevCount = [];
        break;
      case 'calculate':
        // Modifying "totalValue" here
        bkhStdevCount.push(options.value);
        break;
      case 'finalize':
        // Assigning the final value to "totalValue" here
        const moyenne = bkhStdevCount.reduce((sum, value) => sum + value, 0) / bkhStdevCount.length;
        const variance =
          bkhStdevCount.reduce((sum, value) => sum + Math.pow(value - moyenne, 2), 0) / (bkhStdevCount.length - 1);
        options.totalValue = Math.sqrt(variance);
        break;
    }
  } else if (options.name == 'yearBkhStdev') {
    switch (options.summaryProcess) {
      case 'start':
        // Initializing "totalValue" here
        yearBkhStdevCount = [];
        break;
      case 'calculate':
        // Modifying "totalValue" here
        yearBkhStdevCount.push(options.value);
        break;
      case 'finalize':
        // Assigning the final value to "totalValue" here
        const moyenne = yearBkhStdevCount.reduce((sum, value) => sum + value, 0) / yearBkhStdevCount.length;
        const variance =
          yearBkhStdevCount.reduce((sum, value) => sum + Math.pow(value - moyenne, 2), 0) /
          (yearBkhStdevCount.length - 1);
        options.totalValue = Math.sqrt(variance);
        break;
    }
  } else if (options.name == 'ecartStdev') {
    switch (options.summaryProcess) {
      case 'start':
        // Initializing "totalValue" here
        ecarts = [];
        break;
      case 'calculate':
        // Modifying "totalValue" here
        ecarts.push(options.value);
        break;
      case 'finalize':
        // Assigning the final value to "totalValue" here
        const moyenne = ecarts.reduce((sum, value) => sum + value, 0) / ecarts.length;
        const variance = ecarts.reduce((sum, value) => sum + Math.pow(value - moyenne, 2), 0) / (ecarts.length - 1);
        options.totalValue = Math.sqrt(variance);
        break;
    }
  } else if (options.name == 'ecartStdevTot') {
    switch (options.summaryProcess) {
      case 'start':
        // Initializing "totalValue" here
        ecarts = [];
        break;
      case 'calculate':
        // Modifying "totalValue" here
        ecarts.push(options.value);
        break;
      case 'finalize':
        // Assigning the final value to "totalValue" here
        const moyenne = ecarts.reduce((sum, value) => sum + value, 0) / ecarts.length;
        const variance = ecarts.reduce((sum, value) => sum + Math.pow(value - moyenne, 2), 0) / (ecarts.length - 1);
        options.totalValue = Math.sqrt(variance);
        break;
    }
  } else if (options.name == 'grpTarget') {
    switch (options.summaryProcess) {
      case 'start':
        // Initializing "totalValue" here
        grpTarget = 0;
        break;
      case 'calculate':
        // Modifying "totalValue" here
        grpTarget = options.value;
        break;
      case 'finalize':
        // Assigning the final value to "totalValue" here
        options.totalValue = grpTarget;
        break;
    }
  } else if (options.name == 'grpTargetDay') {
    switch (options.summaryProcess) {
      case 'start':
        // Initializing "totalValue" here
        grpTargetDay = 0;
        break;
      case 'calculate':
        // Modifying "totalValue" here
        grpTargetDay = options.value;
        break;
      case 'finalize':
        // Assigning the final value to "totalValue" here
        options.totalValue = grpTargetDay;
        break;
    }
  } else if (options.name == 'grpTargetNight') {
    switch (options.summaryProcess) {
      case 'start':
        // Initializing "totalValue" here
        grpTargetNight = 0;
        break;
      case 'calculate':
        // Modifying "totalValue" here
        grpTargetNight = options.value;
        break;
      case 'finalize':
        // Assigning the final value to "totalValue" here
        options.totalValue = grpTargetNight;
        break;
    }
  }
};

const countPossibleSwaps = (min, max, table) => {
  let count = 0;
  let sorted = table.sort((n1, n2) => n1 - n2);
  //sort table
  while (max - min > 1) {
    sorted[sorted.length - 1] -= 1;
    sorted[0] += 1;
    // take one from table(max) 
    // give it to table(min)
    // sort table, get min and max
    sorted = sorted.sort((n1, n2) => n1 - n2);
    max = sorted[sorted.length - 1];
    min = sorted[0];
    // count 1
    count += 1;
  }
  return count;
};

let ndbbpCount: number;
let dispCount: number;
let bpCount: number;
let prefOffCount: number;

const calculateCustomSummarySpecialIssues = (options) => {
  // Calculating "customSummary1"
  if (options.name == 'ndbbpTot') {
    switch (options.summaryProcess) {
      case 'start':
        // Initializing "totalValue" here
        ndbbpCount = 0;
        break;
      case 'calculate':
        // Modifying "totalValue" here
        ndbbpCount += options.value == 'X' ? 1 : 0;
        break;
      case 'finalize':
        // Assigning the final value to "totalValue" here
        options.totalValue = ndbbpCount;
        break;
    }
  }

  if (options.name == 'dispTot') {
    switch (options.summaryProcess) {
      case 'start':
        // Initializing "totalValue" here
        dispCount = 0;
        break;
      case 'calculate':
        // Modifying "totalValue" here
        dispCount += options.value == 'X' ? 1 : 0;
        break;
      case 'finalize':
        // Assigning the final value to "totalValue" here
        options.totalValue = dispCount;
        break;
    }
  }

  if (options.name == 'bpTot') {
    switch (options.summaryProcess) {
      case 'start':
        // Initializing "totalValue" here
        bpCount = 0;
        break;
      case 'calculate':
        // Modifying "totalValue" here
        bpCount += options.value == 'X' ? 1 : 0;
        break;
      case 'finalize':
        // Assigning the final value to "totalValue" here
        options.totalValue = bpCount;
        break;
    }
  }

  if (options.name == 'prefOffTot') {
    switch (options.summaryProcess) {
      case 'start':
        // Initializing "totalValue" here
        prefOffCount = 0;
        break;
      case 'calculate':
        // Modifying "totalValue" here
        prefOffCount += options.value == 'X' ? 1 : 0;
        break;
      case 'finalize':
        // Assigning the final value to "totalValue" here
        options.totalValue = prefOffCount;
        break;
    }
  }
};

@inject(
  'PharmacyStore',
  'PlannerStore',
  'ApplicationStore',
  'UiStore',
  'AuthenticationStore',
  'SecretariatStore',
  'ModalStore',
)
@inject('ScoreStore', 'MatchStore', 'IndictmentStore')
@observer
class AnalysisPage extends React.Component<AnalysisPageProps & WithTranslateProps, AnalysisPageState> {
  startDate: Date;
  endDate: Date;
  selectedStartRuleTransgressionDate: Date;
  selectedEndRuleTransgressionDate: Date;
  prevStartDate: Date;
  prevEndDate: Date;

  calculateCustomSummaryGroupsDaily = (options) => {
    if (options.name === 'nbrJN0') {
      switch (options.summaryProcess) {
        case 'start':
          // Initializing "totalValue" here
          nbrJN0 = 0;
          break;
        case 'calculate':
          if (options.value == 0) {
            nbrJN0 += 1;
          }
          break;
        case 'finalize':
          options.totalValue = nbrJN0;
          break;
      }
    }
    if (options.name === 'nbrJN1plus') {
      switch (options.summaryProcess) {
        case 'start':
          // Initializing "totalValue" here
          nbrJN1plus = 0;
          break;
        case 'calculate':
          if (options.value > 1) {
            nbrJN1plus += 1;
          }
          break;
        case 'finalize':
          options.totalValue = nbrJN1plus;
          break;
      }
    }
  };

  calculateCustomSummaryGaps = (options) => {
    if (options.name === '%Below') {
      switch (options.summaryProcess) {
        case 'start':
          // Initializing "totalValue" here
          phBelow = [];
          phBelowCount = [];
          gapBelowCount = 0;
          break;
        case 'calculate':
          if (options.value.ecart < this.state.lowerGapLimit && !phBelow.includes(options.value.apbNumber)) {
            phBelow.push(options.value.apbNumber);
          }
          if (!phBelowCount.includes(options.value.apbNumber)) {
            phBelowCount.push(options.value.apbNumber);
          }
          if (options.value.ecart < this.state.lowerGapLimit) {
            gapBelowCount += 1;
          }
          break;
        case 'finalize':
          options.totalValue = gapBelowCount; //phBelow.length;
          break;
      }
    } else if (options.name === '%Above') {
      switch (options.summaryProcess) {
        case 'start':
          // Initializing "totalValue" here
          phAbove = [];
          phAboveCount = [];
          gapAboveCount = 0;
          break;
        case 'calculate':
          if (options.value.ecart > this.state.upperGapLimit && !phAbove.includes(options.value.apbNumber)) {
            phAbove.push(options.value.apbNumber);
          }
          if (!phAboveCount.includes(options.value.apbNumber)) {
            phAboveCount.push(options.value.apbNumber);
          }
          if (options.value.ecart > this.state.upperGapLimit) {
            gapAboveCount += 1;
          }
          break;
        case 'finalize':
          options.totalValue = gapAboveCount; //phAbove.length;
          break;
      }
    }
  };

  getSpreadingVisibleRows = () => {
    if (this.spreadingDataGridRef.current) {
      const instance = this.spreadingDataGridRef.current.instance;
      const visibleRows = instance.getVisibleRows();
      console.log(visibleRows.length);
      return visibleRows.length;
    } else return -1;
  };

  private spreadingDataGridRef = React.createRef<DataGrid>();

  getVisibleRows = () => {
    if (this.gapDataGridRef.current) {
      const instance = this.gapDataGridRef.current.instance;
      const visibleRows = instance.getVisibleRows();
      console.log(visibleRows.length);
      return visibleRows.length;
    } else return -1;
  };

  private gapDataGridRef = React.createRef<DataGrid>();

  constructor(props: any) {
    super(props);
    //this.gapDataGridRef = React.createRef();
    if (this.props.UiStore!.diagnosticPageStartDate == null) {
      var now = new Date();
      var semesterYear = now.getFullYear();
      this.setState({ semesterYear: semesterYear});
      this.startDate = getSemesterStartDate(now); // getNextStartDate();
      this.endDate = getSemesterEndDate(now);
      this.setStartDate(this.startDate); // getNextEndDate();
      this.setEndDate(this.endDate); // getNextEndDate();
    } else {
      this.startDate = this.props.UiStore!.diagnosticPageStartDate; //getSemesterStartDate(this.props.UiStore!.diagnosticPageStartDate); // getNextStartDate();
      this.endDate = this.props.UiStore!.diagnosticPageEndDate!; //getSemesterEndDate(this.props.UiStore!.diagnosticPageEndDate);
      this.selectedStartRuleTransgressionDate = this.startDate; // getNextEndDate();
      this.selectedEndRuleTransgressionDate = this.endDate; // getNextEndDate();
    }
    this.state = {
      isLoading: false,
      saving: false,
      isMounted: false,
      planningId: -1,
      selectedPlanningId: {
        label: this.props.UiStore!.diagnosticPageCurrentPlanningId,
        value: this.props.UiStore!.diagnosticPageCurrentPlanningId,
      },
      selectedTabId: TAB.PROBLEMS,
      selectedSubTabId: SUBTAB.TOOCLOSEDUTIES,
      selectedDutyCountSubTabId: SUBSUBTAB.DUTYCOUNTCHANGESGRID,
      selectedUnbalancedCountSubTabId: SUBSUBTAB.UNBALANCEDNEIGHBORSGRAPHS,
      startDate: this.startDate,
      endDate: this.endDate,
      selectedStartRuleTransgressionDate: this.selectedStartRuleTransgressionDate,
      selectedEndRuleTransgressionDate: this.selectedEndRuleTransgressionDate,
      prevStartDate: this.prevStartDate,
      prevEndDate: this.prevEndDate,
      ruleFilter: '',
      selectedDate: undefined,
      offset: this.props.UiStore!.diagnosticOffset,
      savedPlanningId: this.props.UiStore!.diagnosticPageCurrentPlanningId,
      savedPrevPlanningId: this.props.UiStore!.diagnosticPagePrevPlanningId,
      status: this.props.UiStore!.diagnosticSearchStatus,
      distribution: new Map(),
      lowerGapLimit: this.props.UiStore!.lowerGapLimit ? this.props.UiStore!.lowerGapLimit! : 4,
      upperGapLimit: this.props.UiStore!.upperGapLimit ? this.props.UiStore!.upperGapLimit! : 50,
      nbrPharmacies: 0,
      nbrPharmaciesWithGapBelow: 0,
      nbrPharmaciesWithGapAbove: 0,
      suStdev: 0,
      saStdev: 0,
      nbrNBeforeBP: 0,
      nbrDutiesOnDisp: 0,
      nbrDutiesOnBP: 0,
      nbrDutiesOnPrefOff: 0,
      nbrJN0: 0,
      nbrJN1plus: 0,
      semesterYear: new Date().getFullYear(),
      runFilterText: '',
      lowerDistanceLimit: this.props.UiStore!.lowerDistanceLimit ? this.props.UiStore!.lowerDistanceLimit! : 4,
      filteredData: []
    };
    this.onGapOptionChanged = this.onGapOptionChanged.bind(this);
    this.onDutyCountOptionChanged = this.onDutyCountOptionChanged.bind(this);
  }

  _isMounted = false;

  async componentDidMount() {
    this._isMounted = true;
    this._isMounted && this.setState({ isMounted: true });

    const { UiStore } = this.props;

    this._isMounted &&
      this.setState({
        selectedTabId: UiStore!.diagnosticPageActiveTab == '' ? TAB.PROBLEMS : UiStore!.diagnosticPageActiveTab,
        selectedSubTabId:
          UiStore!.diagnosticPageActiveSubTab == '' ? SUBTAB.TOOCLOSEDUTIES : UiStore!.diagnosticPageActiveSubTab,
        selectedDutyCountSubTabId: SUBSUBTAB.DUTYCOUNTCHANGESGRID,
        selectedUnbalancedCountSubTabId: SUBSUBTAB.UNBALANCEDNEIGHBORSGRAPHS,
        semesterYear: UiStore!.diagnosticPageCurrentSemesterYear,
      });

    // Tabs inside another Tabs messes up with the container height, resulting in a confusing scrollbar. Fix it for this page (try/catch because parentElement might be inaccessible)
    try {
      if (this.state.selectedTabId == TAB.PROBLEMS) {
        document.getElementsByClassName('bp3-tabs')[0].parentElement!.parentElement!.parentElement!.style!.overflow =
          'hidden';
      }
    } catch (error) { }
    this.props.UiStore!.afterAttach();
  }

  async componentWillUnmount() {
    this._isMounted && this.setState({ isMounted: false });
    this._isMounted = false;
  }

  async componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.notReadyYet()) return;
    const { ScoreStore, MatchStore, IndictmentStore, PlannerStore } = this.props;
    if (
      this.state.selectedTabId === TAB.SCORES ||
      this.state.selectedTabId === TAB.MATCHES ||
      this.state.selectedTabId === TAB.TRANSGRESSIONS
    ) {
      if (this.state.planningId === -1 || this.state.planningId !== prevState.planningId) {
        if (!this.state.isMounted) return;
        this._isMounted && this.setState({ isLoading: true });
        await ScoreStore!.getScores({ count: 9999 });
        if (!this.state.isMounted) return;
        let planningId = this.state.planningId;
        if (planningId === -1) {
          planningId = Math.max(
            ...ScoreStore!.dataList.map((o) => {
              return o.scoreId;
            }),
          );
        }
        if (planningId > 0) {
          await Promise.all([
            MatchStore!.getMatches({ PlanningId: planningId }),
            MatchStore!.getComparedMatches({ PlanningId: planningId }),
            IndictmentStore!.getIndictments({ PlanningId: planningId }),
            //// IndictmentStore!.getIndictmentsCount(planningId),
            //MatchStore!.GetGroupTransgressions(this.state.planningId, '*', {}),
            {
              /*MatchStore!.GetGroupTransgressionsByDate(
              this.state.startDate,
              this.state.endDate,
              this.state.planningId,
              '*',
              { secretariatId: this.getSecretariatId() },
            ),
            MatchStore!.GetGroupDutyCountsByDate(
              this.state.startDate,
              this.state.endDate,
              this.state.planningId,
              '*',
              { secretariatId: this.getSecretariatId() },
            ),*/
            },
          ]);

          if (!this.state.isMounted) return;
          this._isMounted && this.setState({ planningId });
        }

        this._isMounted && this.setState({ isLoading: false });
      }
    } else if (this.state.planningId !== -1 && this.state.selectedTabId == TAB.RULES) {
      await PlannerStore!.getRules({ PlanningId: this.state.planningId });
    }
  }

  GetTooCloseDutiesColumns = [
    {
      headerName: this.props.translate(TLCode.TOO_CLOSE_DUTIES_PHARMACY),
      maxWidth: 80,
      minWidth: 70,
      field: 'apbNumber',
      sortingOrder: ['asc', 'desc'],
      resizable: false,
    },
    {
      headerName: this.props.translate(TLCode.TOO_CLOSE_DUTIES_PHARMACY_GROUP),
      maxWidth: 90,
      width: 45,
      minWidth: 60,
      field: 'group',
      sortingOrder: ['asc', 'desc'],
      resizable: false,
    },
    {
      headerName: this.props.translate(TLCode.TOO_CLOSE_DUTIES_PHARMACY_NAME),
      maxWidth: 600,
      width: 600,
      minWidth: 250,
      field: 'pharmacyName',
      sortingOrder: ['asc', 'desc'],
    },
    {
      headerName: this.props.translate(TLCode.TOO_CLOSE_DUTIES_DATE1),
      maxWidth: 160,
      minWidth: 90,
      field: 'date1',
      cellRenderer: dateCellRenderer,
      sortingOrder: ['asc', 'desc'],
    },
    {
      headerName: this.props.translate(TLCode.TOO_CLOSE_DUTIES_DATE2),
      maxWidth: 160,
      minWidth: 70,
      // width: 30,
      field: 'date2',
      cellRenderer: dateCellRenderer,
      sortingOrder: ['asc', 'desc'],
    },
    {
      headerName: this.props.translate(TLCode.TOO_CLOSE_DUTIES_ECART),
      // maxWidth: 160,
      minWidth: 50,
      // width: 30,
      field: 'ecart',
      sortingOrder: ['asc', 'desc'],
    },
    {
      headerName: this.props.translate(TLCode.TOO_CLOSE_DUTIES_TOTAL),
      // maxWidth: 160,
      minWidth: 50,
      // width: 30,
      field: 'total',
      sortingOrder: ['asc', 'desc'],
    },
  ];

  GetAbnormalDutyCountsColumns = [
    {
      headerName: this.props.translate(TLCode.TOO_CLOSE_DUTIES_PHARMACY),
      maxWidth: 80,
      minWidth: 70,
      field: 'apbNumber',
      sortingOrder: ['asc', 'desc'],
      resizable: false,
    },
    {
      headerName: this.props.translate(TLCode.TOO_CLOSE_DUTIES_PHARMACY_GROUP),
      width: 45,
      field: 'group',
      sortingOrder: ['asc', 'desc'],
      resizable: false,
    },
    {
      headerName: this.props.translate(TLCode.TOO_CLOSE_DUTIES_PHARMACY_NAME),
      field: 'pharmacyName',
      sortingOrder: ['asc', 'desc'],
    },
    {
      headerName: this.props.translate(TLCode.ABNORMAL_DUTY_COUNTS_TARGET_COUNT),
      width: 40,
      field: 'targetDutyCount',
    },
    {
      headerName: this.props.translate(TLCode.ABNORMAL_DUTY_COUNTS_COUNT),
      width: 40,
      field: 'dayDutyCount',
      sortingOrder: ['asc', 'desc'],
    },
    {
      headerName: 'delta',
      width: 30,
      valueGetter:
        'Number.isNaN(getValue("dayDutyCount")-getValue("targetDayDutyCount")) ? 0:getValue("dayDutyCount")-getValue("targetDutyCount")',
      sortingOrder: ['asc', 'desc'],
    },
    {
      headerName: this.props.translate(TLCode.ABNORMAL_DUTY_COUNTS_DAY_TARGET_COUNT),
      width: 40,
      field: 'targetDayDutyCount',
    },
    {
      headerName: this.props.translate(TLCode.ABNORMAL_DUTY_COUNTS_DAY_COUNT),
      width: 40,
      valueGetter:
        'Number.isNaN(getValue("dayDutyCount")-getValue("nightDutyCount")) ? 0:getValue("dayDutyCount")-getValue("nightDutyCount")',
      sortingOrder: ['asc', 'desc'],
    },
    {
      headerName: 'delta J',
      width: 40,
      valueGetter:
        'Number.isNaN(getValue("dayDutyCount")-getValue("nightDutyCount")) ? 0:getValue("dayDutyCount")-getValue("nightDutyCount") - getValue("targetDayDutyCount")',
      sortingOrder: ['asc', 'desc'],
    },
    {
      headerName: this.props.translate(TLCode.ABNORMAL_DUTY_COUNTS_NIGHT_TARGET_COUNT),
      width: 45,
      field: 'targetNightDutyCount',
    },
    {
      headerName: this.props.translate(TLCode.ABNORMAL_DUTY_COUNTS_NIGHT_COUNT),
      width: 45,
      field: 'nightDutyCount',
      sortingOrder: ['asc', 'desc'],
    },
    {
      headerName: 'delta N',
      width: 40,
      valueGetter:
        'Number.isNaN(getValue("nightDutyCount")-getValue("targetNightDutyCount")) ? 0:getValue("nightDutyCount")-getValue("targetNightDutyCount")',
      sortingOrder: ['asc', 'desc'],
    },
  ];

  GetGroupTransgressionsColumns = [
    {
      headerName: this.props.translate(TLCode.SPECIALISSUES_DATE),
      width: 125,
      field: 'date',
      cellRenderer: dateCellRenderer,
      sort: 'asc',
      sortedAt: 0,
      resizable: false,
    },
    {
      headerName: this.props.translate(TLCode.TOO_CLOSE_DUTIES_PHARMACY_GROUP),
      width: 300,
      field: 'group',
      sort: 'asc',
      sortedAt: 1,
      resizable: false,
    },
  ];

  GetGroupTransgressionsByDateColumns = [
    {
      headerName: this.props.translate(TLCode.SPECIALISSUES_DATE),
      width: 125,
      field: 'date',
      cellRenderer: dateCellRenderer,
      sort: 'asc',
      sortedAt: 0,
      resizable: false,
    },
    {
      headerName: this.props.translate(TLCode.TOO_CLOSE_DUTIES_PHARMACY_GROUP),
      width: 100,
      field: 'group',
      sort: 'asc',
      sortedAt: 1,
      resizable: false,
    },
  ];

  GroupRuleTransgressionColumns = [
    {
      headerName: this.props.translate(TLCode.SPECIALISSUES_DATE),
      width: 400,
      field: 'msg',
      sort: 'asc',
      sortedAt: 0,
      resizable: false,
    },
  ];

  GetUnbalancedNeighborsColumns = [
    {
      headerName: this.props.translate(TLCode.UNBALANCED_NEIGHBORS_PHARMACY_APB),
      width: 30,
      field: 'apbNumber',
      sortingOrder: ['asc', 'desc'],
    },
    {
      headerName: this.props.translate(TLCode.TOO_CLOSE_DUTIES_PHARMACY_GROUP),
      width: 30,
      field: 'group',
      sortingOrder: ['asc', 'desc'],
      resizable: false,
    },
    {
      headerName: this.props.translate(TLCode.UNBALANCED_NEIGHBORS_PHARMACY_NAME),
      field: 'pharmacyName',
      sortingOrder: ['asc', 'desc'],
      resizable: true,
    },
    {
      headerName: this.props.translate(TLCode.UNBALANCED_NEIGHBORS_FRIDAYS),
      width: 30,
      field: 'fridayCnt',
      sortingOrder: ['asc', 'desc'],
      headerTooltip: this.props.translate(TLCode.UNBALANCED_NEIGHBORS_FRIDAYS_TOOLTIP),
      filter: false,
    },
    {
      headerName: this.props.translate(TLCode.UNBALANCED_NEIGHBORS_FRIDAY_STATS),
      width: 25,
      field: 'fridays',
      sortingOrder: ['asc', 'desc'],
      cellStyle: (params) => params.data.fridayOk,
      comparator: balanceComparator,
      headerTooltip: this.props.translate(TLCode.UNBALANCED_NEIGHBORS_FRIDAYS_STAT_TOOLTIP),
      filter: false,
      hide: true,
    },
    {
      headerName: this.props.translate(TLCode.UNBALANCED_NEIGHBORS_SATURDAYS),
      width: 30,
      field: 'saturdayCnt',
      sortingOrder: ['asc', 'desc'],
      headerTooltip: this.props.translate(TLCode.UNBALANCED_NEIGHBORS_SATURDAYS_TOOLTIP),
      filter: false,
    },
    {
      headerName: this.props.translate(TLCode.UNBALANCED_NEIGHBORS_SATURDAY_STATS),
      width: 25,
      field: 'saturdays',
      sortingOrder: ['asc', 'desc'],
      cellStyle: (params) => params.data.saturdayOk,
      comparator: balanceComparator,
      headerTooltip: this.props.translate(TLCode.UNBALANCED_NEIGHBORS_SATURDAYS_TOOLTIP),
      filter: false,
      hide: true,
    },
    {
      headerName: this.props.translate(TLCode.UNBALANCED_NEIGHBORS_SUNDAYS),
      width: 35,
      field: 'sundayCnt',
      sortingOrder: ['asc', 'desc'],
      headerTooltip: this.props.translate(TLCode.UNBALANCED_NEIGHBORS_SUNDAYS_TOOLTIP),
      filter: false,
    },
    {
      headerName: this.props.translate(TLCode.UNBALANCED_NEIGHBORS_SUNDAY_STATS),
      width: 25,
      field: 'sundays',
      sortingOrder: ['asc', 'desc'],
      cellStyle: (params) => params.data.sundayOk,
      comparator: balanceComparator,
      headerTooltip: this.props.translate(TLCode.UNBALANCED_NEIGHBORS_SUNDAYS_TOOLTIP),
      filter: false,
      hide: true,
    },
    {
      headerName: this.props.translate(TLCode.UNBALANCED_NEIGHBORS_YEAR_SUNDAYS),
      width: 40,
      field: 'yearSundays',
      sortingOrder: ['asc', 'desc'],
      headerTooltip: this.props.translate(TLCode.UNBALANCED_NEIGHBORS_YEAR_SUNDAYS_TOOLTIP),
      filter: false,
    },
    {
      headerName: this.props.translate(TLCode.UNBALANCED_NEIGHBORS_HOLIDAYS),
      width: 25,
      field: 'holidayCnt',
      sortingOrder: ['asc', 'desc'],
      headerTooltip: this.props.translate(TLCode.UNBALANCED_NEIGHBORS_HOLIDAYS_TOOLTIP),
      filter: false,
    },
    {
      headerName: this.props.translate(TLCode.UNBALANCED_NEIGHBORS_YEAR_HOLIDAYS),
      width: 30,
      field: 'yearHolidayCnt',
      sortingOrder: ['asc', 'desc'],
      headerTooltip: 'Year', // this.props.translate(TLCode.UNBALANCED_NEIGHBORS_HOLIDAYS_TOOLTIP),
      filter: false,
    },
    {
      headerName: this.props.translate(TLCode.UNBALANCED_NEIGHBORS_HOLIDAY_STATS),
      width: 25,
      field: 'holidays',
      sortingOrder: ['asc', 'desc'],
      cellStyle: (params) => params.data.holidayOk,
      comparator: balanceComparator,
      headerTooltip: this.props.translate(TLCode.UNBALANCED_NEIGHBORS_HOLIDAYS_TOOLTIP),
      filter: false,
      hide: true,
    },
    {
      headerName: this.props.translate(TLCode.UNBALANCED_NEIGHBORS_NIGHTS),
      width: 25,
      field: 'nightCnt',
      sortingOrder: ['asc', 'desc'],
      headerTooltip: this.props.translate(TLCode.UNBALANCED_NEIGHBORS_NIGHTS_TOOLTIP),
      filter: false,
    },
    {
      headerName: this.props.translate(TLCode.UNBALANCED_NEIGHBORS_NIGHT_STATS),
      width: 25,
      field: 'nights',
      sortingOrder: ['asc', 'desc'],
      cellStyle: (params) => params.data.nightOk,
      comparator: balanceComparator,
      headerTooltip: this.props.translate(TLCode.UNBALANCED_NEIGHBORS_NIGHTS_TOOLTIP),
      filter: false,
      hide: true,
    },
    {
      headerName: this.props.translate(TLCode.UNBALANCED_NEIGHBORS_DAYS),
      width: 25,
      valueGetter:
        'Number.isNaN(getValue("totalCnt")-getValue("nightCnt"))?null:getValue("totalCnt")-getValue("nightCnt")',
      sortingOrder: ['asc', 'desc'],
      headerTooltip: this.props.translate(TLCode.UNBALANCED_NEIGHBORS_DAYS_TOOLTIP),
      filter: false,
    },
    {
      headerName: this.props.translate(TLCode.UNBALANCED_NEIGHBORS_TOTAL),
      width: 25,
      field: 'totalCnt',
      sortingOrder: ['asc', 'desc'],
      headerTooltip: this.props.translate(TLCode.UNBALANCED_NEIGHBORS_TOTAL_TOOLTIP),
      filter: false,
    },
    {
      headerName: this.props.translate(TLCode.UNBALANCED_NEIGHBORS_TOTAL_STATS),
      width: 25,
      field: 'total',
      sortingOrder: ['asc', 'desc'],
      cellStyle: (params) => params.data.totalOk,
      comparator: balanceComparator,
      headerTooltip: this.props.translate(TLCode.UNBALANCED_NEIGHBORS_TOTAL_STAT_TOOLTIP),
      filter: false,
      hide: true,
    },
  ];

  redGreen(delta) {
    if (delta <= 2) {
      return { color: '#008517', backgroundColor: '#d2fad9' };
    } else {
      return { color: '#ff2000', backgroundColor: '#f7dbd7' };
    }
  }

  // scoreColumnDefs = [
  //   {
  //     headerName: this.props.translate(TLCode.ANALYSIS_SCORES_TIMESTAMP),
  //     width: 100,
  //     field: 'createdOn',
  //     cellRenderer: renderGridDateTimeWithDetails,
  //   },
  //   { headerName: this.props.translate(TLCode.ANALYSIS_SCORES_RUNID), width: 45, field: 'runId' },
  //   { headerName: this.props.translate(TLCode.ANALYSIS_SCORES_PLANNINGID), width: 50, field: 'planningId' },
  //   {
  //     headerName: this.props.translate(TLCode.ANALYSIS_SCORES_DURATION),
  //     width: 60,
  //     field: 'calcStart',
  //     valueGetter: (params) => {
  //       // console.log(" " + params.data.createdOn + " " + params.data.calcStart);
  //       // console.log(new Date(params.data.createdOn).getTime() - new Date(params.data.calcStart).getTime());
  //       return moment
  //         .utc(new Date(params.data.createdOn).getTime() - new Date(params.data.calcStart).getTime())
  //         .format('d [j] h[h]');
  //     },
  //   },
  //   // { headerName: this.props.translate(TLCode.ANALYSIS_SCORES_ID), width: 50, field: 'planningId', sort: 'desc' },
  //   //{ headerName: this.props.translate(TLCode.ANALYSIS_SCORES_ID), width: 50, field: 'scoreId', sort: 'desc' },
  //   { headerName: this.props.translate(TLCode.ANALYSIS_SCORES_STATUS), width: 65, field: 'status' },
  //   {
  //     headerName: this.props.translate(TLCode.ANALYSIS_SCORES_START),
  //     width: 60,
  //     field: 'startDate',
  //     cellRenderer: dateCellRenderer,
  //   },
  //   {
  //     headerName: this.props.translate(TLCode.ANALYSIS_SCORES_END),
  //     width: 60,
  //     field: 'endDate',
  //     cellRenderer: dateCellRenderer,
  //   },
  //   { headerName: this.props.translate(TLCode.ANALYSIS_SCORES_NAME), width: 100, field: 'name' },
  //   { headerName: this.props.translate(TLCode.ANALYSIS_SCORES_DESCRIPTION), field: 'description' },
  //   { headerName: this.props.translate(TLCode.ANALYSIS_SCORES_HARD), width: 65, field: 'hardScore' },
  //   { headerName: this.props.translate(TLCode.ANALYSIS_SCORES_MED), width: 65, field: 'mediumScore' },
  //   { headerName: this.props.translate(TLCode.ANALYSIS_SCORES_SOFT), width: 65, field: 'softScore' },
  //   {
  //     headerName: this.props.translate(TLCode.ANALYSIS_SCORES_END),
  //     width: 60,
  //     field: 'lastPromotedOn',
  //     cellRenderer: dateCellRenderer,
  //   },
  // ];

  // solutionDetailColumns = [
  //   { headerName: this.props.translate(TLCode.ANALYSIS_MATCHES_RULE), width: 200, field: 'ruleName' },
  //   {
  //     headerName: this.props.translate(TLCode.ANALYSIS_MATCHES_TRANSGRESSIONS),
  //     width: 200,
  //     field: 'transgressionCount',
  //     cellRenderer: (params: ICellRendererParams) => {
  //       return getWithDiff(params.data.transgressionCount, params.data.previousTransgressionCount);
  //     },
  //   },
  //   {
  //     headerName: this.props.translate(TLCode.ANALYSIS_MATCHES_HARD),
  //     width: 200,
  //     field: 'hardScore',
  //     cellRenderer: (params: ICellRendererParams) => {
  //       return getWithDiff(params.data.hardScore, params.data.previousHardScore);
  //     },
  //   },
  //   {
  //     headerName: this.props.translate(TLCode.ANALYSIS_MATCHES_MED),
  //     width: 200,
  //     field: 'mediumScore',
  //     cellRenderer: (params: ICellRendererParams) => {
  //       return getWithDiff(params.data.mediumScore, params.data.previousMediumScore);
  //     },
  //   },
  //   {
  //     headerName: this.props.translate(TLCode.ANALYSIS_MATCHES_SOFT),
  //     width: 200,
  //     field: 'softScore',
  //     cellRenderer: (params: ICellRendererParams) => {
  //       return getWithDiff(params.data.softScore, params.data.previousSoftScore);
  //     },
  //   },
  // ];

  // indictmentColumnDefs = [
  //   { headerName: this.props.translate(TLCode.ANALYSIS_MATCHES_RULE), width: 200, field: 'description' },
  //   {
  //     headerName: this.props.translate(TLCode.ANALYSIS_MATCHES_SOFT),
  //     width: 60,
  //     field: 'apbnr',
  //     cellRenderer: (params: ICellRendererParams) => {
  //       return params.data.description.split('$')[1];
  //     },
  //   },
  // ];

  // indictmentCountColumnDefs = [
  //   { headerName: this.props.translate(TLCode.ANALYSIS_MATCHES_APPNUMBER), field: 'apbNumber' },
  //   { headerName: this.props.translate(TLCode.ANALYSIS_MATCHES_NAME), field: 'name' },
  //   {
  //     headerName: this.props.translate(TLCode.ANALYSIS_MATCHES_COUNT),
  //     field: 'cnt',
  //   },
  // ];

  // setRunFilterText(runFilterText) {
  //   this.setState({
  //     runFilterText
  //   });
  // }

  setRuleFilterText(ruleFilter) {
    this.setState({
      ruleFilter,
    });
  }

  goPrevious = () => {
    if (this.state.isMounted) this.setState({ planningId: this.state.planningId - 1 });
  };

  goNext = () => {
    if (this.state.isMounted) this.setState({ planningId: this.state.planningId + 1 });
  };

  handleTabChange = (newTabId: TabId, prevTabId: TabId, event: any) => {
    if (this.state.isMounted) {
      this.setState({ selectedTabId: newTabId.toString() });
      this.props.UiStore!.setDiagnosticPageActiveTab(newTabId.toString());
    }
  };

  handleSubTabChange = (newTabId: TabId, prevTabId: TabId, event: any) => {
    if (this.state.isMounted) {
      this.setState({ selectedSubTabId: newTabId.toString() });
      this.props.UiStore!.setDiagnosticPageActiveSubTab(newTabId.toString());
      if (newTabId === SUBTAB.INSUFFICIENTGEOCOVERAGE && this.props.ScoreStore!.dataList.length === 0) {
        this.props.ScoreStore!.getScores({});
      }
    }
  };

  handleSubSubTabChange = (newTabId: TabId, prevTabId: TabId, event: any) => {
    if (this.state.isMounted) {
      if (typeof newTabId === 'string') {
        // this.setState({ selectedDutyCountSubTabId: newTabId.toString() });
        newTabId.startsWith('DC')
          ? this.setState({ selectedDutyCountSubTabId: newTabId.toString() })
          : newTabId.startsWith('UN')
            ? this.setState({ selectedUnbalancedCountSubTabId: newTabId.toString() })
            : true;
      } else {
        // this.setState({ selectedDutyCountSubTabId: newTabId.toString() });
      }
      //   // this.setState({ selectedDutyCountSubTabId: newTabId.toString() });
      this.props.UiStore!.setDiagnosticPageActiveSubSubTab(newTabId.toString());
    }
  };

  getSolutionLabel = (planning) => {
    if (planning === undefined) return <span />;
    else {
      return (
        <span>
          #{planning!.scoreId} [{planning!.createdOn}] (HARD:{planning!.hardScore} / MED:{planning!.mediumScore} / SOFT:
          {planning!.softScore})
        </span>
      );
    }
  };

  onScoreSelectedV2 = (event) => {
    const scoreId = event.data.scoreId;
    if (this.state.isMounted) {
      this.setState({ planningId: scoreId, savedPlanningId: scoreId, selectedPlanningId: scoreId, selectedTabId: TAB.MATCHES });
      // this.props.UiStore!.setDiagnosticPageCurrentPlanningId(scoreId);
      // const planning = this.props.ScoreStore!.getById(scoreId);
      // this.setStartDate(new Date(planning!.startDate!));
      // this.setEndDate(new Date(planning!.endDate!));
      this.handleSelectedPlanningIdValueChange({ value:scoreId, label:''+scoreId},''+scoreId)
    }
  };

  onScoreSelected = (event) => {
    const scoreId = event.data.scoreId;
    if (this.state.isMounted) {
      this.setState({ planningId: scoreId, savedPlanningId: scoreId, selectedTabId: TAB.MATCHES });
      this.props.UiStore!.setDiagnosticPageCurrentPlanningId(scoreId);
    }
  };

  onRuleSelectedV2 = (event) => {
    const ruleName = event.data.ruleName;
    if (this.state.isMounted) {
      this.setState({ ruleFilter: ruleName, selectedTabId: TAB.TRANSGRESSIONS });
    }
  };

  onRuleSelected = (event) => {
    const ruleName = event.data.ruleName;
    if (this.state.isMounted) this.setState({ ruleFilter: ruleName, selectedTabId: TAB.TRANSGRESSIONS });
  };

  onPharmacySelected = (event) => {
    const pharmacyId = event.data.pharmacy;
    this.props.ApplicationStore!.navigate(`${Page.PharmacyPage}/${pharmacyId}`);
  };

  onPharmacyIdSelected = (event) => {
    const pharmacyId = event.data.pharmacyId;
    this.props.ApplicationStore!.navigate(`${Page.PharmacyPage}/${pharmacyId}`);
  };

  onApbNrSelected = async (event) => {
    const apbNr = event.data.description.split('$')[1];
    this.navigate(apbNr);
    console.log('apbNrSelected');
  };

  onApbNrSelected2 = async (event) => {
    const apbNr = event.data.apbNumber;
    this.setState({ ruleFilter: apbNr });
  };

  navigate = async (apbNr) => {
    await this.props.PharmacyStore!.loadList();
    const pharmacy = this.props.PharmacyStore!.dataList.filter((ph) => ph.apbNumber === parseInt(apbNr))[0];
    const pharmacyId = pharmacy.pharmacyId;
    this.props.ApplicationStore!.navigate(`${Page.PharmacyPage}/${pharmacyId}`);
  };

  setStartDate = (date) => {
    this._isMounted &&
      this.setState({ startDate: date, selectedStartRuleTransgressionDate: date, selectedTabId: TAB.PROBLEMS });
    this.props.UiStore!.setDiagnosticPageStartDate(date);
  };

  setEndDate = (date) => {
    this._isMounted &&
      this.setState({ endDate: date, selectedEndRuleTransgressionDate: date, selectedTabId: TAB.PROBLEMS });
    this.props.UiStore!.setDiagnosticPageEndDate(date);
  };

  getGlobalPerformancePercentage = () => {
    const { MatchStore } = this.props;
    if (this.notReadyYet()) {
      return 'n/a';
    } else {
      const tooCloseDuties = parseFloat(MatchStore!.miscDatas['GetTooCloseDutiesPercentage']);
      const abnormalCount = parseFloat(MatchStore!.miscDatas['GetAbnormalDutyCountsPercentage']);
      return (100 - (tooCloseDuties + abnormalCount) / 2).toFixed(2);
    }
  };

  notReadyYet = () => {
    return this.state.isLoading || !this.state.isMounted;
  };

  formatNeighborsComparison = (pharmacyNbr, neighborsAverage) => {
    try {
      return `\u0078\u0305 ${neighborsAverage.toFixed(0)}, Δ ${(pharmacyNbr - neighborsAverage).toFixed(0)}`;
    } catch (error) {
      console.error(error);
    }
  };

  getUnbalancedNeighborsList = (list) => {
    return list.map((elem) => ({
      pharmacyId: elem.pharmacyId,
      apbNumber: elem.apbNumber,
      anchor: elem.anchor,
      pharmacyName: elem.pharmacyName,
      group: elem.group,
      fridayCnt: elem.fridays,
      fridays: this.formatNeighborsComparison(elem.fridays, elem.neighborsFridays),
      fridayOk: this.redGreen(Math.abs(elem.fridays - elem.neighborsFridays)),
      saturdayCnt: elem.saturdays,
      saturdays: this.formatNeighborsComparison(elem.saturdays, elem.neighborsSaturdays),
      saturdayOk: this.redGreen(Math.abs(elem.saturdays - elem.neighborsSaturdays)),
      sundayCnt: elem.sundays,
      sundays: this.formatNeighborsComparison(elem.sundays, elem.neighborsSundays),
      yearSundays: elem.yearSundays,
      sundayOk: this.redGreen(Math.abs(elem.sundays - elem.neighborsSundays)),
      holidayCnt: elem.holidays,
      yearHolidayCnt: elem.yearHolidays,
      holidays: this.formatNeighborsComparison(elem.holidays, elem.neighborsHolidays),
      holidayOk: this.redGreen(Math.abs(elem.holidays - elem.neighborsHolidays)),
      nightCnt: elem.nights,
      nights: this.formatNeighborsComparison(elem.nights, elem.neighborsNights),
      nightOk: this.redGreen(Math.abs(elem.nights - elem.neighborsNights)),
      totalCnt: elem.total,
      total: this.formatNeighborsComparison(elem.total, elem.neighborsTotal),
      totalOk: this.redGreen(Math.abs(elem.total - elem.neighborsTotal)),
    }));
  };

  getFinalDutyCountChangesList = (list, unavailable) => {
    return list.filter((it) => !unavailable.includes(it.apbNumber)).map((elem) => ({
      ...elem,
      currentRatio: (elem.currNight / elem.currDay).toFixed(2),
      previousRatio: (elem.prevNight / elem.prevDay).toFixed(2),
    }));
  };

  getFinalBlackpointTransgressionList = (list) => {
    // Here we asume that if two elements with the same apbNumber and the same date mean that it's a day and night duty.
    return list
      .reduce((acc: any[], current) => {
        const isDayNightForCurrent = (elem: any) =>
          elem.apbNumber === current.apbNumber && elem.date.split('T')[0] === current.date.split('T')[0];
        const existingSameDateSameApbNumber = acc.find(isDayNightForCurrent);
        if (existingSameDateSameApbNumber !== undefined) {
          const accWithoutSameAsCurrent = acc.filter((elem) => !isDayNightForCurrent(elem));
          existingSameDateSameApbNumber.type = 'J+N';
          existingSameDateSameApbNumber.disp = existingSameDateSameApbNumber.disp || current.disp;
          existingSameDateSameApbNumber.bp = existingSameDateSameApbNumber.bp || current.bp;
          existingSameDateSameApbNumber.prefOff = existingSameDateSameApbNumber.prefOff || current.prefOff;
          return [...accWithoutSameAsCurrent, existingSameDateSameApbNumber];
        } else return [...acc, current];
      }, [])
      .map((elem) => ({
        ...elem,
        // currentRatio: (elem.currNight / elem.currDay).toFixed(2),
        // previousRatio: (elem.prevNight / elem.prevDay).toFixed(2),
      }));
  };

  getFinalGroupTransgressionList = (list) => {
    return list.map((elem) => ({
      ...elem,
      // currentRatio: (elem.currNight / elem.currDay).toFixed(2),
      // previousRatio: (elem.prevNight / elem.prevDay).toFixed(2),
    }));
  };

  getFinalGroupTransgressionByDateList = (list) => {
    return list.map((elem) => ({
      ...elem,
      // currentRatio: (elem.currNight / elem.currDay).toFixed(2),
      // previousRatio: (elem.prevNight / elem.prevDay).toFixed(2),
    }));
  };

  getFinalGroupDutyCountsByDateList = (list) => {
    return list.map((elem) => ({
      ...elem,
      // currentRatio: (elem.currNight / elem.currDay).toFixed(2),
      // previousRatio: (elem.prevNight / elem.prevDay).toFixed(2),
    }));
  };

  selectedDateChange = async (date) => {
    this.setState({ selectedDate: date });
    this.startDate = date;
    const date2 = new Date(JSON.parse(JSON.stringify(date)));
    date2.setMonth(date2.getMonth() - 6);

    const semester = getSemester(new Date(date2));
    this.setStartDate(new Date(semester.beginningStr));
    this.setEndDate(new Date(semester.endStr));
  };

  setS1 = () => {
    this.handlePlanningIdValueChange(-1, '-1');
    this.setState({ selectedPlanningId: {} });
    let date = getFirstMonday(this.state.semesterYear, 0);
    this.setStartDate(date);

    date = getFirstSunday(this.state.semesterYear, 6);
    this.setEndDate(date);
  };

  setS2 = () => {
    this.handlePlanningIdValueChange(-1, '-1');
    this.setState({ selectedPlanningId: {} });
    let date = getFirstMonday(this.state.semesterYear, 6);
    this.setStartDate(date);

    date = getFirstSunday(this.state.semesterYear + 1, 0);
    this.setEndDate(date);
  };

  selectedStartRuleTransgressionChange = async (date) => {
    this.setState({ selectedStartRuleTransgressionDate: date });
    this.selectedStartRuleTransgressionDate = date;
  };

  selectedEndRuleTransgressionChange = async (date) => {
    this.setState({ selectedEndRuleTransgressionDate: date });
    this.selectedEndRuleTransgressionDate = date;
  };

  onFirstDateBlur = () => {
    // const semester = getSemester(new Date(this.state.firstDate));
    // this.setState({ lastDate: semester.endStr, startDate: semester.beginningStr, firstDate: semester.beginningStr, runName: 'RUN-'+semester.name })
  };

  calculateCurrDutyTotal = (changes) => {
    let total = 0;
    changes
      ? changes.map((ph) => {
        total += Number.isNaN(ph.currDay) ? 0 : ph.currDay;
      })
      : 0;
    return total;
  };

  calculatePrevDutyTotal = (changes) => {
    let total = 0;
    changes
      ? changes.map((ph) => {
        total += Number.isNaN(ph.prevDay) ? 0 : ph.prevDay;
      })
      : 0;
    return total;
  };

  calculateCurrDayDutyTotal = (changes) => {
    let total = 0;
    changes
      ? changes.map((ph) => {
        total += Number.isNaN(ph.currDay - ph.currNight) ? 0 : ph.currDay - ph.currNight;
      })
      : 0;
    return total;
  };

  calculatePrevDayDutyTotal = (changes) => {
    let total = 0;
    changes
      ? changes.map((ph) => {
        total += Number.isNaN(ph.prevDay - ph.prevNight) ? 0 : ph.prevDay - ph.prevNight;
      })
      : 0;
    return total;
  };

  calculateCurrNightDutyTotal = (changes) => {
    let total = 0;
    changes
      ? changes.map((ph) => {
        total += Number.isNaN(ph.currNight) ? 0 : ph.currNight;
      })
      : 0;
    return total;
  };

  calculatePrevNightDutyTotal = (changes) => {
    let total = 0;
    changes
      ? changes.map((ph) => {
        total += Number.isNaN(ph.prevNight) ? 0 : ph.prevNight;
      })
      : 0;
    return total;
  };

  calculateDutyDistribution = (changes) => {
    const distribution = new Map();
    changes
      ? changes.map((ph) => {
        const diff = Number.isNaN(ph.currDay) ? 0 : ph.currDay;
        if (!distribution.has(diff)) distribution.set(diff, 0);
        distribution.set(diff, distribution.get(diff) + 1);
      })
      : 0;
    const list = new Array();
    distribution.forEach((value, key) => {
      list.push({ key, value });
    });
    const sortedList = list.sort((a, b) => a.key - b.key);
    return sortedList;
  };

  calculateDayDutyDistribution = (changes) => {
    const distribution = new Map();
    changes.map((ph) => {
      const diff = Number.isNaN(ph.currDay - ph.currNight) ? 0 : ph.currDay - ph.currNight;
      if (!distribution.has(diff)) distribution.set(diff, 0);
      distribution.set(diff, distribution.get(diff) + 1);
    });
    const list = new Array();
    distribution.forEach((value, key) => {
      list.push({ key, value });
    });
    const sortedList = list.sort((a, b) => a.key - b.key);
    return sortedList;
  };

  calculateNightDutyDistribution = (changes) => {
    const distribution = new Map();
    changes.map((ph) => {
      const diff = Number.isNaN(ph.currNight) ? 0 : ph.currNight;
      if (!distribution.has(diff)) distribution.set(diff, 0);
      distribution.set(diff, distribution.get(diff) + 1);
    });
    const list = new Array();
    distribution.forEach((value, key) => {
      list.push({ key, value });
    });
    const sortedList = list.sort((a, b) => a.key - b.key);
    return sortedList;
  };

  calculateDeltaDistribution = (changes) => {
    const distribution = new Map();
    changes.map((ph) => {
      const diff = Number.isNaN(ph.currDay - ph.prevDay) ? 0 : ph.currDay - ph.prevDay;
      if (!distribution.has(diff)) distribution.set(diff, 0);
      distribution.set(diff, distribution.get(diff) + 1);
    });
    const list = new Array();
    distribution.forEach((value, key) => {
      list.push({ key, value });
    });
    const sortedList = list.sort((a, b) => a.key - b.key);
    return sortedList;
  };

  calculateDeltaDayDistribution = (changes) => {
    const distribution = new Map();
    changes.map((ph) => {
      const diff = Number.isNaN(ph.currDay - ph.currNight - (ph.prevDay - ph.prevNight))
        ? 0
        : ph.currDay - ph.currNight - (ph.prevDay - ph.prevNight);
      if (!distribution.has(diff)) distribution.set(diff, 0);
      distribution.set(diff, distribution.get(diff) + 1);
    });
    const list = new Array();
    distribution.forEach((value, key) => {
      list.push({ key, value });
    });
    const sortedList = list.sort((a, b) => a.key - b.key);
    return sortedList;
  };

  calculateDeltaNightDistribution = (changes) => {
    const distribution = new Map();
    changes.map((ph) => {
      const diff = Number.isNaN(ph.currNight - ph.prevNight) ? 0 : ph.currNight - ph.prevNight;
      if (!distribution.has(diff)) distribution.set(diff, 0);
      distribution.set(diff, distribution.get(diff) + 1);
    });
    const list = new Array();
    distribution.forEach((value, key) => {
      list.push({ key, value });
    });
    const sortedList = list.sort((a, b) => a.key - b.key);
    return sortedList;
  };

  calculateFridayDistribution = (changes) => {
    const distribution = new Map();
    changes.map((ph) => {
      const diff = Number.isNaN(ph.fridayCnt) ? 0 : ph.fridayCnt;
      if (!distribution.has(diff)) distribution.set(diff, 0);
      distribution.set(diff, distribution.get(diff) + 1);
    });
    const list = new Array();
    distribution.forEach((value, key) => {
      list.push({ key, value });
    });
    const sortedList = list.sort((a, b) => a.key - b.key);
    return sortedList;
  };

  calculateSaturdayDistribution = (changes) => {
    const distribution = new Map();
    changes.map((ph) => {
      const diff = Number.isNaN(ph.saturdayCnt) ? 0 : ph.saturdayCnt;
      if (!distribution.has(diff)) distribution.set(diff, 0);
      distribution.set(diff, distribution.get(diff) + 1);
    });
    const list = new Array();
    distribution.forEach((value, key) => {
      list.push({ key, value });
    });
    const sortedList = list.sort((a, b) => a.key - b.key);
    return sortedList;
  };

  calculateSundayDistribution = (changes) => {
    const distribution = new Map();
    changes.map((ph) => {
      const diff = Number.isNaN(ph.sundayCnt) ? 0 : ph.sundayCnt;
      if (!distribution.has(diff)) distribution.set(diff, 0);
      distribution.set(diff, distribution.get(diff) + 1);
    });
    const list = new Array();
    distribution.forEach((value, key) => {
      list.push({ key, value });
    });
    const sortedList = list.sort((a, b) => a.key - b.key);
    return sortedList;
  };

  calculateWeekendDistribution = (changes) => {
    const distribution = new Map();
    changes.map((ph) => {
      let diff = Number.isNaN(ph.saturdayCnt) ? 0 : ph.saturdayCnt;
      diff = Number.isNaN(ph.sundayCnt) ? 0 : ph.sundayCnt;
      if (!distribution.has(diff)) distribution.set(diff, 0);
      distribution.set(diff, distribution.get(diff) + 1);
    });
    const list = new Array();
    distribution.forEach((value, key) => {
      list.push({ key, value });
    });
    const sortedList = list.sort((a, b) => a.key - b.key);
    return sortedList;
  };

  calculateBankholidayDistribution = (changes) => {
    const distribution = new Map();
    changes.map((ph) => {
      const diff = Number.isNaN(ph.holidayCnt) ? 0 : ph.holidayCnt;
      if (!distribution.has(diff)) distribution.set(diff, 0);
      distribution.set(diff, distribution.get(diff) + 1);
    });
    const list = new Array();
    distribution.forEach((value, key) => {
      list.push({ key, value });
    });
    const sortedList = list.sort((a, b) => a.key - b.key);
    return sortedList;
  };

  calculatePrevWeekendDistribution = (changes) => {
    const distribution = new Map();
    changes.map((ph) => {
      let diff = Number.isNaN(ph.saturdayCnt) ? 0 : ph.saturdayCnt;
      diff = Number.isNaN(ph.sundayCnt) ? 0 : ph.sundayCnt;
      if (!distribution.has(diff)) distribution.set(diff, 0);
      distribution.set(diff, distribution.get(diff) + 1);
    });
    const list = new Array();
    distribution.forEach((value, key) => {
      list.push({ key, value });
    });
    const sortedList = list.sort((a, b) => a.key - b.key);
    return sortedList;
  };

  calculateRatioDistribution = (changes) => {
    const distribution = new Map();
    changes.map((ph) => {
      const diff =
        Number.isNaN(ph.currDay) || ph.currDay == 0 ? 'n/a' : ((ph.currDay - ph.currNight) / ph.currDay).toFixed(2);
      if (!distribution.has(diff)) distribution.set(diff, 0);
      distribution.set(diff, distribution.get(diff) + 1);
    });
    const list = new Array();
    distribution.forEach((value, key) => {
      if (key != 'n/a') {
        list.push({ key, value });
      }
    });
    const sortedList = list.sort((a, b) => parseFloat(a.key) - parseFloat(b.key));
    return sortedList;
  };

  calculatePrevRatioDistribution = (changes) => {
    const distribution = new Map();
    changes.map((ph) => {
      const diff =
        Number.isNaN(ph.prevDay) || ph.prevDay == 0 ? 'n/a' : ((ph.prevDay - ph.prevNight) / ph.prevDay).toFixed(2);
      if (!distribution.has(diff)) distribution.set(diff, 0);
      distribution.set(diff, distribution.get(diff) + 1);
    });
    const list = new Array();
    distribution.forEach((value, key) => {
      if (key != 'n/a') {
        list.push({ key, value });
      }
    });
    const sortedList = list.sort((a, b) => parseFloat(a.key) - parseFloat(b.key));
    return sortedList;
  };

  detectGroupRuleTransgressions = async () => {
    this._isMounted && this.setState({ isLoading: true });
    const { MatchStore } = this.props;
    await MatchStore!.DetectGroupRuleTransgressions(
      this.state.savedPlanningId,
      this.state.selectedStartRuleTransgressionDate,
      this.state.selectedEndRuleTransgressionDate,
      this.getSecretariatId() ? this.getSecretariatId() : -1,
    );
    this._isMounted && this.setState({ isLoading: false });
  };

  enhance = async () => {
    if (this.state.isLoading) return;

    this._isMounted && this.setState({ isLoading: true });
    const params = {
      secretariatId: this.getSecretariatId(),
      startDate: this.state.startDate,
      enddate: this.state.endDate
    };
    await this.props.PlannerStore!.enhancePlanning(params);

    this._isMounted && this.setState({ isLoading: false });
  };

  search = async () => {
    if (this.state.isLoading) return;
    const { MatchStore } = this.props;
    this._isMounted && this.setState({ isLoading: true });
    const params = {
      offset: this.state.offset,
      status: this.state.status,
      savedPlanningId: this.state.savedPlanningId,
      savedPrevPlanningId: this.state.savedPrevPlanningId,
      secretariatId: this.getSecretariatId(),
    };
    await Promise.all([
      MatchStore!.GetUnavailablePharmacyList(this.state.startDate, this.state.endDate, {

      }),
      MatchStore!.GetTooCloseDuties(
        this.state.startDate,
        this.state.endDate,
        0, //this.state.lowerGapLimit,
        0, //this.state.upperGapLimit,
        {
          offset: this.state.offset,
          savedPlanningId: this.state.savedPlanningId,
          secretariatId: this.getSecretariatId(),
        },
      ),
      // MatchStore!.GetAbnormalDutyCounts(this.state.startDate, this.state.endDate, {
      //   offset: this.state.offset,
      //   savedPlanningId: this.state.savedPlanningId,
      //   secretariatId: this.getSecretariatId(),
      // }),
      MatchStore!.GetDutyCountChanges(this.state.startDate, this.state.endDate, params),
      MatchStore!.GetBlackpointTransgressions(this.state.startDate, this.state.endDate, this.state.savedPlanningId, {
        offset: this.state.offset,
        status: this.state.status,
        secretariatId: this.getSecretariatId(),
      }),
      ////MatchStore!.GetGroupTransgressions(this.state.planningId, '*', {}),
      //MatchStore!.GetGroupTransgressions(this.state.savedPlanningId, '*', {}),
      //MatchStore!.GetGroupTransgressionsByDate(this.state.startDate, this.state.endDate, this.state.planningId, '*', {
      // MatchStore!.GetGroupTransgressionsByDate(this.state.startDate, this.state.endDate, this.state.savedPlanningId, '*', {
      //   secretariatId: this.getSecretariatId(),
      // }),
      //MatchStore!.GetGroupDutyCountsByDate(this.state.startDate, this.state.endDate, this.state.planningId, '*', {
      MatchStore!.GetGroupDutyCountsByDate(this.state.startDate, this.state.endDate, this.state.savedPlanningId, '*', {
        secretariatId: this.getSecretariatId(),
      }),
      MatchStore!.GetGroupAverageDutyCounts(this.state.startDate, this.state.endDate, this.state.savedPlanningId, {
        secretariatId: this.getSecretariatId(),
      }),
      MatchStore!.GetUnbalancedNeighbors(this.state.startDate, this.state.endDate, {
        offset: this.state.offset,
        savedPlanningId: this.state.savedPlanningId,
        secretariatId: this.getSecretariatId(),
      }),
      MatchStore!.GetMinDistances(this.state.startDate, this.state.endDate, this.state.savedPlanningId, {
        offset: this.state.offset,
        savedPlanningId: this.state.savedPlanningId,
        secretariatId: this.getSecretariatId(),
      }),
    ]);
    this._isMounted && this.setState({ isLoading: false });
  };

  handleOffsetValueChange = (_valueAsNumber: number, _valueAsString: string) => {
    this.setState({ offset: _valueAsNumber });
    this.props.UiStore!.setDiagnosticOffset(_valueAsNumber);
  };

  handlePlanningIdValueChange = (_valueAsNumber: number, _valueAsString: string) => {
    this.setState({ savedPlanningId: _valueAsNumber });
    this.props.UiStore!.setDiagnosticPageCurrentPlanningId(_valueAsNumber);
  };

  handleSelectedPlanningIdValueChange = (_valueAsNumber: any, _valueAsString: string) => {
    this.setState({ savedPlanningId: _valueAsNumber.value, selectedPlanningId: _valueAsNumber });
    this.props.UiStore!.setDiagnosticPageCurrentPlanningId(_valueAsNumber.value);
    const planning = this.props.ScoreStore!.getById(_valueAsNumber.value);
    this.setStartDate(new Date(planning!.startDate!)); // semester.beginningStr));
    this.setEndDate(new Date(planning!.endDate!)); // semester.endStr));
  };

  handlePrevPlanningIdValueChange = (_valueAsNumber: number, _valueAsString: string) => {
    this.setState({ savedPrevPlanningId: _valueAsNumber });
    this.props.UiStore!.setDiagnosticPagePrevPlanningId(_valueAsNumber);
  };

  handleSemesterYearValueChange = (_valueAsNumber: number, _valueAsString: string) => {
    this.setState({ semesterYear: _valueAsNumber });
    this.props.UiStore!.setDiagnosticPageCurrentSemesterYear(_valueAsNumber);
  };

  handleStatusValueChange = (data: any) => {
    this.setState({ status: data });
    this.props.UiStore!.setDiagnosticSearchStatus(data);
  };

  handleLowerDistanceLimitChange = (_valueAsNumber: number, _valueAsString: string) => {
    this.setState({ lowerDistanceLimit: _valueAsNumber });
    this.props.UiStore!.setLowerDistanceLimit(_valueAsNumber);
    this.props.UiStore!.persistUiState();
  };

  handleLowerGapLimitChange = (_valueAsNumber: number, _valueAsString: string) => {
    this.setState({ lowerGapLimit: _valueAsNumber });
    this.props.UiStore!.setLowerGapLimit(_valueAsNumber);
    this.props.UiStore!.persistUiState();
    //this.setState({ nbrPharmaciesWithGapAbove: this.getVisibleRows()})
  };

  handleUpperGapLimitChange = (_valueAsNumber: number, _valueAsString: string) => {
    this.setState({ upperGapLimit: _valueAsNumber });
    this.props.UiStore!.setUpperGapLimit(_valueAsNumber);
    this.props.UiStore!.persistUiState();
    //this.setState({ nbrPharmaciesWithGapAbove: this.getVisibleRows()})
  };

  buildSelectableScoreList = (scoreList: any[]) => {
    const list = Array.from(scoreList, (x) => {
      if (x.status === 'generated') {
        const obj = { label: x.planningId, value: x.planningId };
        return obj;
      } else return null;
    })
      .filter((x) => x != null)
      .sort((a, b) => (a!.value < b!.value ? 1 : -1));
    return list;
  };

  customExport = (sheet: any) => {
    const wb = new ExcelJs.Workbook();
    const ws = wb.addWorksheet('Sheet1');

    ws.columns = [
      { header: 'APB', key: 'apb', width: 7, numFmt: '0' },
      { header: 'Gr', key: 'gr', width: 6 },
      { header: 'Nom', key: 'nom', width: 50 },
      { header: 'Cible', key: 'cible', width: 6, numFmt: '0', alignment: { horizontal: 'left' } },
      {
        header: 'Total',
        key: 'total',
        width: 6,
        numFmt: '0',
        style: { fill: { fgColor: { argb: 'ffff00' }, type: 'pattern', pattern: 'solid' } },
      },
      {
        header: 'Δ Cible',
        key: 'deltaCible',
        width: 7,
        style: { fill: { fgColor: { argb: 'ffffff' }, type: 'pattern', pattern: 'solid' } },
      },
      {
        header: 'J Cible',
        key: 'jcible',
        width: 7,
        style: { fill: { fgColor: { argb: 'c5d9f1' }, type: 'pattern', pattern: 'solid' } },
      },
      {
        header: 'Jours',
        key: 'jours',
        width: 7,
        style: { fill: { fgColor: { argb: '8db4e2' }, type: 'pattern', pattern: 'solid' } },
      },
      {
        header: 'N Cible',
        key: 'ncible',
        width: 7,
        style: { fill: { fgColor: { argb: 'd9d9d9' }, type: 'pattern', pattern: 'solid' } },
      },
      {
        header: 'Nuits',
        key: 'nuits',
        width: 7,
        style: { fill: { fgColor: { argb: 'bfbfbf' }, type: 'pattern', pattern: 'solid' } },
      },
      {
        header: 'Ven',
        key: 'vendredis',
        width: 7,
        style: { fill: { fgColor: { argb: 'fde9d9' }, type: 'pattern', pattern: 'solid' } },
      },
      {
        header: 'Sam',
        key: 'samedis',
        width: 7,
        style: { fill: { fgColor: { argb: 'fcd5b4' }, type: 'pattern', pattern: 'solid' } },
      },
      {
        header: 'Dim',
        key: 'dimanches',
        width: 7,
        style: { fill: { fgColor: { argb: 'fabf8f' }, type: 'pattern', pattern: 'solid' } },
      },
      {
        header: 'Fériés',
        key: 'feries',
        width: 7,
        style: { fill: { fgColor: { argb: '92d050' }, type: 'pattern', pattern: 'solid' } },
      },
      {
        header: 'Fériés/an',
        key: 'feriesparan',
        width: 9,
        style: { fill: { fgColor: { argb: 'ffffff' }, type: 'pattern', pattern: 'solid' } },
      },
    ];

    const end = sheet['!ref'].split(':')[1].replace('P', '') as number;
    var index = 2;

    while (index <= end) {
      var row = {
        apb: +sheet['A' + index].v,
        gr: sheet['B' + index].v,
        nom: sheet['C' + index].v,
        cible: +sheet['D' + index].v,
        total: +sheet['E' + index].v,
        deltaCible: +sheet['F' + index].v,
        jcible: +sheet['G' + index].v,
        jours: +sheet['H' + index].v,
        ncible: +sheet['I' + index].v,
        nuits: +sheet['J' + index].v,
        vendredis: +sheet['L' + index].v,
        samedis: +sheet['M' + index].v,
        dimanches: +sheet['N' + index].v,
        feries: +sheet['O' + index].v,
        feriesparan: +sheet['P' + index].v,
      };
      const newRow = ws.addRow(row);
      index += 1;
    }

    ws.eachRow(function (Row, rowNum) {
      Row.eachCell(function (Cell, cellNum) {
        if (cellNum > 3) {
          Cell.alignment = {
            horizontal: 'center',
          };
          Cell.border = {
            left: { style: 'thin', color: { argb: 'd4d4d4' } },
            top: { style: 'thin', color: { argb: 'd4d4d4' } },
            bottom: { style: 'thin', color: { argb: 'd4d4d4' } },
          };
        }
      });
    });

    const filename = 'PharmagardeDutyCountChanges.xlsx';

    wb.xlsx
      .writeBuffer()
      .then((buffer) => FileSaver.saveAs(new Blob([buffer]), filename))
      .catch((err) => console.log('Error writing excel export', err));
  };

  customExport2 = (sheet: any) => {
    const wopts: XLSX.WritingOptions = { bookType: 'xlsx', bookSST: false, type: 'base64', cellStyles: true };

    const wb = XLSX.utils.book_new();
    wb.SheetNames[0] = 'sheet';
    wb.Sheets.sheet = sheet;

    var A1 = XLSX.utils.decode_cell('A1');
    var E1 = XLSX.utils.decode_cell('E1');
    XLSX.utils.sheet_add_aoa(
      wb.Sheets.sheet,
      [
        [
          'APB',
          'Gr',
          '<b>Nom</b>',
          'Cible',
          'Total',
          'Δ Cible',
          'J Cible',
          'Jours',
          'N Cible',
          'Nuits',
          'Ratio',
          'ven',
          'sam',
          'dim',
          'fériés',
          'fériés/an',
        ],
      ],
      { origin: A1 },
    );

    wb.Sheets.sheet['!cols'] = [
      { wch: 7 },
      { wch: 6 },
      { wch: 50 },
      { wch: 6 },
      { wch: 6 },
      { wch: 6 },
      { wch: 6 },
      { wch: 6 },
      { wch: 6 },
      { wch: 6 },
      { wch: 6 },
      { wch: 6 },
      { wch: 6 },
      { wch: 6 },
      { wch: 6 },
      { wch: 6 },
    ];
    wb.Sheets.sheet['E1'].s = { fill: { bgColor: { rgb: 'ff6600' } } };
    XLSX.writeFile(wb, 'PharmagardeDutyCountChanges.xlsx', wopts);
  };

  getSecretariatId = () => {
    if (this.props.AuthenticationStore!.isSuperAdmin)
      return this.props.SecretariatStore!.selectedSecretariatId === 0
        ? undefined
        : this.props.SecretariatStore!.selectedSecretariatId;
    if (this.props.AuthenticationStore!.isSecretariat) return this.props.AuthenticationStore!.secretariatId!;
    return undefined;
  };

  onExporting = (e) => {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Main sheet');
    exportDataGrid({
      component: e.component,
      worksheet: worksheet,
      customizeCell: function (options) {
        options.excelCell.font = { name: 'Arial', size: 12 };
        options.excelCell.alignment = { horizontal: 'left' };
      },
    }).then(function () {
      workbook.xlsx.writeBuffer().then(function (buffer) {
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'DataGrid.xlsx');
      });
    });
  };

  onExportingDifferences = (e) => {
    this.onExportingToExcel(e, 'Différences');
  };

  onExportingEcarts = (e) => {
    this.onExportingToExcel(e, 'Ecarts');
  };

  onExportingNombres = (e) => {
    this.onExportingToExcel(e, 'Nombres');
  };

  onExportingTransgressions = (e) => {
    this.onExportingToExcel(e, 'Transgressions');
  };

  onExportingDutyCounts = (e) => {
    this.onExportingToExcel(e, 'NombresParGroupe');
  };

  onExportingTargetCounts = (e) => {
    this.onExportingToExcel(e, 'NombresCiblesParGroupe');
  };

  onExportingSpecialIssues = (e) => {
    this.onExportingToExcel(e, 'SpecialIssues');
  };

  onExportingToExcel = (e, name) => {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Main sheet');
    exportDataGrid({
      component: e.component,
      worksheet: worksheet,
      customizeCell: function (options) {
        options.excelCell.font = { name: 'Arial', size: 12 };
        options.excelCell.alignment = { horizontal: 'left' };
        // if (options.gridCell != undefined && options.gridCell.rowType === "data") {
        //   const bgColor = options.gridCell!.data.backgroundColor;
        //   if (bgColor) {
        //       options.excelCell.fill = {
        //           type: "pattern",
        //           pattern: "solid",
        //           fgColor: { argb:  bgColor.replace("#", "FF") } // Couleur de fond verte
        //       };
        //   }
        // }
        if (options.gridCell != undefined && options.gridCell!.column!.name === 'target') {
          options.excelCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: columnColors.targetColor } };
        } else if (options.gridCell != undefined && options.gridCell!.column!.name === 'count') {
          options.excelCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: columnColors.countColor } };
        } else if (options.gridCell != undefined && options.gridCell!.column!.name === 'dayTarget') {
          options.excelCell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: columnColors.dayTargetColor },
          };
        } else if (options.gridCell != undefined && options.gridCell!.column!.name === 'dayCount') {
          options.excelCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: columnColors.dayCountColor } };
        } else if (options.gridCell != undefined && options.gridCell!.column!.name === 'nightTarget') {
          options.excelCell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: columnColors.nightTargetColor },
          };
        } else if (options.gridCell != undefined && options.gridCell!.column!.name === 'nightCount') {
          options.excelCell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: columnColors.nightCountColor },
          };
        } else if (options.gridCell != undefined && options.gridCell!.column!.name === 'currSaturdays') {
          options.excelCell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: columnColors.saturdayCountColor },
          };
        } else if (options.gridCell != undefined && options.gridCell!.column!.name === 'currSundays') {
          options.excelCell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: columnColors.sundayCountColor },
          };
        }
      },
    }).then(function () {
      workbook.xlsx.writeBuffer().then(function (buffer) {
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'PharmagardeDiagnostic_' + name + '.xlsx');
      });
    });
  };

  promotePlanning = async (e) => {
    //this.props.PushNotificationStore!.planningPromoteStart();
    const confirm = await this.props.ModalStore!.confirm.show(
      this.props.translate(TLCode.ROSTER_PromoteConfirmationTitle),
      this.props.translate(TLCode.ROSTER_PromoteConfirmationText),
    );
    if (confirm) {
      console.log(e);
      this.setState({ saving: true });
      //      await this.props.PlannerStore!.promotePlanning(e.row.data.planningId, null);
      //this._isMounted && this.setState({ promoteRequestTime: new Date().toLocaleString() });
      this.setState({ saving: false });
    }
  };

  deletePlanning = async (e) => {
    const confirm = await this.props.ModalStore!.confirm.show(
      this.props.translate(TLCode.ROSTER_DeleteConfirmationTitle),
      this.props.translate(TLCode.ROSTER_DeleteConfirmationText),
    );
    if (confirm) {
      console.log(e);
      this.setState({ saving: true });
      await this.props.PlannerStore!.deletePlanning(e.row.data.planningId);
      //this._isMounted && this.setState({ promoteRequestTime: new Date().toLocaleString() });
      this.setState({ saving: false });
    }
  };

  private onRowDoubleClicked = (ev) => {
    if (ev.data.pharmacy) {
      this.props.ApplicationStore!.navigate(`${Page.PharmacyPage}/${ev.data.pharmacy}`);
    } else if (ev.data.pharmacyId) {
      this.props.ApplicationStore!.navigate(`${Page.PharmacyPage}/${ev.data.pharmacyId}`);
    }
  };

  onGapOptionChanged(e) {
    if (this.state.nbrPharmaciesWithGapBelow != e.component.getTotalSummaryValue('%Below')) {
      this.setState({ nbrPharmaciesWithGapBelow: e.component.getTotalSummaryValue('%Below') });
      this.setState({
        nbrPharmacies: this.props.MatchStore!.miscDatas!['GetDutyCountChanges']
          ? this.props.MatchStore!.miscDatas!['GetDutyCountChanges'].length
          : 0,
      });
    }
    if (this.state.nbrPharmaciesWithGapAbove != e.component.getTotalSummaryValue('%Above')) {
      this.setState({ nbrPharmaciesWithGapAbove: e.component.getTotalSummaryValue('%Above') });
      this.setState({
        nbrPharmacies: this.props.MatchStore!.miscDatas!['GetDutyCountChanges']
          ? this.props.MatchStore!.miscDatas!['GetDutyCountChanges'].length
          : 0,
      });
    }
  }

  onDutyCountOptionChanged(e) {
    if (this.state.suStdev != e.component.getTotalSummaryValue('suStdev')) {
      this.setState({ suStdev: e.component.getTotalSummaryValue('suStdev') });
    }
    if (this.state.saStdev != e.component.getTotalSummaryValue('saStdev')) {
      this.setState({ saStdev: e.component.getTotalSummaryValue('saStdev') });
    }
  }

  reload = async () => {
    this._isMounted && this.setState({ isLoading: true });
    await this.props.ScoreStore!.getScores({});
    this._isMounted && this.setState({ isLoading: false });
  };


  public render() {
    const { ScoreStore, MatchStore, IndictmentStore, UiStore } = this.props;

    const scoreList = this.notReadyYet() ? {} : ScoreStore!.dataList;

    const selectableScoreList = this.notReadyYet() ? {} : this.buildSelectableScoreList(ScoreStore!.dataList);

    const indictmentList = this.state.isLoading ? {} : IndictmentStore!.dataList;
    //const preFilteredIndictmentList = this.state.isLoading ? {} : IndictmentStore!.dataList.filter((item) => item.description!.includes(this.state.ruleFilter))
    const preFilteredIndictmentList = this.state.isLoading
      ? {}
      : IndictmentStore!.dataList.filter((item) => {
        if (!item.description) return false;
        if (item.planningId != this.state.savedPlanningId) return false;
        const parts = item.description.split('$');
        if (parts.length < 2) return false;
        return parts[1].includes(this.state.ruleFilter);
      });

    const indictmentCountList = this.state.isLoading ? {} : IndictmentStore!.indictmentCount;
    const matchList = this.notReadyYet() ? {} : MatchStore!.miscDatas!['getComparedMatches'];
    const GetTooCloseDutiesList = this.notReadyYet() ? {} : MatchStore!.miscDatas!['GetTooCloseDuties'];

    let grp;
    if (GetTooCloseDutiesList != undefined && GetTooCloseDutiesList.length != undefined) {
    //const grouped = groupByKeys(GetTooCloseDutiesList, ["pharmacy", "apbNumber", "city", "zipCode", "pharmacyName", "ecartMoy", "ecartStdev","ecartCnt"]);
    grp = Object.values(
      GetTooCloseDutiesList.reduce((acc, ph) => 
        {
          if (!(ph.pharmacy in acc)) 
            {
               acc[ph.pharmacy] = ph;
              }
          return acc;
        },{})
      ); 
    }
    let grpData = grp == undefined ? {}:grp.map(it => ({ ecartCnt: it.ecartCnt, ecartMoy: it.ecartMoy, ecartStdev: it.ecartStdev, apbNumber: it.apbNumber, group:it.group }));

    // if (this.spreadingDataGridRef.current != null) {
    //   grpData = this.spreadingDataGridRef.current!.instance.getDataSource().items();
    //   console.log(this.spreadingDataGridRef.current!.instance.getDataSource().items());
    // }

    if (this.state.filteredData.length == undefined) {
      this.setState({ filteredData: grpData });
    }

    const GetTooCloseDutiesListFilteredGapLimit = this.notReadyYet()
      ? {}
      : Array.isArray(MatchStore!.miscDatas!['GetTooCloseDuties'])
      ? MatchStore!.miscDatas!['GetTooCloseDuties'].filter(
        (d) => d.ecart < this.state.lowerGapLimit || d.ecart > this.state.upperGapLimit,
      ).map((item) => ({
        ...item,
        weekday1: item.date1 ? new Date(item.date1).toLocaleDateString('fr-FR', { weekday: 'long' }) : '',
        weekday2: item.date2 ? new Date(item.date2).toLocaleDateString('fr-FR', { weekday: 'long' }) : ''
      }))
      : [];
    

    //const GetUnavailablePharmacyList = [530101];
    const GetUnavailablePharmacyList = this.notReadyYet() ? {} : MatchStore!.miscDatas!['GetUnavailablePharmacyList'];

    const GetAbnormalDutyCountsList = this.notReadyYet() ? {} : MatchStore!.miscDatas!['GetAbnormalDutyCounts'];

    const GetDutyCountChangesList = this.notReadyYet() ? [] : MatchStore!.miscDatas!['GetDutyCountChanges'];
    const GetBlackpointTransgressionList = this.notReadyYet()
      ? []
      : MatchStore!.miscDatas!['GetBlackpointTransgressions'];
    const GetGroupTransgressionList = this.notReadyYet() ? [] : MatchStore!.miscDatas!['GetGroupTransgressions'];
    const GetGroupTransgressionByDateList = this.notReadyYet()
      ? []
      : MatchStore!.miscDatas!['GetGroupTransgressionsByDate'];
    const GetGroupDutyCountsByDateList = this.notReadyYet() ? [] :
      MatchStore!.miscDatas!['GetGroupDutyCountsByDate'] ? MatchStore!.miscDatas!['GetGroupDutyCountsByDate'].map(item => ({
        ...item,
        weekday: item.date ? new Date(item.date).toLocaleDateString('fr-FR', { weekday: 'long' }) : ''
      })) : [];
    const GetUnbalancedNeighborsList = this.notReadyYet() ? [] : MatchStore!.miscDatas!['GetUnbalancedNeighbors'];
    //const GetMinDistancesList = this.notReadyYet() ? [] : MatchStore!.miscDatas!['GetMinDistances'];

    const GetMinDistancesList = this.notReadyYet()
      ? {}
      : Array.isArray(MatchStore!.miscDatas!['GetMinDistances'])
        ? MatchStore!.miscDatas!['GetMinDistances'].filter((d) => d.distance < this.state.lowerDistanceLimit)
        : [];
    // const DetectGroupRuleTransgressionList = this.notReadyYet()
    //   ? []
    //   : MatchStore!.miscDatas!['DetectGroupRuleTransgressions'];
    const GetGroupAverageDutyCountList = this.notReadyYet() ? [] : MatchStore!.miscDatas!['GetGroupAverageDutyCounts'];
    const finalDutyCountChangesList = GetDutyCountChangesList
      ? this.getFinalDutyCountChangesList(GetDutyCountChangesList, GetUnavailablePharmacyList)
      : [];
    const finalBlackpointTransgressionList = GetBlackpointTransgressionList
      ? this.getFinalBlackpointTransgressionList(GetBlackpointTransgressionList)
      : [];
    // const finalGroupTransgressionList = GetGroupTransgressionList
    //   ? this.getFinalGroupTransgressionList(GetGroupTransgressionList)
    //   : [];
    // const finalGroupTransgressionByDateList = GetGroupTransgressionByDateList
    //   ? this.getFinalGroupTransgressionByDateList(GetGroupTransgressionByDateList)
    //   : [];
    // const finalGroupDutyCountsByDateList = GetGroupDutyCountsByDateList
    //   ? this.getFinalGroupDutyCountsByDateList(GetGroupDutyCountsByDateList)
    //   : [];
    const finalUnbalancedNeighborsList = GetUnbalancedNeighborsList
      ? this.getUnbalancedNeighborsList(GetUnbalancedNeighborsList)
      : [];
    const finalMinDistancesList = GetMinDistancesList;
    // ? this.getMinDistancesList(GetMinDistancesList)
    //   : [];

    const defaultPlanning = { scoreId: 0, createdOn: 0, hardScore: 0, mediumScore: 0, softScore: 0 };
    const currentScore = this.notReadyYet() ? defaultPlanning : ScoreStore!.getById(this.state.planningId);
    const previousScore = this.notReadyYet() ? defaultPlanning : ScoreStore!.getById(this.state.planningId - 1);
    const nextScore = this.notReadyYet() ? defaultPlanning : ScoreStore!.getById(this.state.planningId + 1);
    const dutyDistribution = GetDutyCountChangesList ? this.calculateDutyDistribution(GetDutyCountChangesList) : [];
    const dayDutyDistribution = GetDutyCountChangesList
      ? this.calculateDayDutyDistribution(GetDutyCountChangesList)
      : [];
    const nightDutyDistribution = GetDutyCountChangesList
      ? this.calculateNightDutyDistribution(GetDutyCountChangesList)
      : [];
    const deltaDistribution = GetDutyCountChangesList ? this.calculateDeltaDistribution(GetDutyCountChangesList) : [];
    const deltaDayDistribution = GetDutyCountChangesList
      ? this.calculateDeltaDayDistribution(GetDutyCountChangesList)
      : [];
    const deltaNightDistribution = GetDutyCountChangesList
      ? this.calculateDeltaNightDistribution(GetDutyCountChangesList)
      : [];
    const ratioDistribution = GetDutyCountChangesList ? this.calculateRatioDistribution(GetDutyCountChangesList) : [];
    const prevRatioDistribution = GetDutyCountChangesList
      ? this.calculatePrevRatioDistribution(GetDutyCountChangesList)
      : [];
    const fridayDistribution = finalUnbalancedNeighborsList
      ? this.calculateFridayDistribution(finalUnbalancedNeighborsList)
      : [];
    const saturdayDistribution = finalUnbalancedNeighborsList
      ? this.calculateSaturdayDistribution(finalUnbalancedNeighborsList)
      : [];
    const sundayDistribution = finalUnbalancedNeighborsList
      ? this.calculateSundayDistribution(finalUnbalancedNeighborsList)
      : [];
    const weekendDistribution = finalUnbalancedNeighborsList
      ? this.calculateWeekendDistribution(finalUnbalancedNeighborsList)
      : [];
    const bankHolidayDistribution = finalUnbalancedNeighborsList
      ? this.calculateBankholidayDistribution(finalUnbalancedNeighborsList)
      : [];

    const selectedDate = this.state.selectedDate;
    const offset = this.state.offset;
    const savedPlanningId = this.state.savedPlanningId;
    const selectedPlanningId = this.state.selectedPlanningId;
    const savedPrevPlanningId = this.state.savedPrevPlanningId;
    const selectedStartRuleTransgressionDate = this.state.startDate; // selectedStartRuleTransgressionDate;
    const selectedEndRuleTransgressionDate = this.state.endDate; // selectedEndRuleTransgressionDate;
    const year = this.state.semesterYear;

    // const dataSource = new DataSource({
    //   store: GetTooCloseDutiesList,
    //   group: [{
    //     selector: "apbNumber",
    //     calculateGroupValue: (group) => {
    //       // const ecarts = group.items.map(i => i.ecart);
    //       // const avg = ecarts.reduce((a, b) => a + b, 0) / ecarts.length;

    //       // // On attache la moyenne à chaque ligne
    //       // group.items.forEach(item => {
    //       //   item.EcartAvg = avg;
    //       // });

    //       // return group.key; // valeur du groupement
    //     }
    //   }]
    // });

    const onGridReady = (e) => {
    // e.component = instance de la grille
    // e.component.on("optionChanged", (args) => {
    //   if (args.fullName === "filterValue") {
        let filter = e.component.getCombinedFilter();
        const rows = e.component.getDataSource().store().load({ filter: filter }).done(data => 
          this.setState({filteredData: data}));//getVisibleRows();
        //const filtered = rows.map(r => r.data);
        
    //   }
    // });
  };
    return (
      <MainSectionLayout isLoading={this.notReadyYet()} title={TLCode.ANALYSIS_MAIN_TITLE}>
        {this.notReadyYet() ? (
          <Container />
        ) : (
          <Container>
            <Card className={CardStyle.toString()}>
              <Tabs
                id="main"
                renderActiveTabPanelOnly={true}
                defaultSelectedTabId={TAB.PROBLEMS}
                selectedTabId={this.state.selectedTabId}
                onChange={this.handleTabChange}
              >
                <Tab
                  id={TAB.PROBLEMS}
                  title={
                    <span style={{ backgroundColor: '#f7c5c5' }}>
                      <TranslatedMessage id={TLCode.ANALYSIS_PROBLEMS} />
                    </span>
                  }
                  panel={
                    <span>
                      <div>
                        <span>
                          <DivLine>
                            <DivColumn>
                              <DivLine>{this.props.translate(TLCode.ANALYSIS_CLICK_SEMESTER)}</DivLine>
                              <DivLine>
                                {this.props.translate(TLCode.ROSTER_Year)}&nbsp;
                                <NumericInput
                                  style={{ width: '60px' }}
                                  min={2016}
                                  value={year}
                                  onValueChange={this.handleSemesterYearValueChange}
                                />
                                <ButtonGroup>
                                  <Button intent="primary" onClick={this.setS1}>
                                    <TranslatedMessage id={TLCode.ROSTER_S1} />
                                  </Button>
                                  &nbsp;&nbsp;
                                  <Button intent="primary" onClick={this.setS2}>
                                    <TranslatedMessage id={TLCode.ROSTER_S2} />
                                  </Button>
                                </ButtonGroup>
                              </DivLine>
                            </DivColumn>
                            <DivColumn>
                              <b>OU</b>
                            </DivColumn>
                            <DivColumn>
                              <DivLine>
                                <DivColumn style={{ width: '80px' }}>
                                  {this.props.translate(TLCode.ANALYSIS_PLANNINGID)}&nbsp;
                                </DivColumn>
                                <DivColumn style={{ width: '100px' }}>
                                  <Select
                                    options={selectableScoreList}
                                    value={selectedPlanningId}
                                    onChange={this.handleSelectedPlanningIdValueChange}
                                  />
                                  <InputGroup
                                    placeholder="PlanningId"
                                    value={savedPlanningId.toString()}
                                    onChange={(e) => {
                                      this.setState({ savedPlanningId: e.target.value });
                                    }}
                                  />
                                </DivColumn>
                              </DivLine>
                            </DivColumn>
                            <DivColumn>
                              <b>OU</b>
                            </DivColumn>
                            <DivColumn>
                              <DivLine>{this.props.translate(TLCode.ANALYSIS_PERIOD)}</DivLine>
                              <DivLine>
                                <span style={{ width: '100px' }}>
                                  <DateInput
                                    value={selectedDate}
                                    canClearSelection={false}
                                    onChange={(value) => {
                                      this.selectedDateChange(value);
                                    }}
                                  />
                                </span>
                              </DivLine>
                            </DivColumn>
                            <DivColumn>
                              <strong>ce qui donne</strong>
                            </DivColumn>
                            <DivColumn>
                              <DivLine>
                                {this.props.translate(TLCode.ANALYSIS_START)}&nbsp;&nbsp;
                                <span style={{ width: '100px' }}>
                                  <DateInput
                                    value={this.state.startDate}
                                    disabled={false}
                                    onChange={(value) => this.setState({ startDate: value })}
                                  />
                                </span>
                              </DivLine>
                              <DivLine>
                                {this.props.translate(TLCode.ANALYSIS_END)}&nbsp;&nbsp;
                                <span style={{ width: '100px' }}>
                                  <DateInput
                                    value={this.state.endDate}
                                    disabled={false}
                                    onChange={(value) => this.setState({ endDate: value })}
                                  />
                                </span>
                              </DivLine>
                            </DivColumn>
                            <DivColumn>
                              <Button intent="primary" icon={IconNames.CALCULATOR} onClick={this.search}>
                                <TranslatedMessage id={TLCode.ANALYSIS_Assess} />
                              </Button>
                              {this.props.AuthenticationStore!.isSuperAdmin &&
                                <Button intent="danger" icon={IconNames.CLEAN} onClick={this.enhance}>
                                  <TranslatedMessage id={TLCode.ANALYSIS_Enhance} />
                                </Button>}
                            </DivColumn>
                          </DivLine>
                        </span>
                        <br />
                        <p>
                          <b>
                            {this.props.translate(TLCode.ANALYSIS_GLOBAL_PERF)} {this.getGlobalPerformancePercentage()}%
                          </b>{' '}
                          <Tooltip
                            content={
                              <div>
                                <p>{this.props.translate(TLCode.ANALYSIS_GLOBAL_PERF_COMMENT)}</p>
                                <ul>
                                  <li>{this.props.translate(TLCode.TOO_CLOSE_DUTIES)}</li>
                                  <li>{this.props.translate(TLCode.ABNORMAL_DUTY_COUNTS)}</li>
                                </ul>
                              </div>
                            }
                          >
                            <Icon icon={IconNames.HELP} />
                          </Tooltip>
                        </p>
                      </div>
                      {/* <br /> */}
                      <Tabs
                        id="sub"
                        renderActiveTabPanelOnly={true}
                        defaultSelectedTabId={SUBTAB.TOOCLOSEDUTIES}
                        selectedTabId={this.state.selectedSubTabId}
                        onChange={this.handleSubTabChange}
                      >
                        <Tab
                          id={SUBTAB.TOOCLOSEDUTIES}
                          title={this.props.translate(TLCode.TOO_CLOSE_DUTIES)}
                          panel={
                            <span>
                              <p>
                                <b>Planning {savedPlanningId > -1 ? savedPlanningId : 'live'}</b>&nbsp;&nbsp;&nbsp;
                                <b>
                                  {this.props.translate(TLCode.TOO_CLOSE_DUTIES_DETAILS1)}[{this.state.lowerGapLimit}
                                  &nbsp;-&nbsp;{this.state.upperGapLimit}]&nbsp;&nbsp;&nbsp;
                                </b>
                                <b>{this.props.translate(TLCode.ANALYSIS_PERF)}</b>
                                <b>
                                  {this.props.translate(TLCode.ANALYSIS_SmallGaps)}
                                  &nbsp;
                                  {/* {(
                                    100 -
                                    (100 * this.state.nbrPharmaciesWithGapBelow) / this.state.nbrPharmacies
                                  ).toFixed(2)}
                                  % */}
                                </b>
                                &nbsp;{(100 * Math.exp(-0.02 * this.state.nbrPharmaciesWithGapBelow)).toFixed(1)}%
                                &nbsp;({this.state.nbrPharmaciesWithGapBelow})&nbsp;&nbsp;
                                {/* &nbsp;&nbsp;({this.state.nbrPharmaciesWithGapBelow} ph) */}
                                <b>
                                  &nbsp;{this.props.translate(TLCode.ANALYSIS_LargeGaps)}
                                  &nbsp;
                                  {/* {(
                                    100 -
                                    (100 * this.state.nbrPharmaciesWithGapAbove) / this.state.nbrPharmacies
                                  ).toFixed(2)}
                                  % */}
                                </b>
                                &nbsp;{(100 * Math.exp(-0.02 * this.state.nbrPharmaciesWithGapAbove)).toFixed(1)}%
                                &nbsp;({this.state.nbrPharmaciesWithGapAbove})
                                &nbsp;&nbsp;
                                {/* &nbsp;&nbsp;({this.state.nbrPharmaciesWithGapAbove} ph)&nbsp;&nbsp; */}
                                {/* {this.props.translate(TLCode.ON_A_TOTAL_OF)}
                                {this.state.nbrPharmacies} */}
                              </p>
                              <DivLine style={{ width: '600px' }}>
                                <DivColumn style={{ width: '250px' }}>
                                  <DivLine>
                                    {this.props.translate(TLCode.ANALYSIS_LOWER_GAP_LIMIT)}
                                    <NumericInput
                                      style={{ width: '60px' }}
                                      value={this.state.lowerGapLimit}
                                      onValueChange={this.handleLowerGapLimitChange}
                                    />
                                  </DivLine>
                                </DivColumn>
                                <DivColumn style={{ width: '250px' }}>
                                  <DivLine>
                                    {this.props.translate(TLCode.ANALYSIS_UPPER_GAP_LIMIT)}
                                    <NumericInput
                                      style={{ width: '60px' }}
                                      value={this.state.upperGapLimit}
                                      onValueChange={this.handleUpperGapLimitChange}
                                    />
                                  </DivLine>
                                </DivColumn>
                              </DivLine>

                              {/* <p>{this.props.translate(TLCode.PHARMACY_LINKS_NOTICE)}</p> */}

                              <DataGrid
                                ref={this.gapDataGridRef}
                                dataSource={GetTooCloseDutiesListFilteredGapLimit}
                                allowColumnReordering={true}
                                rowAlternationEnabled={true}
                                showBorders={true}
                                width="100%"
                                allowColumnResizing={true}
                                columnResizingMode={'widget'}
                                onExporting={this.onExportingEcarts}
                                onRowClick={this.onRowDoubleClicked}
                                onContentReady={this.onGapOptionChanged}
                              >
                                <FilterRow visible={true} applyFilter={'auto'} />
                                <FilterPanel visible={true} />
                                <HeaderFilter visible={true} />
                                <GroupPanel visible={true} />
                                <SearchPanel visible={true} highlightCaseSensitive={true} width={300} />
                                <Grouping autoExpandAll={false} />
                                <ColumnChooser enabled={true} />
                                <Export enabled={true} />

                                <Column
                                  dataField="group"
                                  caption={this.props.translate(TLCode.TOO_CLOSE_DUTIES_PHARMACY_GROUP)}
                                  minWidth={120}
                                  width={120}
                                />
                                <Column
                                  dataField="apbNumber"
                                  caption={this.props.translate(TLCode.TOO_CLOSE_DUTIES_PHARMACY)}
                                  minWidth={70}
                                  width={90}
                                  defaultSortOrder="asc"
                                  sortIndex={1}
                                />
                                <Column
                                  dataField="pharmacyName"
                                  caption={this.props.translate(TLCode.TOO_CLOSE_DUTIES_PHARMACY_NAME)}
                                  minWidth={70}
                                  width={250}
                                />
                                <Column
                                  dataField="city"
                                  caption={this.props.translate(TLCode.PHARMACIES_City)}
                                  minWidth={120}
                                  width={180}
                                />
                                <Column
                                  dataField="zipCode"
                                  caption={this.props.translate(TLCode.PHARMACIES_ZipCode)}
                                  minWidth={90}
                                  width={90}
                                />
                                <Column
                                  name='day1'
                                  caption={this.props.translate(TLCode.GROUPANALYSIS_WEEKDAY1)}
                                  dataField="weekday1"
                                  allowSorting={true}
                                  allowFiltering={false}
                                  allowHeaderFiltering={true}
                                  alignment="left"
                                  width={100}
                                />
                                <Column
                                  dataField="date1"
                                  caption={this.props.translate(TLCode.TOO_CLOSE_DUTIES_DATE1)}
                                  minWidth={90}
                                  width={120}
                                  dataType="date"
                                  format="EEE. dd/MM/yyyy"
                                />
                                <Column
                                  name='day2'
                                  caption={this.props.translate(TLCode.GROUPANALYSIS_WEEKDAY2)}
                                  dataField="weekday2"
                                  allowSorting={true}
                                  allowFiltering={false}
                                  allowHeaderFiltering={true}
                                  alignment="left"
                                  width={100}
                                />
                                <Column
                                  dataField="date2"
                                  caption={this.props.translate(TLCode.TOO_CLOSE_DUTIES_DATE2)}
                                  minWidth={90}
                                  width={120}
                                  dataType="date"
                                  format="EEE. dd/MM/yyyy"
                                />
                                <Column
                                  dataField="ecart"
                                  caption={this.props.translate(TLCode.TOO_CLOSE_DUTIES_ECART)}
                                  minWidth={100}
                                  width={100}
                                />
                                <Summary calculateCustomSummary={this.calculateCustomSummaryGaps}>
                                  <TotalItem
                                    name="%Below"
                                    summaryType="custom"
                                    showInColumn="ecart"
                                    displayFormat="Δ trop petits {0}"
                                    valueFormat={{ type: 'fixedPoint', precision: 0 }}
                                  />
                                  <TotalItem
                                    name="%Above"
                                    summaryType="custom"
                                    showInColumn="ecart"
                                    displayFormat="Δ trop grands {0}"
                                    valueFormat={{ type: 'fixedPoint', precision: 0 }}
                                  />
                                </Summary>
                                <Pager
                                  visible={true}
                                  allowedPageSizes={[5, 10, 20, 50, 100]}
                                  showPageSizeSelector={true}
                                  showInfo={true}
                                  showNavigationButtons={true}
                                />
                                <Paging defaultPageSize={20} />
                              </DataGrid>
                            </span>
                          }
                        />
                        <Tab
                          id={SUBTAB.UNEVEN_DUTY_INTERVALS}
                          title={this.props.translate(TLCode.UNEVEN_DUTY_INTERVALS)}
                          panel={
                            <span>
                              {/* <p>
                                <b>Planning {savedPlanningId > -1 ? savedPlanningId : 'live'}</b>&nbsp;&nbsp;&nbsp;
                                <b>
                                  {this.props.translate(TLCode.TOO_CLOSE_DUTIES_DETAILS1)}[{this.state.lowerGapLimit}
                                  &nbsp;-&nbsp;{this.state.upperGapLimit}]&nbsp;&nbsp;&nbsp;
                                </b>
                                <b>
                                  {this.props.translate(TLCode.ANALYSIS_PERF)}
                                  {MatchStore!.miscDatas['GetTooCloseDutiesPerformance']}%&nbsp;&nbsp;&nbsp;
                                </b>
                                {MatchStore!.miscDatas['GetTooCloseDutiesCount']}
                                {this.props.translate(TLCode.ON_A_TOTAL_OF)}
                                {MatchStore!.miscDatas['GetTooCloseDutiesMaximum']}
                                {this.props.translate(TLCode.DUTIES)}(
                                {MatchStore!.miscDatas['GetTooCloseDutiesPercentage']}%)
                              </p>
                              <p>{this.props.translate(TLCode.PHARMACY_LINKS_NOTICE)}</p> */}
                              <DivLine>
                                <Tabs id="id1">
                                  <Tab id="id2" title='table'
                                  panel={
                              <DataGrid
                                ref={this.spreadingDataGridRef}
                                dataSource={grp}
                                allowColumnReordering={true}
                                rowAlternationEnabled={true}
                                showBorders={true}
                                width="100%"
                                allowColumnResizing={true}
                                columnResizingMode={'widget'}
                                onExporting={this.onExportingEcarts}
                                //onRowDblClick={this.onScoreSelectedV2}
                                onRowClick={this.onRowDoubleClicked}
                                //onOptionChanged={onGridReady}
                                onContentReady={onGridReady}
                                onInitialized={onGridReady}
                              >
                                <SortByGroupSummaryInfo summaryItem="ecartStdev" sortOrder="desc" />
                                <FilterRow visible={true} applyFilter={'auto'} />
                                <FilterPanel visible={true} />
                                <HeaderFilter visible={true} />
                                <GroupPanel visible={true} />
                                <SearchPanel visible={true} highlightCaseSensitive={true} width={300} />
                                <Grouping autoExpandAll={false} />
                                <ColumnChooser enabled={true} />
                                <Export enabled={true} />
                                <Column
                                  dataField="group"
                                  caption={this.props.translate(TLCode.TOO_CLOSE_DUTIES_PHARMACY_GROUP)}
                                  minWidth={120}
                                  width={120}
                                />
                                {/* <Column
                                  //dataField="apbNumber"
                                  calculateCellValue={(data) => data.apbNumber + ' - ' + data.pharmacyName}
                                  caption="APB - nom"
                                  allowGrouping={true}
                                  allowSorting={true}
                                /> */}
                                <Column
                                  dataField="apbNumber"
                                  caption={this.props.translate(TLCode.TOO_CLOSE_DUTIES_PHARMACY)}
                                  minWidth={70}
                                  width={90}
                                  defaultSortOrder="asc"
                                  sortIndex={1}
                                  allowGrouping={true}
                                />
                                <Column
                                  dataField="pharmacyName"
                                  caption={this.props.translate(TLCode.TOO_CLOSE_DUTIES_PHARMACY_NAME)}
                                  minWidth={250}
                                  width={500}
                                />
                                <Column
                                  dataType="string"
                                  dataField="zipCode"
                                  caption={this.props.translate(TLCode.PHARMACIES_ZipCode)}
                                  width={55}
                                  hidingPriority={3}
                                  allowSearch={false}
                                />
                                <Column
                                  dataType="string"
                                  dataField="city"
                                  caption={this.props.translate(TLCode.PHARMACIES_City)}
                                  width={160}
                                  hidingPriority={2}
                                  allowSearch={true}
                                />
                                <Column
                                  caption="Ecart moyen"
                                  dataField="ecartMoy"
                                  defaultSortOrder="asc"
                                  sortIndex={0}
                                />
                                <Column
                                  caption="Dispersion des écarts"
                                  dataField="ecartStdev"
                                  defaultSortOrder="asc"
                                  format="0.00"
                                />
                                <Column
                                  caption="Nbre d'écarts"
                                  dataField="ecartCnt"
                                  defaultSortOrder="asc"
                                />
                                <Pager
                                  visible={true}
                                  allowedPageSizes={[20, 50, 100, 'all']}
                                  showPageSizeSelector={true}
                                  showInfo={true}
                                  showNavigationButtons={true}
                                />
                                <Paging defaultPageSize={20} />
                              </DataGrid>
                                  }>

                                  </Tab>
                                  <Tab id="id3" title='graphe'
                                  panel={
                              <DivLine style={{  border: "1px solid black", height: 500, width: 750 }}>
                              <ScatterChart
                                style={{ width: '500px'}} //, maxWidth: '700px', maxHeight: '70vh', aspectRatio: 1.618 }}
                                //responsive
                                width={700}
                                height={500}
                                margin={{
                                  top: 20,
                                  right: 0,
                                  bottom: 0,
                                  left: 0,
                                }}
                              >
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis type="number" dataKey="ecartMoy" name="moy" unit="j"  />
                                <YAxis type="number" dataKey="ecartStdev" name="var" unit="j" domain={[0, 60]} tickFormatter={(val) => val.toFixed(2)}/>
                                <ChartTooltip dataKey="apbnr" content={<CustomTooltip />} />
                                <Scatter activeShape={{ fill: 'red' }} name="A school" data={this.state.filteredData} fill="#8884d8" />
                              </ScatterChart>
                              </DivLine>
                                  }>


                                  </Tab>
                                </Tabs>
                              </DivLine>
                              {/* <DataGrid
                                dataSource={GetTooCloseDutiesList}
                                allowColumnReordering={true}
                                rowAlternationEnabled={true}
                                showBorders={true}
                                width="100%"
                                allowColumnResizing={true}
                                columnResizingMode={'widget'}
                                onExporting={this.onExportingEcarts}
                                //onRowDblClick={this.onScoreSelectedV2}
                                onRowClick={this.onRowDoubleClicked}
                              >
                                <SortByGroupSummaryInfo summaryItem="ecartStdev" sortOrder="desc" />
                                <FilterRow visible={true} applyFilter={'auto'} />
                                <FilterPanel visible={true} />
                                <HeaderFilter visible={true} />
                                <GroupPanel visible={true} />
                                <SearchPanel visible={true} highlightCaseSensitive={true} width={300} />
                                <Grouping autoExpandAll={false} />
                                <ColumnChooser enabled={true} />
                                <Export enabled={true} />

                                <Column
                                  dataField="group"
                                  caption={this.props.translate(TLCode.TOO_CLOSE_DUTIES_PHARMACY_GROUP)}
                                  minWidth={120}
                                  width={120}
                                />
                                <Column
                                  //dataField="apbNumber"
                                  calculateCellValue={(data) => data.apbNumber + ' - ' + data.pharmacyName}
                                  caption="APB - nom"
                                  groupIndex={0}
                                  allowGrouping={true}
                                  allowSorting={true}
                                />
                                <Column
                                  dataField="apbNumber"
                                  caption={this.props.translate(TLCode.TOO_CLOSE_DUTIES_PHARMACY)}
                                  minWidth={70}
                                  width={90}
                                  defaultSortOrder="asc"
                                  sortIndex={1}
                                  allowGrouping={true}
                                />
                                <Column
                                  dataField="pharmacyName"
                                  caption={this.props.translate(TLCode.TOO_CLOSE_DUTIES_PHARMACY_NAME)}
                                  minWidth={250}
                                  width={500}
                                />
                                <Column
                                  dataField="date1"
                                  caption={this.props.translate(TLCode.TOO_CLOSE_DUTIES_DATE1)}
                                  minWidth={90}
                                  width={150}
                                  dataType="date"
                                  format="dd/MM/yyyy"
                                />
                                <Column
                                  dataField="date2"
                                  caption={this.props.translate(TLCode.TOO_CLOSE_DUTIES_DATE2)}
                                  minWidth={90}
                                  width={150}
                                  dataType="date"
                                  format="dd/MM/yyyy"
                                />
                                <Column
                                  dataField="ecart"
                                  caption={this.props.translate(TLCode.TOO_CLOSE_DUTIES_ECART)}
                                  minWidth={30}
                                  width={40}
                                />
                                <Column
                                  dataField="ecartMoy"
                                  defaultSortOrder="asc"
                                  sortIndex={0}
                                />
                                                                <Column
                                  dataField="ecartStdev"
                                  defaultSortOrder="asc"
                                />
                                                                <Column
                                  dataField="ecartCnt"
                                  defaultSortOrder="asc"
                                />
                                <Summary calculateCustomSummary={calculateCustomSummary}>
                                  <GroupItem
                                    column="ecart"
                                    summaryType="max"
                                    displayFormat="max {0}"
                                    showInGroupFooter={false}
                                    //showInColumn="date1"
                                    alignByColumn={true}
                                    valueFormat={{ type: 'fixedPoint', precision: 3 }}
                                  />
                                  <GroupItem
                                    column="ecart"
                                    summaryType="avg"
                                    displayFormat="μ {0}"
                                    showInGroupFooter={false}
                                    //showInColumn="date2"
                                    alignByColumn={true}
                                    valueFormat={{ type: 'fixedPoint', precision: 3 }}
                                  />
                                  <GroupItem
                                    name="ecartStdev"
                                    column="ecart"
                                    summaryType="custom"
                                    displayFormat="σ {0}"
                                    showInGroupFooter={false}
                                    alignByColumn={true}
                                    valueFormat={{ type: 'fixedPoint', precision: 3 }}
                                  />
                                  <TotalItem
                                    name="ecartMoy"
                                    column="ecart"
                                    summaryType="avg"
                                    displayFormat="μTot {0}"
                                    valueFormat={{ type: 'fixedPoint', precision: 3 }}
                                  />
                                  <TotalItem
                                    name="ecartStdev"
                                    column="ecart"
                                    summaryType="custom"
                                    displayFormat="σTot {0}"
                                    valueFormat={{ type: 'fixedPoint', precision: 3 }}
                                  />
                                </Summary>
                                <Pager
                                  visible={true}
                                  allowedPageSizes={[5, 10, 20, 50, 100]}
                                  showPageSizeSelector={true}
                                  showInfo={true}
                                  showNavigationButtons={true}
                                />
                                <Paging defaultPageSize={20} />
                              </DataGrid> */}
                            </span>
                          }
                        />
                        <Tab
                          id={SUBTAB.DUTYCOUNTCHANGES}
                          title={this.props.translate(TLCode.DUTY_COUNT_CHANGES_TITLE)}
                          panel={
                            <span>
                              <p>
                                <b>Planning {savedPlanningId > -1 ? savedPlanningId : 'live'}</b>&nbsp;&nbsp;&nbsp;
                                {/* <p><b>Planning {savedPlanningId>-1?savedPlanningId:'live'}</b>&nbsp;&nbsp;&nbsp; */}
                                <b>Total:</b> {this.calculateCurrDutyTotal(GetDutyCountChangesList)}
                                &nbsp;&nbsp;&nbsp;
                                <b>préc.</b> {this.calculatePrevDutyTotal(GetDutyCountChangesList)}&nbsp;&nbsp;
                                <b>Δ</b>{' '}
                                {this.calculateCurrDutyTotal(GetDutyCountChangesList) -
                                  this.calculatePrevDutyTotal(GetDutyCountChangesList)}
                                &nbsp;&nbsp;&nbsp;&nbsp;---
                                <b>Jours seuls:</b> {this.calculateCurrDayDutyTotal(GetDutyCountChangesList)}
                                &nbsp;&nbsp;&nbsp;<b>préc.</b> {this.calculatePrevDayDutyTotal(GetDutyCountChangesList)}
                                &nbsp;&nbsp;<b>Δ</b>{' '}
                                {this.calculateCurrDayDutyTotal(GetDutyCountChangesList) -
                                  this.calculatePrevDayDutyTotal(GetDutyCountChangesList)}
                                &nbsp;&nbsp;&nbsp;&nbsp;---
                                <b>Jours + Nuits:</b> {this.calculateCurrNightDutyTotal(GetDutyCountChangesList)}
                                &nbsp;&nbsp;&nbsp;<b>préc.</b>{' '}
                                {this.calculatePrevNightDutyTotal(GetDutyCountChangesList)}&nbsp;&nbsp;<b>Δ</b>{' '}
                                {this.calculateCurrNightDutyTotal(GetDutyCountChangesList) -
                                  this.calculatePrevNightDutyTotal(GetDutyCountChangesList)}
                              </p>
                              <Tabs
                                id="subDutyCountChanges"
                                renderActiveTabPanelOnly={true}
                                defaultSelectedTabId={SUBSUBTAB.DUTYCOUNTCHANGESGRID}
                                selectedTabId={this.state.selectedDutyCountSubTabId}
                                onChange={this.handleSubSubTabChange}
                              >
                                <Tab
                                  id={SUBSUBTAB.DUTYCOUNTCHANGESGRID}
                                  title={this.props.translate(TLCode.DUTY_COUNT_CHANGES_LIST_TITLE)}
                                  panel={
                                    <>
                                      {' '}
                                      <p>
                                        {this.props.translate(TLCode.DUTY_COUNT_CHANGES_EXPLANATION_1)}
                                        &nbsp;&nbsp;&nbsp;
                                        {this.props.translate(TLCode.DUTY_COUNT_CHANGES_EXPLANATION_2)}
                                      </p>
                                      <DataGrid
                                      >

                                      </DataGrid>
                                      <DataGrid
                                        dataSource={finalDutyCountChangesList}
                                        allowColumnReordering={true}
                                        rowAlternationEnabled={true}
                                        showBorders={true}
                                        width="100%"
                                        allowColumnResizing={true}
                                        columnResizingMode={'widget'}
                                        onExporting={this.onExportingDifferences}
                                        onRowClick={this.onRowDoubleClicked}
                                        columnHidingEnabled={true}
                                        // onContentReady={(e) => {
                                        //   if (UiStore!.diagnosticPageActiveSubSubTab !== SUBSUBTAB.DUTYCOUNTCHANGESGRID) return;
                                        //    if (this.state.suStdev != e.component.getTotalSummaryValue("suStdev")) {
                                        //      this.setState({ suStdev : e.component.getTotalSummaryValue("suStdev")})
                                        //    }
                                        //   if (this.state.saStdev != e.component.getTotalSummaryValue("saStdev")) {
                                        //       this.setState({ saStdev : e.component.getTotalSummaryValue("saStdev")})
                                        //   }
                                        //  }}
                                        onContentReady={this.onDutyCountOptionChanged}
                                        onCellPrepared={(e) => {
                                          if (e.rowType === 'group') {
                                            console.log(e); console.log(e.column.caption); console.log(e.cellElement);
                                            if (
                                              //e.column.caption === 'DI' || e.column.caption === 'SA'
                                              //|| e.column.caption === 'N courant' || e.column.caption === 'fériés'
                                              e.column.caption === 'Total courant' ||
                                              e.column.dataField === 'currSaturdays' || e.column.dataField === 'currSundays'
                                              || e.column.caption === 'J courant' || e.column.dataField === 'currNight' || e.column.dataField === 'currBankHolidays'

                                            ) {

                                              // On suppose que le summary est celui de type "custom"
                                              if (e["summaryItems"][2].value > 1) {
                                                e.cellElement.style.backgroundColor = '#ffebee';
                                                e.cellElement.style.color = '#c62828';
                                                e.cellElement.style.fontWeight = 'bold';
                                              } else {
                                                e.cellElement.style.backgroundColor = '#e8f5e9';
                                                e.cellElement.style.color = '#2e7d32';
                                              }
                                            }
                                          }
                                        }
                                        }
                                      >
                                        <FilterRow visible={true} applyFilter={'auto'} />
                                        <FilterPanel visible={true} />
                                        <HeaderFilter visible={true} />
                                        <GroupPanel visible={true} />
                                        <SearchPanel visible={true} highlightCaseSensitive={true} width={300} />
                                        <Grouping autoExpandAll={false} />
                                        <ColumnChooser enabled={true} />
                                        <Export enabled={true} />
                                        <Column
                                          dataField="apbNumber"
                                          caption={this.props.translate(TLCode.DUTY_COUNT_CHANGES_APBNUMBER)}
                                          minWidth={70}
                                          width={70}
                                          defaultSortOrder="asc"
                                          sortIndex={1}
                                        />
                                        <Column
                                          dataField="group"
                                          caption={this.props.translate(TLCode.TOO_CLOSE_DUTIES_PHARMACY_GROUP)}
                                          minWidth={100}
                                          width={100}
                                          groupIndex={0}
                                        />
                                        <Column
                                          dataField="pharmacyName"
                                          caption={this.props.translate(TLCode.TOO_CLOSE_DUTIES_PHARMACY_NAME)}
                                          minWidth={100}
                                          width={100}
                                        />
                                        <Column
                                          dataField="anchor"
                                          caption={this.props.translate(TLCode.PHARMACIES_Anchor)}
                                          minWidth={100}
                                          width={100}
                                        />
                                        <Column
                                          dataField="target"
                                          caption={this.props.translate(TLCode.DUTY_COUNT_CHANGES_GROUP_TARGET)}
                                          minWidth={60}
                                          width={60}
                                          cssClass={targetColor}
                                        />
                                        <Column
                                          name="count"
                                          dataField="currDay"
                                          caption={this.props.translate(TLCode.DUTY_COUNT_CHANGES_CURRDAY)}
                                          minWidth={60}
                                          width={80}
                                          cssClass={countColor}
                                        />
                                        <Column
                                          name="deltaTotal"
                                          caption={this.props.translate(
                                            TLCode.DUTY_COUNT_CHANGES_GROUP_TARGET_DIFFERENCE,
                                          )}
                                          calculateCellValue={(rowData) =>
                                            Number.isNaN(rowData.currDay - rowData.target)
                                              ? 0
                                              : rowData.currDay - rowData.target
                                          }
                                          minWidth={50}
                                          width={80}
                                          allowSorting
                                        />
                                        <Column
                                          dataField="dayTarget"
                                          caption={this.props.translate(TLCode.DUTY_COUNT_CHANGES_GROUP_DAY_TARGET)}
                                          minWidth={50}
                                          width={60}
                                          cssClass={dayTargetColor}
                                        />
                                        <Column
                                          name="dayCount"
                                          caption={this.props.translate(TLCode.DUTY_COUNT_CHANGES_CURRDAYONLY)}
                                          calculateCellValue={(rowData) =>
                                            Number.isNaN(rowData.currDay - rowData.currNight)
                                              ? null
                                              : rowData.currDay - rowData.currNight
                                          }
                                          minWidth={60}
                                          width={80}
                                          allowSorting
                                          cssClass={dayCountColor}
                                        />
                                        <Column
                                          name="deltaJ"
                                          caption="Δ J"
                                          calculateCellValue={(rowData) =>
                                            Number.isNaN(rowData.currDay - rowData.currNight)
                                              ? 0
                                              : rowData.currDay - rowData.currNight - rowData.dayTarget
                                          }
                                          minWidth={60}
                                          width={70}
                                          allowSorting
                                        />
                                        <Column
                                          dataField="nightTarget"
                                          caption={this.props.translate(TLCode.DUTY_COUNT_CHANGES_GROUP_NIGHT_TARGET)}
                                          minWidth={60}
                                          width={80}
                                          cssClass={nightTargetColor}
                                        />
                                        <Column
                                          name="nightCount"
                                          dataField="currNight"
                                          caption={this.props.translate(TLCode.DUTY_COUNT_CHANGES_CURRNIGHT)}
                                          minWidth={60}
                                          width={80}
                                          cssClass={nightCountColor}
                                        />
                                        <Column
                                          name="deltaN"
                                          caption="Δ N"
                                          calculateCellValue={(rowData) =>
                                            Number.isNaN(rowData.currNight - rowData.nightTarget)
                                              ? 0
                                              : rowData.currNight - rowData.nightTarget
                                          }
                                          minWidth={80}
                                          width={80}
                                          allowSorting
                                        />
                                        {/* <Column
                                          dataField="currFridays"
                                          caption="VE"
                                          minWidth={50}
                                          width={50}
                                        /> */}
                                        <Column
                                          dataField="currSaturdays"
                                          caption="SA" //{this.props.translate(TLCode.UNBALANCED_NEIGHBORS_SATURDAYS)}
                                          minWidth={60}
                                          width={90}
                                          cssClass={saturdayCountColor}
                                        />
                                        <Column dataField="yearSaturdays" caption="SA/an" minWidth={60} width={90} />
                                        <Column
                                          dataField="currSundays"
                                          caption="DI" //{this.props.translate(TLCode.UNBALANCED_NEIGHBORS_SUNDAYS)}
                                          minWidth={60}
                                          width={90}
                                          cssClass={sundayCountColor}
                                        />
                                        <Column dataField="yearSundays" caption="DI/an" minWidth={60} width={90} />
                                        <Column
                                          dataField="currBankHolidays"
                                          caption='fériés' //{this.props.translate(TLCode.UNBALANCED_NEIGHBORS_HOLIDAYS)}
                                          minWidth={60}
                                          width={90}
                                        />
                                        <Column
                                          dataField="yearBankHolidays"
                                          caption={this.props.translate(TLCode.UNBALANCED_NEIGHBORS_YEAR_HOLIDAYS)}
                                          minWidth={60}
                                          width={90}
                                        />
                                        <Column dataField="bPs" caption="BPs" minWidth={50} width={50} />
                                        <Column
                                          dataField="daysOff"
                                          caption="Days Off"
                                          minWidth={65}
                                          width={65}
                                          hidingPriority={2}
                                        />
                                        <Column
                                          dataField="prevAll"
                                          caption={this.props.translate(
                                            TLCode.ABNORMAL_DUTY_COUNTS_DUTY_COUNT_PREV_SEM,
                                          )}
                                          minWidth={60}
                                          width={70}
                                          hidingPriority={1}
                                        />
                                        <Summary calculateCustomSummary={calculateCustomSummary}>
                                          <GroupItem
                                            column="target"
                                            summaryType="avg"
                                            displayFormat="{0}"
                                            showInGroupFooter={false}
                                            alignByColumn={true}
                                          />
                                          <GroupItem
                                            column="dayTarget"
                                            summaryType="avg"
                                            displayFormat="{0}"
                                            showInGroupFooter={false}
                                            alignByColumn={true}
                                          />
                                          <GroupItem
                                            column="nightTarget"
                                            summaryType="avg"
                                            displayFormat="{0}"
                                            showInGroupFooter={false}
                                            alignByColumn={true}
                                          />
                                          <GroupItem
                                            column="count"
                                            summaryType="avg"
                                            displayFormat="μ {0}"
                                            showInGroupFooter={false}
                                            alignByColumn={true}
                                            valueFormat={{ type: 'fixedPoint', precision: 3 }}
                                          />
                                          <GroupItem
                                            name="countStdev"
                                            column="count"
                                            summaryType="custom"
                                            displayFormat="σ {0}"
                                            showInGroupFooter={false}
                                            alignByColumn={true}
                                            valueFormat={{ type: 'fixedPoint', precision: 3 }}
                                          />
                                          <GroupItem
                                            column="dayCount"
                                            summaryType="avg"
                                            displayFormat="μ {0}"
                                            showInGroupFooter={false}
                                            alignByColumn={true}
                                            valueFormat={{ type: 'fixedPoint', precision: 3 }}
                                          />
                                          <GroupItem
                                            name="dayCountStdev"
                                            column="dayCount"
                                            summaryType="custom"
                                            displayFormat="σ {0}"
                                            showInGroupFooter={false}
                                            alignByColumn={true}
                                            valueFormat={{ type: 'fixedPoint', precision: 3 }}
                                          />
                                          <GroupItem
                                            column="nightCount"
                                            summaryType="avg"
                                            displayFormat="μ {0}"
                                            showInGroupFooter={false}
                                            alignByColumn={true}
                                            valueFormat={{ type: 'fixedPoint', precision: 3 }}
                                          />
                                          <GroupItem
                                            name="nightCountStdev"
                                            column="nightCount"
                                            summaryType="custom"
                                            displayFormat="σ {0}"
                                            showInGroupFooter={false}
                                            alignByColumn={true}
                                            valueFormat={{ type: 'fixedPoint', precision: 3 }}
                                          />
                                          <GroupItem
                                            name="totalCountRange"
                                            column="count"
                                            summaryType="custom"
                                            displayFormat="range {0}"
                                            showInGroupFooter={false}
                                            alignByColumn={true}
                                            valueFormat={{ type: 'fixedPoint', precision: 3 }}
                                          />
                                          <GroupItem
                                            name="totalCountSwaps"
                                            column="deltaTotal"
                                            summaryType="custom"
                                            displayFormat="swaps {0}"
                                            showInGroupFooter={false}
                                            alignByColumn={true}
                                            valueFormat={{ type: 'fixedPoint', precision: 0 }}
                                          />

                                          <GroupItem
                                            name="dayCountRange"
                                            column="dayCount"
                                            summaryType="custom"
                                            displayFormat="range {0}"
                                            showInGroupFooter={false}
                                            alignByColumn={true}
                                            valueFormat={{ type: 'fixedPoint', precision: 3 }}
                                          />
                                          <GroupItem
                                            name="dayCountSwaps"
                                            column="deltaJ"
                                            summaryType="custom"
                                            displayFormat="swaps {0}"
                                            showInGroupFooter={false}
                                            alignByColumn={true}
                                            valueFormat={{ type: 'fixedPoint', precision: 0 }}
                                          />
                                          <GroupItem
                                            name="nightCountRange"
                                            column="nightCount"
                                            summaryType="custom"
                                            displayFormat="range {0}"
                                            showInGroupFooter={false}
                                            alignByColumn={true}
                                            valueFormat={{ type: 'fixedPoint', precision: 3 }}
                                          />
                                          <GroupItem
                                            name="nightCountSwaps"
                                            column="deltaN"
                                            summaryType="custom"
                                            displayFormat="swaps {0}"
                                            showInGroupFooter={false}
                                            alignByColumn={true}
                                            valueFormat={{ type: 'fixedPoint', precision: 0 }}
                                          />
                                          <GroupItem
                                            column="currSaturdays"
                                            summaryType="avg"
                                            displayFormat="μ {0}"
                                            showInGroupFooter={false}
                                            alignByColumn={true}
                                            valueFormat={{ type: 'fixedPoint', precision: 3 }}
                                          />
                                          <GroupItem
                                            name="currSaturdaysStdev"
                                            column="currSaturdays"
                                            summaryType="custom"
                                            displayFormat="σ {0}"
                                            showInGroupFooter={false}
                                            alignByColumn={true}
                                            valueFormat={{ type: 'fixedPoint', precision: 3 }}
                                          />
                                          <GroupItem
                                            name="saturdayCountRange"
                                            column="currSaturdays"
                                            summaryType="custom"
                                            displayFormat="range {0}"
                                            showInGroupFooter={false}
                                            alignByColumn={true}
                                            valueFormat={{ type: 'fixedPoint', precision: 3 }}
                                          />
                                          <GroupItem
                                            column="currSundays"
                                            summaryType="avg"
                                            displayFormat="μ {0}"
                                            showInGroupFooter={false}
                                            alignByColumn={true}
                                            valueFormat={{ type: 'fixedPoint', precision: 3 }}
                                          />
                                          <GroupItem
                                            name="currSundaysStdev"
                                            column="currSundays"
                                            summaryType="custom"
                                            displayFormat="σ {0}"
                                            showInGroupFooter={false}
                                            alignByColumn={true}
                                            valueFormat={{ type: 'fixedPoint', precision: 3 }}
                                          />
                                          <GroupItem
                                            name="sundayCountRange"
                                            column="currSundays"
                                            summaryType="custom"
                                            displayFormat="range {0}"
                                            showInGroupFooter={false}
                                            alignByColumn={true}
                                            valueFormat={{ type: 'fixedPoint', precision: 3 }}
                                          />
                                          <GroupItem
                                            name="saturdaySwaps"
                                            column="currSaturdays"
                                            summaryType="custom"
                                            displayFormat="swaps {0}"
                                            showInGroupFooter={false}
                                            alignByColumn={true}
                                            valueFormat={{ type: 'fixedPoint', precision: 0 }}
                                          />
                                          <GroupItem
                                            name="sundaySwaps"
                                            column="currSundays"
                                            summaryType="custom"
                                            displayFormat="swaps {0}"
                                            showInGroupFooter={false}
                                            alignByColumn={true}
                                            valueFormat={{ type: 'fixedPoint', precision: 0 }}
                                          />
                                          <TotalItem
                                            name="deltaTotalMoy"
                                            column="deltaTotal"
                                            summaryType="avg"
                                            displayFormat="μ ΔTot {0}"
                                            valueFormat={{ type: 'fixedPoint', precision: 2 }}
                                          />
                                          <TotalItem
                                            name="deltaJMoy"
                                            column="deltaJ"
                                            summaryType="avg"
                                            displayFormat="μ ΔJ {0}"
                                            valueFormat={{ type: 'fixedPoint', precision: 2 }}
                                          />
                                          <TotalItem
                                            name="deltaNMoy"
                                            column="deltaN"
                                            summaryType="avg"
                                            displayFormat="μ ΔN {0}"
                                            valueFormat={{ type: 'fixedPoint', precision: 2 }}
                                          />
                                          <TotalItem
                                            name="suMoy"
                                            column="currSundays"
                                            summaryType="avg"
                                            displayFormat="SU μTot {0}"
                                            valueFormat={{ type: 'fixedPoint', precision: 3 }}
                                          />
                                          <TotalItem
                                            name="suStdev"
                                            column="currSundays"
                                            summaryType="custom"
                                            displayFormat="SU σTot {0}"
                                            valueFormat={{ type: 'fixedPoint', precision: 3 }}
                                          />
                                          <TotalItem
                                            name="saMoy"
                                            column="currSaturdays"
                                            summaryType="avg"
                                            displayFormat="SA μTot {0}"
                                            valueFormat={{ type: 'fixedPoint', precision: 3 }}
                                          />
                                          <TotalItem
                                            name="saStdev"
                                            column="currSaturdays"
                                            summaryType="custom"
                                            displayFormat="SA σTot {0}"
                                            valueFormat={{ type: 'fixedPoint', precision: 3 }}
                                          />
                                          <GroupItem
                                            name="bkhMoyGrp"
                                            column="currBankHolidays"
                                            summaryType="avg"
                                            displayFormat="μTot {0}"
                                            valueFormat={{ type: 'fixedPoint', precision: 3 }}
                                            showInGroupFooter={false}
                                            alignByColumn={true}
                                          />
                                          <GroupItem
                                            name="bkhStdevGrp"
                                            column="currBankHolidays"
                                            summaryType="custom"
                                            displayFormat="σTot {0}"
                                            valueFormat={{ type: 'fixedPoint', precision: 3 }}
                                            showInGroupFooter={false}
                                            alignByColumn={true}
                                          />
                                          <GroupItem
                                            name="bkhCountRange"
                                            column="currBankHolidays"
                                            summaryType="custom"
                                            displayFormat="range {0}"
                                            showInGroupFooter={false}
                                            alignByColumn={true}
                                            valueFormat={{ type: 'fixedPoint', precision: 3 }}
                                          />
                                          <GroupItem
                                            name="yearBkhMoyGrp"
                                            column="yearBankHolidays"
                                            summaryType="avg"
                                            displayFormat="μTot {0}"
                                            valueFormat={{ type: 'fixedPoint', precision: 3 }}
                                            showInGroupFooter={false}
                                            alignByColumn={true}
                                          />
                                          <GroupItem
                                            name="yearBkhStdevGrp"
                                            column="yearBankHolidays"
                                            summaryType="custom"
                                            displayFormat=" σTot {0}"
                                            valueFormat={{ type: 'fixedPoint', precision: 3 }}
                                            showInGroupFooter={false}
                                            alignByColumn={true}
                                          />
                                          <TotalItem
                                            name="bkhMoy"
                                            column="currBankHolidays"
                                            summaryType="avg"
                                            displayFormat="μTot {0}"
                                            valueFormat={{ type: 'fixedPoint', precision: 3 }}
                                          />
                                          <TotalItem
                                            name="bkhStdev"
                                            column="currBankHolidays"
                                            summaryType="custom"
                                            displayFormat="σTot {0}"
                                            valueFormat={{ type: 'fixedPoint', precision: 3 }}
                                          />
                                          <TotalItem
                                            name="yearBkhMoy"
                                            column="yearBankHolidays"
                                            summaryType="avg"
                                            displayFormat="μTot {0}"
                                            valueFormat={{ type: 'fixedPoint', precision: 3 }}
                                          />
                                          <TotalItem
                                            name="yearBkhStdev"
                                            column="yearBankHolidays"
                                            summaryType="custom"
                                            displayFormat=" σTot {0}"
                                            valueFormat={{ type: 'fixedPoint', precision: 3 }}
                                          />
                                        </Summary>
                                        <Pager
                                          visible={true}
                                          allowedPageSizes={[20, 50, 100, 'all']}
                                          showPageSizeSelector={true}
                                          showInfo={true}
                                          showNavigationButtons={true}
                                        />
                                        <Paging defaultPageSize={50} />
                                      </DataGrid>
                                    </>
                                  }
                                />
                                <Tab
                                  id={SUBSUBTAB.DUTYCOUNTCHANGESGRAPHS}
                                  title={this.props.translate(TLCode.DUTY_COUNT_CHANGES_GRAPHS_TITLE)}
                                  panel={
                                    <>
                                      {' '}
                                      <p>
                                        {this.props.translate(TLCode.DUTY_COUNT_CHANGES_EXPLANATION_3)}
                                        &nbsp;&nbsp;&nbsp;
                                        {this.props.translate(TLCode.DUTY_COUNT_CHANGES_EXPLANATION_4)}
                                      </p>
                                      {/* <p>{this.props.translate(TLCode.PHARMACY_LINKS_NOTICE)}</p> */}
                                      <DivLine>
                                        <LineChart
                                          width={500}
                                          height={250}
                                          data={deltaDistribution}
                                          margin={{
                                            top: 5,
                                            right: 30,
                                            left: 20,
                                            bottom: 5,
                                          }}
                                        >
                                          <CartesianGrid strokeDasharray="3 3" />
                                          <XAxis dataKey="key" tpe="number" interval={0} />
                                          <YAxis>
                                            <Label value="Phies" position="insideLeft" offset={-10} />
                                          </YAxis>
                                          <ReferenceLine x="0" stroke="red" />
                                          <Tooltip />
                                          <Legend />
                                          <Line
                                            type="monotone"
                                            dataKey="value"
                                            name="Différence nbre total de gardes"
                                            stroke="#8884d8"
                                            activeDot={{ r: 8 }}
                                          />
                                          <ChartTooltip />
                                        </LineChart>
                                        <LineChart
                                          width={500}
                                          height={250}
                                          data={deltaDayDistribution}
                                          margin={{
                                            top: 5,
                                            right: 30,
                                            left: 20,
                                            bottom: 5,
                                          }}
                                        >
                                          <CartesianGrid strokeDasharray="3 3" />
                                          <XAxis dataKey="key" tpe="number" interval={0} />
                                          <YAxis>
                                            <Label value="Phies" position="insideLeft" offset={-10} />
                                          </YAxis>
                                          <ReferenceLine x="0" stroke="red" />
                                          <Tooltip />
                                          <Legend />
                                          <Line
                                            type="monotone"
                                            dataKey="value"
                                            name="Différence nbre de gardes de jour"
                                            stroke="#8884d8"
                                            activeDot={{ r: 8 }}
                                          />
                                          <ChartTooltip />
                                        </LineChart>
                                        <LineChart
                                          width={500}
                                          height={250}
                                          data={deltaNightDistribution}
                                          margin={{
                                            top: 5,
                                            right: 30,
                                            left: 20,
                                            bottom: 5,
                                          }}
                                        >
                                          <CartesianGrid strokeDasharray="3 3" />
                                          <XAxis dataKey="key" tpe="number" interval={0} />
                                          <YAxis>
                                            <Label value="Phies" position="insideLeft" offset={-10} />
                                          </YAxis>
                                          <ReferenceLine x="0" stroke="red" />
                                          <Tooltip />
                                          <Legend />
                                          <Line
                                            type="monotone"
                                            dataKey="value"
                                            name="Différence nbre de gardes de nuit"
                                            stroke="#8884d8"
                                            activeDot={{ r: 8 }}
                                          />
                                          <ChartTooltip />
                                        </LineChart>
                                      </DivLine>
                                      <DivLine>
                                        <LineChart
                                          width={600}
                                          height={250}
                                          data={prevRatioDistribution}
                                          margin={{
                                            top: 5,
                                            right: 30,
                                            left: 20,
                                            bottom: 5,
                                          }}
                                        >
                                          <CartesianGrid strokeDasharray="3 3" />
                                          <XAxis dataKey="key" tpe="number" interval={0.5} domain={[0.0, 1.0]} />
                                          <YAxis domain={[0, 90]}>
                                            <Label value="Phies" position="insideLeft" offset={-10} />
                                          </YAxis>
                                          <ReferenceLine x="0" stroke="red" />
                                          <Tooltip />
                                          <Legend />
                                          <Line
                                            type="monotone"
                                            dataKey="value"
                                            name="Ratio précédent jour seul/ total 0=> jamais de nuit, 1=> toujours nuit"
                                            stroke="#8884d8"
                                            activeDot={{ r: 8 }}
                                          />
                                          <ChartTooltip />
                                        </LineChart>
                                      </DivLine>
                                      <DivLine>
                                        <LineChart
                                          width={600}
                                          height={250}
                                          data={ratioDistribution}
                                          margin={{
                                            top: 5,
                                            right: 30,
                                            left: 20,
                                            bottom: 5,
                                          }}
                                        >
                                          <CartesianGrid strokeDasharray="3 3" />
                                          <XAxis dataKey="key" tpe="number" interval={0.5} domain={[0.0, 1.0]} />
                                          <YAxis domain={[0, 90]}>
                                            <Label value="Phies" position="insideLeft" offset={-10} />
                                          </YAxis>
                                          <ReferenceLine x="0" stroke="red" />
                                          <Tooltip />
                                          <Legend />
                                          <Line
                                            type="monotone"
                                            dataKey="value"
                                            name="Ratio courant jour seul/ total 0=> jamais de nuit, 1=> toujours nuit"
                                            stroke="#8884d8"
                                            activeDot={{ r: 8 }}
                                          />
                                          <ChartTooltip />
                                        </LineChart>
                                      </DivLine>
                                      <DivLine>
                                        <LineChart
                                          width={500}
                                          height={250}
                                          data={dutyDistribution}
                                          margin={{
                                            top: 5,
                                            right: 30,
                                            left: 20,
                                            bottom: 5,
                                          }}
                                        >
                                          <CartesianGrid strokeDasharray="3 3" />
                                          <XAxis dataKey="key" tpe="number" interval={0} />
                                          <YAxis>
                                            <Label value="Phies" position="insideLeft" offset={-10} />
                                          </YAxis>
                                          <Tooltip />
                                          <Legend />
                                          <Line
                                            type="monotone"
                                            dataKey="value"
                                            name="Distribution nbre total de gardes par pharmacie"
                                            stroke="#8884d8"
                                            activeDot={{ r: 8 }}
                                          />
                                          <ChartTooltip />
                                        </LineChart>
                                        {/* </DivLine>
                              <DivLine> */}
                                        <LineChart
                                          width={500}
                                          height={250}
                                          data={dayDutyDistribution}
                                          margin={{
                                            top: 5,
                                            right: 30,
                                            left: 20,
                                            bottom: 5,
                                          }}
                                        >
                                          <CartesianGrid strokeDasharray="3 3" />
                                          <XAxis dataKey="key" tpe="number" interval={0} />
                                          <YAxis>
                                            <Label value="Phies" position="insideLeft" offset={-10} />
                                          </YAxis>
                                          <Tooltip />
                                          <Legend />
                                          <Line
                                            type="monotone"
                                            dataKey="value"
                                            name="Distribution nbre de gardes de jour par pharmacie"
                                            stroke="#8884d8"
                                            activeDot={{ r: 8 }}
                                          />
                                          <ChartTooltip />
                                        </LineChart>
                                        {/* </DivLine>
                              <DivLine> */}
                                        <LineChart
                                          width={500}
                                          height={250}
                                          data={nightDutyDistribution}
                                          margin={{
                                            top: 5,
                                            right: 30,
                                            left: 20,
                                            bottom: 5,
                                          }}
                                        >
                                          <CartesianGrid strokeDasharray="3 3" />
                                          <XAxis dataKey="key" tpe="number" interval={0} />
                                          <YAxis>
                                            <Label value="Phies" position="insideLeft" offset={-10} />
                                          </YAxis>
                                          <Tooltip />
                                          <Legend />
                                          <Line
                                            type="monotone"
                                            dataKey="value"
                                            name="Distribution nbre de gardes de nuit par pharmacie"
                                            stroke="#8884d8"
                                            activeDot={{ r: 8 }}
                                          />
                                          <ChartTooltip />
                                        </LineChart>
                                      </DivLine>
                                    </>
                                  }
                                />
                              </Tabs>
                            </span>
                          }
                        />
                        <Tab
                          id={SUBTAB.UNBALANCEDNEIGHBORS}
                          title={this.props.translate(TLCode.UNBALANCED_NEIGHBORS_TITLE)}
                          panel={
                            <span>
                              <p>
                                <b>Planning {savedPlanningId > -1 ? savedPlanningId : 'live'}</b>&nbsp;&nbsp;&nbsp;
                                {/* <b>
                                  {this.props.translate(TLCode.ANALYSIS_GLOBAL_PERF)}{' '}
                                  {this.getGlobalPerformancePercentage()}%
                                </b>{' '} */}
                                {this.props.translate(TLCode.UNBALANCED_NEIGHBORS_COMMENTS)}
                                {/* </p>
                              <p> */}&nbsp;&nbsp;&nbsp;
                                {/* {this.props.translate(TLCode.PHARMACY_LINKS_NOTICE)} */}
                              </p>
                              <Tabs
                                id="subUnbalancedNeighbors"
                                renderActiveTabPanelOnly={true}
                                defaultSelectedTabId={SUBSUBTAB.UNBALANCEDNEIGHBORSGRAPHS}
                                selectedTabId={this.state.selectedUnbalancedCountSubTabId}
                                onChange={this.handleSubSubTabChange}
                              >
                                {/* <Tab
                                  id={SUBSUBTAB.UNBALANCEDNEIGHBORSGRID}
                                  title={this.props.translate(TLCode.UNBALANCED_NEIGHBORS_LIST_TITLE)}
                                  panel={
                                    <BaseGridXL
                                      height="600px"
                                      keyName="pharmacyId"
                                      columnDefs={this.GetUnbalancedNeighborsColumns}
                                      rowData={finalUnbalancedNeighborsList}
                                      loading={this.notReadyYet()}
                                      onRowDoubleClicked={this.onPharmacyIdSelected}
                                      exportName="PharmagardDutyCountChanges"
                                    />
                                  }
                                /> */}
                                <Tab
                                  id={SUBSUBTAB.UNBALANCEDNEIGHBORSGRAPHS}
                                  title={this.props.translate(TLCode.UNBALANCED_NEIGHBORS_GRAPHS_TITLE)}
                                  panel={
                                    <>
                                      <DivLine>
                                        <LineChart
                                          width={350}
                                          height={200}
                                          data={fridayDistribution}
                                          margin={{
                                            top: 5,
                                            right: 30,
                                            left: 20,
                                            bottom: 5,
                                          }}
                                        >
                                          <CartesianGrid strokeDasharray="3 3" />
                                          <XAxis dataKey="key" tpe="number" interval={0} />
                                          <YAxis>
                                            <Label value="Phies" position="insideLeft" offset={-10} />
                                          </YAxis>
                                          <ReferenceLine x="0" stroke="red" />
                                          <Tooltip />
                                          <Legend />
                                          <Line
                                            type="monotone"
                                            dataKey="value"
                                            name="Distribution nbre de gardes le vendredi"
                                            stroke="#8884d8"
                                            activeDot={{ r: 8 }}
                                          />
                                          <ChartTooltip />
                                        </LineChart>
                                        <LineChart
                                          width={350}
                                          height={200}
                                          data={saturdayDistribution}
                                          margin={{
                                            top: 5,
                                            right: 30,
                                            left: 20,
                                            bottom: 5,
                                          }}
                                        >
                                          <CartesianGrid strokeDasharray="3 3" />
                                          <XAxis dataKey="key" tpe="number" interval={0} />
                                          <YAxis>
                                            <Label value="Phies" position="insideLeft" offset={-10} />
                                          </YAxis>
                                          <ReferenceLine x="0" stroke="red" />
                                          <Tooltip />
                                          <Legend />
                                          <Line
                                            type="monotone"
                                            dataKey="value"
                                            name="Distribution nbre de gardes le samedi"
                                            stroke="#8884d8"
                                            activeDot={{ r: 8 }}
                                          />
                                          <ChartTooltip />
                                        </LineChart>
                                        <LineChart
                                          width={350}
                                          height={200}
                                          data={sundayDistribution}
                                          margin={{
                                            top: 5,
                                            right: 30,
                                            left: 20,
                                            bottom: 5,
                                          }}
                                        >
                                          <CartesianGrid strokeDasharray="3 3" />
                                          <XAxis dataKey="key" tpe="number" interval={0} />
                                          <YAxis>
                                            <Label value="Phies" position="insideLeft" offset={-10} />
                                          </YAxis>
                                          <ReferenceLine x="0" stroke="red" />
                                          <Tooltip />
                                          <Legend />
                                          <Line
                                            type="monotone"
                                            dataKey="value"
                                            name="Distribution nbre de gardes le dimanche"
                                            stroke="#8884d8"
                                            activeDot={{ r: 8 }}
                                          />
                                          <ChartTooltip />
                                        </LineChart>
                                      </DivLine>
                                      <DivLine>
                                        <LineChart
                                          width={350}
                                          height={200}
                                          data={weekendDistribution}
                                          margin={{
                                            top: 5,
                                            right: 30,
                                            left: 20,
                                            bottom: 5,
                                          }}
                                        >
                                          <CartesianGrid strokeDasharray="3 3" />
                                          <XAxis dataKey="key" tpe="number" interval={0} />
                                          <YAxis>
                                            <Label value="Phies" position="insideLeft" offset={-10} />
                                          </YAxis>
                                          <ReferenceLine x="0" stroke="red" />
                                          <Tooltip />
                                          <Legend />
                                          <Line
                                            type="monotone"
                                            dataKey="value"
                                            name="Distribution nbre de gardes le weekend"
                                            stroke="#8884d8"
                                            activeDot={{ r: 8 }}
                                          />
                                          <ChartTooltip />
                                        </LineChart>
                                        <LineChart
                                          width={350}
                                          height={200}
                                          data={bankHolidayDistribution}
                                          margin={{
                                            top: 5,
                                            right: 30,
                                            left: 20,
                                            bottom: 5,
                                          }}
                                        >
                                          <CartesianGrid strokeDasharray="3 3" />
                                          <XAxis dataKey="key" tpe="number" interval={0} />
                                          <YAxis>
                                            <Label value="Phies" position="insideLeft" offset={-10} />
                                          </YAxis>
                                          <ReferenceLine x="0" stroke="red" />
                                          <Tooltip />
                                          <Legend />
                                          <Line
                                            type="monotone"
                                            dataKey="value"
                                            name="Distribution nbre de gardes les jours fériés"
                                            stroke="#8884d8"
                                            activeDot={{ r: 8 }}
                                          />
                                          <ChartTooltip />
                                        </LineChart>
                                      </DivLine>
                                    </>
                                  }
                                />
                              </Tabs>
                            </span>
                          }
                        />
                        <Tab
                          id={SUBTAB.GROUPANALYSIS}
                          title={this.props.translate(TLCode.GROUPANALYSIS_TITLE)}
                          panel={
                            <span>
                              <Tabs>
                                <Tab
                                  id={SUBSUBTAB.GROUPDUTYCOUNTS}
                                  title={this.props.translate(TLCode.GROUPANALYSIS_DUTY_COUNTS_TITLE)}
                                  panel={
                                    <span>
                                      <DivLine>
                                        <DivColumn style={{ width: '1200px' }}>
                                          <DivLine>
                                            <DivColumn style={{ width: '600px' }}>
                                              <p>
                                                <b>{this.props.translate(TLCode.GROUPANALYSIS_DUTY_COUNTS_BY_DATE)}</b>
                                              </p>
                                              {GetGroupDutyCountsByDateList != undefined && (
                                                <DataGrid
                                                  dataSource={GetGroupDutyCountsByDateList}
                                                  rowAlternationEnabled={true}
                                                  showBorders={true}
                                                  width="100%"
                                                  allowColumnResizing={true}
                                                  allowColumnReordering={false}
                                                  columnResizingMode={'widget'}
                                                  onExporting={this.onExportingDutyCounts}
                                                  onContentReady={(e) => {
                                                    if (
                                                      this.state.nbrJN0 != e.component.getTotalSummaryValue('nbrJN0')
                                                    ) {
                                                      this.setState({
                                                        nbrJN0: e.component.getTotalSummaryValue('nbrJN0'),
                                                      });
                                                    }
                                                    if (
                                                      this.state.nbrJN1plus !=
                                                      e.component.getTotalSummaryValue('nbrJN1plus')
                                                    ) {
                                                      this.setState({
                                                        nbrJN1plus: e.component.getTotalSummaryValue('nbrJN1plus'),
                                                      });
                                                    }
                                                  }}
                                                >
                                                  <FilterRow visible={true} applyFilter={'auto'} />
                                                  <FilterPanel visible={true} />
                                                  <HeaderFilter visible={true} />
                                                  <GroupPanel visible={true} />
                                                  <SearchPanel visible={true} highlightCaseSensitive={true} />
                                                  <Grouping autoExpandAll={false} />
                                                  <ColumnChooser enabled={true} />
                                                  <Export enabled={true} />
                                                  <Column
                                                    caption={this.props.translate(TLCode.GROUPANALYSIS_WEEKDAY)}
                                                    dataField="weekday"
                                                    allowSorting={true}
                                                    allowFiltering={false}
                                                    allowHeaderFiltering={true}
                                                    alignment="left"
                                                    width={100}
                                                  />
                                                  <Column
                                                    caption={this.props.translate(TLCode.GROUPANALYSIS_DATE)}
                                                    dataField="date"
                                                    dataType="date"
                                                    defaultSortOrder="asc"
                                                    format="dd/MM/yyyy"
                                                    alignment="left"
                                                    width={120}
                                                  />
                                                  <Column
                                                    caption={this.props.translate(TLCode.GROUPANALYSIS_GROUP)}
                                                    dataType="string"
                                                    dataField="group"
                                                    defaultSortOrder="asc"
                                                  />
                                                  <Column
                                                    caption={this.props.translate(TLCode.GROUPANALYSIS_COUNT)}
                                                    dataField="count"
                                                  //allowFiltering={false}
                                                  />
                                                  <Column
                                                    caption={this.props.translate(TLCode.GROUPANALYSIS_DAY_COUNT)}
                                                    dataField="dCount"
                                                  //allowFiltering={false}
                                                  />
                                                  <Column
                                                    caption={this.props.translate(TLCode.GROUPANALYSIS_NIGHT_COUNT)}
                                                    dataField="nCount"
                                                  //allowFiltering={false}
                                                  />
                                                  <Summary
                                                    calculateCustomSummary={this.calculateCustomSummaryGroupsDaily}
                                                  >
                                                    <TotalItem
                                                      name="nbrJN0"
                                                      column="nCount"
                                                      summaryType="custom"
                                                      displayFormat="nbrJ+N=0 {0}"
                                                    />
                                                    <TotalItem
                                                      name="nbrJN1plus"
                                                      column="nCount"
                                                      summaryType="custom"
                                                      displayFormat="nbrJ+N>1 {0}"
                                                    />
                                                  </Summary>
                                                  <Pager
                                                    visible={true}
                                                    allowedPageSizes={[5, 10, 20, 50, 100]}
                                                    showPageSizeSelector={true}
                                                    showInfo={true}
                                                    showNavigationButtons={true}
                                                  />
                                                  <Paging defaultPageSize={20} />
                                                </DataGrid>
                                              )}
                                            </DivColumn>
                                            {/* <DivColumn style={{ width: '600px' }}>
                                              <DivLine style={{ width: '600px' }}>
                                                <DivColumn style={{ width: '200px' }}>
                                                  <DivLine>
                                                    {this.props.translate(TLCode.StartDate)}
                                                    <div style={{ width: '100px' }}>
                                                      <DateInput
                                                        value={selectedStartRuleTransgressionDate}
                                                        canClearSelection={false}
                                                        onChange={(value) => {
                                                          this.selectedStartRuleTransgressionChange(value);
                                                        }}
                                                      />
                                                    </div>
                                                  </DivLine>
                                                </DivColumn>
                                                <DivColumn style={{ width: '200px' }}>
                                                  <DivLine>
                                                    {this.props.translate(TLCode.EndDate)}&nbsp;
                                                    <div style={{ width: '100px' }}>
                                                      <DateInput
                                                        value={selectedEndRuleTransgressionDate}
                                                        canClearSelection={false}
                                                        onChange={(value) => {
                                                          this.selectedEndRuleTransgressionChange(value);
                                                        }}
                                                      />
                                                    </div>
                                                  </DivLine>
                                                </DivColumn>
                                                <DivColumn style={{ width: '100px' }}>
                                                  <Button
                                                    intent="primary"
                                                    icon={IconNames.CALCULATOR}
                                                    onClick={this.detectGroupRuleTransgressions}
                                                  >
                                                    <TranslatedMessage id={TLCode.GROUPANALYSIS_CALCULATE} />
                                                  </Button>
                                                </DivColumn>
                                              </DivLine>
                                              <DivLine>
                                                <DivColumn>
                                                  <p>
                                                    <b>Planning {savedPlanningId > -1 ? savedPlanningId : 'live'}</b>
                                                    &nbsp;&nbsp;&nbsp;
                                                    <b>
                                                      {this.props.translate(
                                                        TLCode.GROUPANALYSIS_DYNAMIC_TRANSGRESSIONS,
                                                      )}
                                                    </b>
                                                  </p>
                                                  {DetectGroupRuleTransgressionList != undefined && (
                                                    <BaseGridXL
                                                      height="600px"
                                                      width="600px"
                                                      keyName="rowid"
                                                      columnDefs={this.GroupRuleTransgressionColumns}
                                                      rowData={DetectGroupRuleTransgressionList}
                                                      loading={this.notReadyYet()}
                                                      // onRowDoubleClicked={this.onPharmacyIdSelected}
                                                      exportName="PharmagardeGroupRuleTransgressions"
                                                    />
                                                  )}
                                                </DivColumn>
                                              </DivLine>
                                            </DivColumn> */}
                                          </DivLine>
                                        </DivColumn>
                                      </DivLine>
                                    </span>
                                  }
                                />
                                {/* <Tab
                                  id={SUBSUBTAB.GROUPRULETRANSGRESSIONS}
                                  title={this.props.translate(TLCode.GROUPANALYSIS_GROUP_TRANSGRESSIONS_TITLE)}
                                  panel={
                                    <span>
                                      <DivLine>
                                        <DivColumn style={{ width: '1200px' }}>
                                          <DivLine>
                                            <DivColumn style={{ width: '600px' }}>
                                              <p>
                                                <b>
                                                  {this.props.translate(
                                                    TLCode.GROUPANALYSIS_GROUP_TRANSGRESSIONS_BY_DATE,
                                                  )}
                                                </b>
                                              </p>
                                              {GetGroupDutyCountsByDateList != undefined && (
                                                <DataGrid
                                                  dataSource={GetGroupDutyCountsByDateList}
                                                  rowAlternationEnabled={true}
                                                  showBorders={true}
                                                  width="100%"
                                                  allowColumnResizing={true}
                                                  columnResizingMode={'widget'}
                                                >
                                                  <HeaderFilter visible={true} />
                                                  <FilterRow visible={true} applyFilter={'auto'} />
                                                  <Column
                                                    caption={this.props.translate(TLCode.GROUPANALYSIS_GROUP)}
                                                    dataType="string"
                                                    dataField="date"
                                                    defaultSortOrder="asc"
                                                  />
                                                  <Column
                                                    caption={this.props.translate(TLCode.GROUPANALYSIS_GROUP)}
                                                    dataType="string"
                                                    dataField="group"
                                                    defaultSortOrder="asc"
                                                  />
                                                  <Column
                                                    caption={this.props.translate(TLCode.GROUPANALYSIS_TARGET)}
                                                    dataField="count"
                                                    allowFiltering={false}
                                                  />
                                                  <Column
                                                    caption={this.props.translate(TLCode.GROUPANALYSIS_AVERAGE)}
                                                    dataField="dCount"
                                                    allowFiltering={false}
                                                  />
                                                  <Column
                                                    caption={this.props.translate(TLCode.GROUPANALYSIS_MEMBERS)}
                                                    dataField="nCount"
                                                    allowFiltering={false}
                                                  />
                                                </DataGrid>
                                              )}
                                            </DivColumn>
                                            <DivColumn style={{ width: '600px' }}>
                                              <DivLine style={{ width: '600px' }}>
                                                <DivColumn style={{ width: '200px' }}>
                                                  <DivLine>
                                                    {this.props.translate(TLCode.StartDate)}
                                                    <div style={{ width: '100px' }}>
                                                      <DateInput
                                                        value={selectedStartRuleTransgressionDate}
                                                        canClearSelection={false}
                                                        onChange={(value) => {
                                                          this.selectedStartRuleTransgressionChange(value);
                                                        }}
                                                      />
                                                    </div>
                                                  </DivLine>
                                                </DivColumn>
                                                <DivColumn style={{ width: '200px' }}>
                                                  <DivLine>
                                                    {this.props.translate(TLCode.EndDate)}&nbsp;
                                                    <div style={{ width: '100px' }}>
                                                      <DateInput
                                                        value={selectedEndRuleTransgressionDate}
                                                        canClearSelection={false}
                                                        onChange={(value) => {
                                                          this.selectedEndRuleTransgressionChange(value);
                                                        }}
                                                      />
                                                    </div>
                                                  </DivLine>
                                                </DivColumn>
                                                <DivColumn style={{ width: '100px' }}>
                                                  <Button
                                                    intent="primary"
                                                    icon={IconNames.CALCULATOR}
                                                    onClick={this.detectGroupRuleTransgressions}
                                                  >
                                                    <TranslatedMessage id={TLCode.GROUPANALYSIS_CALCULATE} />
                                                  </Button>
                                                </DivColumn>
                                              </DivLine>
                                              <DivLine>
                                                <DivColumn>
                                                  <p>
                                                    <b>Planning {savedPlanningId > -1 ? savedPlanningId : 'live'}</b>
                                                    &nbsp;&nbsp;&nbsp;
                                                    <b>
                                                      {this.props.translate(
                                                        TLCode.GROUPANALYSIS_DYNAMIC_TRANSGRESSIONS,
                                                      )}
                                                    </b>
                                                  </p>
                                                  {DetectGroupRuleTransgressionList != undefined && (
                                                    <BaseGridXL
                                                      height="600px"
                                                      width="600px"
                                                      keyName="rowid"
                                                      columnDefs={this.GroupRuleTransgressionColumns}
                                                      rowData={DetectGroupRuleTransgressionList}
                                                      loading={this.notReadyYet()}
                                                      // onRowDoubleClicked={this.onPharmacyIdSelected}
                                                      exportName="PharmagardeGroupRuleTransgressions"
                                                    />
                                                  )}
                                                </DivColumn>
                                              </DivLine>
                                            </DivColumn>
                                          </DivLine>
                                        </DivColumn>
                                      </DivLine>
                                    </span>
                                  }
                                /> */}
                                <Tab
                                  id={SUBSUBTAB.GROUPTARGETS}
                                  title={this.props.translate(TLCode.GROUPANALYSIS_GROUP_TARGETS_TITLE)}
                                  panel={
                                    <span>
                                      <DivLine>
                                        <DivColumn style={{ width: '600px' }}>
                                          <p>
                                            <b>Planning {savedPlanningId > -1 ? savedPlanningId : 'live'}</b>
                                            <b>
                                              {this.props.translate(TLCode.GROUPANALYSIS_GROUP_AVERAGE_DUTY_COUNTS)}
                                            </b>
                                          </p>
                                          {GetGroupAverageDutyCountList != undefined && (
                                            <DataGrid
                                              dataSource={GetGroupAverageDutyCountList}
                                              rowAlternationEnabled={true}
                                              showBorders={true}
                                              width="100%"
                                              allowColumnResizing={true}
                                              columnResizingMode={'widget'}
                                              onExporting={this.onExportingTargetCounts}
                                            >
                                              <HeaderFilter visible={true} />
                                              <FilterRow visible={true} applyFilter={'auto'} />
                                              <FilterPanel visible={true} />
                                              <GroupPanel visible={true} />
                                              <SearchPanel visible={true} highlightCaseSensitive={true} />
                                              <ColumnChooser enabled={true} />
                                              <Export enabled={true} />
                                              <Column
                                                caption={this.props.translate(TLCode.GROUPANALYSIS_GROUP)}
                                                dataType="string"
                                                dataField="group"
                                                defaultSortOrder="asc"
                                              />
                                              <Column
                                                caption={this.props.translate(TLCode.GROUPANALYSIS_MEMBERS)}
                                                dataField="members"
                                                allowFiltering={false}
                                                width={100}
                                              />
                                              <Column
                                                caption={this.props.translate(TLCode.GROUPANALYSIS_TARGET_TOTAL)}
                                                dataField="targetCount"
                                                allowFiltering={false}
                                              />
                                              {/* <Column
                                                caption={this.props.translate(TLCode.GROUPANALYSIS_COUNT)}
                                                dataField="count"
                                                allowFiltering={false}
                                              /> */}
                                              <Column
                                                caption={this.props.translate(TLCode.GROUPANALYSIS_AVERAGE)}
                                                dataField="average"
                                                allowFiltering={false}
                                                format={{ type: 'fixedPoint', precision: 2 }}
                                              />
                                              <Column
                                                caption={this.props.translate(TLCode.GROUPANALYSIS_TARGET_DAY)}
                                                dataField="targetDayCount"
                                                allowFiltering={false}
                                              />
                                              {/* <Column
                                                caption={this.props.translate(TLCode.GROUPANALYSIS_COUNT)}
                                                dataField="dayCount"
                                                allowFiltering={false}
                                              /> */}
                                              <Column
                                                caption={this.props.translate(TLCode.GROUPANALYSIS_AVERAGE)}
                                                dataField="averageDay"
                                                allowFiltering={false}
                                                format={{ type: 'fixedPoint', precision: 2 }}
                                              />
                                              <Column
                                                caption={this.props.translate(TLCode.GROUPANALYSIS_TARGET_NIGHT)}
                                                dataField="targetNightCount"
                                                allowFiltering={false}
                                              />
                                              {/* <Column
                                                caption={this.props.translate(TLCode.GROUPANALYSIS_COUNT)}
                                                dataField="nightCount"
                                                allowFiltering={false}
                                              /> */}
                                              <Column
                                                caption={this.props.translate(TLCode.GROUPANALYSIS_AVERAGE)}
                                                dataField="averageNight"
                                                allowFiltering={false}
                                                format={{ type: 'fixedPoint', precision: 2 }}
                                              />
                                              <Pager
                                                visible={true}
                                                allowedPageSizes={[5, 10, 20, 50, 100]}
                                                showPageSizeSelector={true}
                                                showInfo={true}
                                                showNavigationButtons={true}
                                              />
                                              <Paging defaultPageSize={20} />
                                            </DataGrid>
                                          )}
                                        </DivColumn>
                                      </DivLine>
                                    </span>
                                  }
                                />
                              </Tabs>
                            </span>
                          }
                        />
                        <Tab
                          id={SUBTAB.SPECIALISSUES}
                          title={this.props.translate(TLCode.SPECIALISSUES_TITLE)}
                          panel={
                            <span>
                              <DivLine>
                                <DivColumn style={{ width: '900px' }}>
                                  <p>
                                    <b>Planning {savedPlanningId > -1 ? savedPlanningId : 'live'}</b>
                                    &nbsp;&nbsp;&nbsp;
                                    <b>{this.props.translate(TLCode.SPECIALISSUES_BLACKPOINTTRANSGRESSIONS)}</b>
                                  </p>
                                  <DataGrid
                                    dataSource={finalBlackpointTransgressionList}
                                    allowColumnReordering={true}
                                    rowAlternationEnabled={true}
                                    showBorders={true}
                                    width="100%"
                                    height="600px"
                                    allowColumnResizing={true}
                                    columnResizingMode={'widget'}
                                    onExporting={this.onExportingSpecialIssues}
                                    onRowClick={this.onRowDoubleClicked}
                                    onContentReady={(e) => {
                                      if (this.state.nbrNBeforeBP != e.component.getTotalSummaryValue('ndbbpTot')) {
                                        this.setState({ nbrNBeforeBP: e.component.getTotalSummaryValue('ndbbpTot') });
                                      }
                                      if (this.state.nbrDutiesOnDisp != e.component.getTotalSummaryValue('dispTot')) {
                                        this.setState({ nbrDutiesOnDisp: e.component.getTotalSummaryValue('dispTot') });
                                      }
                                      if (this.state.nbrDutiesOnBP != e.component.getTotalSummaryValue('bpTot')) {
                                        this.setState({ nbrDutiesOnBP: e.component.getTotalSummaryValue('bpTot') });
                                      }
                                      if (
                                        this.state.nbrDutiesOnPrefOff != e.component.getTotalSummaryValue('prefOffTot')
                                      ) {
                                        this.setState({
                                          nbrDutiesOnPrefOff: e.component.getTotalSummaryValue('prefOffTot'),
                                        });
                                      }
                                    }}
                                  >
                                    <FilterRow visible={true} applyFilter={'auto'} />
                                    <FilterPanel visible={true} />
                                    <HeaderFilter visible={true} />
                                    <GroupPanel visible={true} />
                                    <SearchPanel visible={true} highlightCaseSensitive={true} />
                                    <Grouping autoExpandAll={false} />
                                    <ColumnChooser enabled={true} />
                                    <Export enabled={true} />
                                    <Column
                                      dataField="group"
                                      caption={this.props.translate(TLCode.TOO_CLOSE_DUTIES_PHARMACY_GROUP)}
                                      minWidth={120}
                                      width={110}
                                    />
                                    <Column
                                      dataField="apbNumber"
                                      caption={this.props.translate(TLCode.DUTY_COUNT_CHANGES_APBNUMBER)}
                                      dataType="number"
                                      minWidth={70}
                                      width={90}
                                      defaultSortOrder="asc"
                                      sortIndex={1}
                                    />
                                    <Column
                                      dataField="pharmacyName"
                                      caption={this.props.translate(TLCode.SPECIALISSUES_NAME)}
                                      minWidth={120}
                                      width={230}
                                    />
                                    <Column
                                      dataField="date"
                                      caption={this.props.translate(TLCode.SPECIALISSUES_DATE)}
                                      dataType="date"
                                      format="dd/MM/yyyy"
                                      alignment="left"
                                      width={110}
                                      allowHeaderFiltering={false}
                                    />
                                    <Column
                                      dataField="type"
                                      caption={this.props.translate(TLCode.SPECIALISSUES_TYPE)}
                                      width={60}
                                    />
                                    <Column
                                      dataField="NDBBP"
                                      caption={this.props.translate(TLCode.SPECIALISSUES_NIGHT_BEFORE_BP)}
                                      dataType="string"
                                      calculateCellValue={(rowData) => {
                                        return rowData.ndbbp == true ? 'X' : '';
                                      }}
                                      width={80}
                                    />
                                    <Column
                                      dataField="disp"
                                      caption={this.props.translate(TLCode.SPECIALISSUES_DISP)}
                                      dataType="string"
                                      calculateCellValue={(rowData) => {
                                        return rowData.disp == true ? 'X' : '';
                                      }}
                                      width={80}
                                    />
                                    <Column
                                      dataField="bp"
                                      caption={this.props.translate(TLCode.SPECIALISSUES_BP)}
                                      dataType="string"
                                      calculateCellValue={(rowData) => {
                                        return rowData.bp == true ? 'X' : '';
                                      }}
                                      width={80}
                                    />
                                    <Column
                                      dataField="prefOff"
                                      caption={this.props.translate(TLCode.SPECIALISSUES_PREFOFF)}
                                      dataType="string"
                                      calculateCellValue={(rowData) => {
                                        return rowData.prefOff == true ? 'X' : '';
                                      }}
                                      width={80}
                                    />
                                    <Summary calculateCustomSummary={calculateCustomSummarySpecialIssues}>
                                      <TotalItem
                                        name="ndbbpTot"
                                        column="NDBBP"
                                        summaryType="custom"
                                        displayFormat="Tot {0}"
                                        valueFormat={{ type: 'fixedPoint', precision: 0 }}
                                      />
                                      <TotalItem
                                        name="dispTot"
                                        column="disp"
                                        summaryType="custom"
                                        displayFormat="Tot {0}"
                                        valueFormat={{ type: 'fixedPoint', precision: 0 }}
                                      />
                                      <TotalItem
                                        name="bpTot"
                                        column="bp"
                                        summaryType="custom"
                                        displayFormat="Tot {0}"
                                        valueFormat={{ type: 'fixedPoint', precision: 0 }}
                                      />
                                      <TotalItem
                                        name="prefOffTot"
                                        column="prefOff"
                                        summaryType="custom"
                                        displayFormat="Tot {0}"
                                        valueFormat={{ type: 'fixedPoint', precision: 0 }}
                                      />
                                    </Summary>
                                    <Pager
                                      visible={true}
                                      allowedPageSizes={[5, 10, 20, 50, 100]}
                                      showPageSizeSelector={true}
                                      showInfo={true}
                                      showNavigationButtons={true}
                                    />
                                    <Paging defaultPageSize={20} />
                                  </DataGrid>
                                </DivColumn>
                              </DivLine>
                            </span>
                          }
                        />
                        <Tab
                          id={SUBTAB.DISTANCES}
                          title={this.props.translate(TLCode.DISTANCES_TITLE)}
                          panel={
                            <span>
                              {/* <DivLine> */}
                              {/* <DivColumn> */}
                              <DivColumn style={{ width: '280px' }}>
                                <DivLine>
                                  {this.props.translate(TLCode.ANALYSIS_LOWER_DISTANCE_LIMIT)}
                                  <NumericInput
                                    style={{ width: '60px' }}
                                    value={this.state.lowerDistanceLimit}
                                    majorStepSize={1000}
                                    stepSize={100}
                                    onValueChange={this.handleLowerDistanceLimitChange}
                                  />
                                </DivLine>
                              </DivColumn>
                              <DataGrid
                                dataSource={finalMinDistancesList}
                                allowColumnReordering={true}
                                rowAlternationEnabled={true}
                                showBorders={true}
                                width="100%"
                                height="600px"
                                allowColumnResizing={true}
                                columnResizingMode={'widget'}
                                //onExporting={this.onExportingSpecialIssues}
                                onRowClick={this.onRowDoubleClicked}
                                columnHidingEnabled={true}
                              >
                                <FilterRow visible={true} applyFilter={'auto'} />
                                <FilterPanel visible={true} />
                                <HeaderFilter visible={true} />
                                <GroupPanel visible={true} />
                                <SearchPanel visible={true} highlightCaseSensitive={true} />
                                <Grouping autoExpandAll={false} />
                                <ColumnChooser enabled={true} />
                                <Export enabled={true} />
                                <Column
                                  dataField="date"
                                  caption={this.props.translate(TLCode.DISTANCES_Date)}
                                  dataType="date"
                                  format="dd/MM/yyyy"
                                  alignment="left"
                                  width={100}
                                  allowHeaderFiltering={false}
                                />
                                <Column
                                  dataField="groupName"
                                  caption={this.props.translate(TLCode.TOO_CLOSE_DUTIES_PHARMACY_GROUP)}
                                  minWidth={100}
                                  width={100}
                                />
                                <Column
                                  dataField="anchor"
                                  caption={this.props.translate(TLCode.DISTANCES_Anchor)}
                                  minWidth={100}
                                  width={100}
                                />
                                <Column
                                  dataField="apbNumber"
                                  caption={this.props.translate(TLCode.DISTANCES_ApbNumber)}
                                  dataType="number"
                                  minWidth={70}
                                  width={70}
                                />
                                <Column
                                  dataField="name"
                                  caption={this.props.translate(TLCode.DISTANCES_Name)}
                                  minWidth={100}
                                  width={120}
                                />
                                <Column
                                  dataField="groupName"
                                  caption={this.props.translate(TLCode.TOO_CLOSE_DUTIES_PHARMACY_GROUP)}
                                  minWidth={100}
                                  width={100}
                                />
                                <Column
                                  dataField="anchor"
                                  caption={this.props.translate(TLCode.DISTANCES_Anchor)}
                                  minWidth={100}
                                  width={100}
                                />
                                <Column
                                  dataField="address"
                                  caption={this.props.translate(TLCode.DISTANCES_Address)}
                                  minWidth={100}
                                  width={100}
                                />
                                <Column
                                  dataField="zipCode"
                                  caption={this.props.translate(TLCode.DISTANCES_Zip)}
                                  minWidth={60}
                                  width={60}
                                />
                                <Column
                                  dataField="city"
                                  caption={this.props.translate(TLCode.DISTANCES_City)}
                                  minWidth={100}
                                  width={100}
                                />
                                <Column
                                  dataField="distance"
                                  caption={this.props.translate(TLCode.DISTANCES_Distance)}
                                  width={70}
                                  defaultSortIndex={1}
                                  defaultSortOrder="asc"
                                />
                                <Column
                                  dataField="pairingAllowed"
                                  caption={this.props.translate(TLCode.DISTANCES_PairingAllowed)}
                                  width={90}
                                />
                                <Column
                                  dataField="apbNumber2"
                                  caption={this.props.translate(TLCode.DISTANCES_ApbNumber)}
                                  dataType="number"
                                  minWidth={70}
                                  width={70}
                                />
                                <Column
                                  dataField="name2"
                                  caption={this.props.translate(TLCode.DISTANCES_Name)}
                                  minWidth={100}
                                  width={120}
                                />
                                <Column
                                  dataField="groupName2"
                                  caption={this.props.translate(TLCode.TOO_CLOSE_DUTIES_PHARMACY_GROUP)}
                                  minWidth={100}
                                  width={100}
                                />
                                <Column
                                  dataField="anchor2"
                                  caption={this.props.translate(TLCode.DISTANCES_Anchor)}
                                  minWidth={70}
                                  width={100}
                                />
                                <Column
                                  dataField="address2"
                                  caption={this.props.translate(TLCode.DISTANCES_Address)}
                                  minWidth={100}
                                  width={120}
                                  hidingPriority={3}
                                />
                                <Column
                                  dataField="zipCode2"
                                  caption={this.props.translate(TLCode.DISTANCES_Zip)}
                                  minWidth={60}
                                  width={60}
                                  hidingPriority={2}
                                />
                                <Column
                                  dataField="city2"
                                  caption={this.props.translate(TLCode.DISTANCES_City)}
                                  minWidth={120}
                                  width={120}
                                  hidingPriority={1}
                                />
                                <Column
                                  dataField="groupName2"
                                  caption={this.props.translate(TLCode.TOO_CLOSE_DUTIES_PHARMACY_GROUP)}
                                  minWidth={100}
                                  width={100}
                                />
                                <Column
                                  dataField="anchor2"
                                  caption={this.props.translate(TLCode.DISTANCES_Anchor)}
                                  minWidth={100}
                                  width={100}
                                />
                                <Pager
                                  visible={true}
                                  allowedPageSizes={[20, 50, 100, 'all']}
                                  showPageSizeSelector={true}
                                  showInfo={true}
                                  showNavigationButtons={true}
                                />
                                <Paging defaultPageSize={20} />
                              </DataGrid>
                              {/* </DivColumn> */}
                              {/* </DivLine> */}
                            </span>
                          }
                        />
                        <Tab
                          id={SUBTAB.SUMMARY}
                          title="Résumé"
                          panel={
                            <span>
                              <DivLine style={{ justifyContent: 'flex-start', gap: '5px' }}>
                                <DivColumn style={{ width: '200px', alignItems: 'flex-end' }}>
                                  petits Δ:
                                </DivColumn>
                                <DivColumn style={{ width: '200px' }}>
                                  &nbsp;{(100 * Math.exp(-0.02 * this.state.nbrPharmaciesWithGapBelow)).toFixed(1)}%
                                  &nbsp;({this.state.nbrPharmaciesWithGapBelow})&nbsp;&nbsp;borne inf:&nbsp;{this.state.lowerGapLimit}
                                </DivColumn>
                              </DivLine>
                              <DivLine style={{ justifyContent: 'flex-start', gap: '5px' }}>
                                <DivColumn style={{ width: '200px', alignItems: 'flex-end' }}>
                                  grands Δ:
                                </DivColumn>
                                <DivColumn style={{ width: '200px' }}>
                                  &nbsp;{(100 * Math.exp(-0.02 * this.state.nbrPharmaciesWithGapAbove)).toFixed(1)}%
                                  &nbsp;({this.state.nbrPharmaciesWithGapAbove})&nbsp;&nbsp;borne sup:&nbsp;{this.state.upperGapLimit}
                                </DivColumn>
                              </DivLine>
                              <DivLine style={{ justifyContent: 'flex-start', gap: '5px' }}>
                                <DivColumn style={{ width: '200px', alignItems: 'flex-end' }}>
                                  dimanches Stdev:
                                </DivColumn>
                                <DivColumn style={{ width: '200px' }}> {this.state.suStdev.toFixed(3)}</DivColumn>
                              </DivLine>
                              <DivLine style={{ justifyContent: 'flex-start', gap: '5px' }}>
                                <DivColumn style={{ width: '200px', alignItems: 'flex-end' }}>samedis Stdev:</DivColumn>
                                <DivColumn style={{ width: '200px' }}>
                                  {this.state.saStdev ? this.state.saStdev.toFixed(3) : 0}
                                </DivColumn>
                              </DivLine>
                              <DivLine style={{ justifyContent: 'flex-start', gap: '5px' }}>
                                <DivColumn style={{ width: '200px', alignItems: 'flex-end' }}>nbrJN=0:</DivColumn>
                                <DivColumn style={{ width: '200px' }}>{this.state.nbrJN0}</DivColumn>
                              </DivLine>
                              <DivLine style={{ justifyContent: 'flex-start', gap: '5px' }}>
                                <DivColumn style={{ width: '200px', alignItems: 'flex-end' }}>nbrJN&gt;1:</DivColumn>
                                <DivColumn style={{ width: '200px' }}>{this.state.nbrJN1plus}</DivColumn>
                              </DivLine>
                              <DivLine style={{ justifyContent: 'flex-start', gap: '5px' }}>
                                <DivColumn style={{ width: '200px', alignItems: 'flex-end' }}>
                                  nbrDutiesOnDisp:
                                </DivColumn>
                                <DivColumn style={{ width: '200px' }}>{this.state.nbrDutiesOnDisp}</DivColumn>
                              </DivLine>
                              <DivLine style={{ justifyContent: 'flex-start', gap: '5px' }}>
                                <DivColumn style={{ width: '200px', alignItems: 'flex-end' }}>nbrDutiesOnBP:</DivColumn>
                                <DivColumn style={{ width: '200px' }}>{this.state.nbrDutiesOnBP}</DivColumn>
                              </DivLine>
                              <DivLine style={{ justifyContent: 'flex-start', gap: '5px' }}>
                                <DivColumn style={{ width: '200px', alignItems: 'flex-end' }}>nbrNBeforeBP:</DivColumn>
                                <DivColumn style={{ width: '200px' }}>{this.state.nbrNBeforeBP}</DivColumn>
                              </DivLine>
                              <DivLine style={{ justifyContent: 'flex-start', gap: '5px' }}>
                                <DivColumn style={{ width: '200px', alignItems: 'flex-end' }}>
                                  nbrDutiesOnPrefOff:
                                </DivColumn>
                                <DivColumn style={{ width: '200px' }}>{this.state.nbrDutiesOnPrefOff}</DivColumn>
                              </DivLine>
                            </span>
                          }
                        />
                        {/* <Tab
                          disabled={true}
                          id={SUBTAB.INSUFFICIENTGEOCOVERAGE}
                          title={this.props.translate(TLCode.INSUFICIENT_GEO_COVERAGE)}
                          panel={
                            <span>
                              <p>
                                <b>{this.props.translate(TLCode.FAKE)}</b>
                              </p>
                              <p>
                                <b>Périodes de garde avec couverture géographique insuffisante</b>
                                <br />
                                <b>Indice de performance : 85.02%</b>&nbsp;&nbsp;&nbsp;
                                1.11% - 4 sur un total de 364 périodes de garde
                              </p>
                              <p>{this.props.translate(TLCode.PHARMACY_LINKS_NOTICE)}</p>
                              <BaseGridXL
                                height="600px"
                                keyName="scoreId"
                                columnDefs={this.scoreColumnDefs}
                                rowData={scoreList}
                                loading={this.notReadyYet()}
                                onRowDoubleClicked={this.onScoreSelected}
                              />
                            </span>
                          }
                        /> */}
                      </Tabs>
                    </span>
                  }
                />
                <Tab
                  id={TAB.SCORES}
                  title={
                    <span style={{ backgroundColor: '#daf9ae' }}>
                      <TranslatedMessage id={TLCode.ANALYSIS_SCORES} />
                    </span>
                  }
                  panel={
                    <span>
                      {/* <InputGroup
                        placeholder="Filter"
                        leftIcon="search"
                        value={this.state.runFilterText}
                        onChange={(e) => this.setRunFilterText(e.target.value)}
                      /> */}
                      <Button intent="primary" onClick={this.reload}>
                        <TranslatedMessage id={TLCode.ROSTER_ReloadScores} />
                      </Button>
                      <DataGrid
                        dataSource={scoreList}
                        allowColumnReordering={true}
                        rowAlternationEnabled={true}
                        showBorders={true}
                        width="100%"
                        allowColumnResizing={true}
                        columnResizingMode={'widget'}
                        onExporting={this.onExporting}
                        onRowClick={this.onScoreSelectedV2}
                        stateStoring={{
                          enabled: true,
                          type: 'sessionStorage',
                          storageKey: 'analysisPageGrid',
                        }}
                      >
                        {/* <Editing mode="popup" allowUpdating={true} allowAdding={false} allowDeleting={false}>
                          <Popup title="test" showTitle={true} />
                          <Form>
                            <GroupItem>
                              <SimpleItem dataField='body'></SimpleItem>
                            </GroupItem>
                          </Form>
                        </Editing> */}
                        <FilterRow visible={true} applyFilter={'auto'} />
                        <FilterPanel visible={true} />
                        <HeaderFilter visible={true} />
                        <GroupPanel visible={true} />
                        <SearchPanel visible={true} highlightCaseSensitive={true} />
                        <Grouping autoExpandAll={false} />
                        <ColumnChooser enabled={true} />
                        <Export enabled={true} />

                        <Column
                          dataField="calcStart"
                          caption={this.props.translate(TLCode.ANALYSIS_SCORES_TIMESTAMP)}
                          width={120}
                          dataType="date"
                          format="dd/MM/yyyy HH:mm:ss"
                          defaultSortOrder="desc"
                          defaultSortIndex={0}
                        />
                        <Column
                          dataField="runId"
                          caption={this.props.translate(TLCode.ANALYSIS_SCORES_RUNID)}
                          dataType="number"
                          alignment="left"
                          width={65}
                        />
                        <Column
                          dataField="planningId"
                          caption={this.props.translate(TLCode.ANALYSIS_SCORES_PLANNINGID)}
                          dataType="number"
                          alignment="left"
                          width={70}
                        />
                        {/*<Column
                          dataField="calcStart"
                          caption={this.props.translate(TLCode.ANALYSIS_SCORES_CALCSTART)}
                          dataType="date"
                          format="dd/MM/yyyy HH:mm:ss"
                          alignment="left"
                          width={140}
                          allowHeaderFiltering={false}
                        /> */}
                        <Column
                          dataField="calcStart"
                          caption={this.props.translate(TLCode.ANALYSIS_SCORES_DURATION)}
                          dataType="number"
                          alignment="left"
                          width={90}
                          calculateCellValue={(rowData) => {
                            console.log(rowData.createdOn + ' / ' + rowData.calcStart);
                            const m1 = moment(rowData.createdOn);
                            const m2 = moment(rowData.calcStart);
                            const diff = moment.duration(m1.diff(m2));
                            const j = diff.days();
                            const d = diff.hours();
                            const m = diff.minutes();
                            const human = moment.duration(diff).humanize(); //moment.utc(diff.as('milliseconds')).format("d [j] h[h] m[min]");
                            return human;
                            //const formatted = moment.utc(diff.asMilliseconds()).format("h[h] m[min]");
                            //return moment.utc(new Date(rowData.createdOn).getTime() - new Date(rowData.calcStart).getTime()).format("h[h]")}
                          }}
                        />
                        <Column
                          dataField="status"
                          caption={this.props.translate(TLCode.ANALYSIS_SCORES_STATUS)}
                          dataType="string"
                          alignment="left"
                          width={70}
                          allowHeaderFiltering={true}
                        />
                        <Column
                          dataField="startDate"
                          caption={this.props.translate(TLCode.ANALYSIS_SCORES_START)}
                          dataType="date"
                          format="dd/MM/yyyy"
                          alignment="left"
                          allowHeaderFiltering={false}
                        />
                        <Column
                          dataField="endDate"
                          caption={this.props.translate(TLCode.ANALYSIS_SCORES_END)}
                          dataType="date"
                          format="dd/MM/yyyy"
                          alignment="left"
                          allowHeaderFiltering={false}
                        />
                        <Column
                          dataField="name"
                          caption={this.props.translate(TLCode.ANALYSIS_SCORES_NAME)}
                          dataType="string"
                          alignment="left"
                          allowGrouping={false}
                          minWidth={30}
                        />
                        <Column
                          dataField="description"
                          caption={this.props.translate(TLCode.ANALYSIS_SCORES_DESCRIPTION)}
                          dataType="string"
                          alignment="left"
                          allowHeaderFiltering={false}
                          allowGrouping={false}
                          minWidth={270}
                        />
                        <Column
                          dataField="hardScore"
                          caption={this.props.translate(TLCode.ANALYSIS_SCORES_HARD)}
                          dataType="string"
                          alignment="left"
                          allowGrouping={false}
                          width={65}
                        />
                        <Column
                          dataField="mediumScore"
                          caption={this.props.translate(TLCode.ANALYSIS_SCORES_MED)}
                          dataType="string"
                          alignment="left"
                          allowGrouping={false}
                          width={65}
                        />
                        <Column
                          dataField="softScore"
                          caption={this.props.translate(TLCode.ANALYSIS_SCORES_SOFT)}
                          dataType="string"
                          alignment="left"
                          allowGrouping={false}
                          width={65}
                        />
                        <Column
                          dataField="lastPromotedOn"
                          caption={this.props.translate(TLCode.ANALYSIS_SCORES_LASTPROMOTED)}
                          dataType="date"
                          format="dd/MM/yyyy HH:mm:ss"
                          alignment="left"
                          width={140}
                          allowHeaderFiltering={false}
                          calculateCellValue={(rowData) => {
                            if (rowData.lastPromotedOn.startsWith('0001-01-01T')) {
                              return '';
                            } else {
                              return rowData.lastPromotedOn;
                            }
                          }}
                        />
                        <Column caption="Actions" type="buttons" width={120}>
                          <DGButton
                            text="Pré-publier"
                            hint="Pré-publier"
                            icon="movetofolder"
                            visible={true}
                            disabled={false}
                            onClick={this.promotePlanning}
                          />
                          &nbsp;&nbsp;
                          <DGButton
                            text="Supprimer"
                            hint="Supprimer"
                            icon="trash"
                            visible={true}
                            disabled={false}
                            onClick={this.deletePlanning}
                          />
                        </Column>
                        <Pager
                          visible={true}
                          allowedPageSizes={[5, 10, 20, 50, 100]}
                          showPageSizeSelector={true}
                          showInfo={true}
                          showNavigationButtons={true}
                        />
                        <Paging defaultPageSize={20} />
                      </DataGrid>
                      {/* <BaseGridXL
                        height="600px"
                        keyName="scoreId"
                        columnDefs={this.scoreColumnDefs}
                        rowData={scoreList}
                        loading={this.notReadyYet()}
                        onRowDoubleClicked={this.onScoreSelected}
                        exportName="PharmagardeScores"
                      /> */}
                    </span>
                  }
                />
                <Tab
                  id={TAB.MATCHES}
                  title={
                    <span style={{ backgroundColor: '#d9f99d' }}>
                      <TranslatedMessage id={TLCode.ANALYSIS_MATCHES} />
                    </span>
                  }
                  panel={
                    <span>
                      <span>
                        <span>
                          <DivLine>
                            {previousScore ? (
                              <Tooltip content={this.getSolutionLabel(previousScore)} position={Position.LEFT}>
                                <Button
                                  icon={IconNames.CHEVRON_LEFT}
                                  large={true}
                                  style={{ marginLeft: '2px' }}
                                  onClick={() => this.goPrevious()}
                                />
                              </Tooltip>
                            ) : (
                              <span />
                            )}
                            <DivBox>
                              <DivLine>
                                {this.props.translate(TLCode.ANALYSIS_MATCHES_CURR)}
                                {this.getSolutionLabel(currentScore)}
                              </DivLine>
                            </DivBox>
                            {nextScore ? (
                              <Tooltip content={this.getSolutionLabel(nextScore)} position={Position.RIGHT}>
                                <Button
                                  icon={IconNames.CHEVRON_RIGHT}
                                  large={true}
                                  style={{ marginLeft: '2px' }}
                                  onClick={() => this.goNext()}
                                />
                              </Tooltip>
                            ) : (
                              <span />
                            )}
                          </DivLine>
                        </span>
                        <span>
                          <DataGrid
                            dataSource={matchList}
                            allowColumnReordering={true}
                            rowAlternationEnabled={true}
                            showBorders={true}
                            width="100%"
                            allowColumnResizing={true}
                            columnResizingMode={'widget'}
                            onExporting={this.onExportingTransgressions}
                            //onRowDblClick={this.onRuleSelectedV2}
                            onRowClick={this.onRuleSelectedV2}
                          >
                            <FilterRow visible={true} applyFilter={'auto'} />
                            <FilterPanel visible={true} />
                            <HeaderFilter visible={true} />
                            <GroupPanel visible={true} />
                            <SearchPanel visible={true} highlightCaseSensitive={true} />
                            <Grouping autoExpandAll={false} />
                            <ColumnChooser enabled={true} />
                            <Export enabled={true} />
                            <Scrolling mode="infinite" />
                            <Column
                              dataField="ruleName"
                              caption={this.props.translate(TLCode.ANALYSIS_MATCHES_RULE)}
                              width={300}
                            />
                            <Column
                              dataField="transgressionCount"
                              caption={this.props.translate(TLCode.ANALYSIS_MATCHES_TRANSGRESSIONS)}
                              width={180}
                            />
                            <Column
                              dataField="hardScore"
                              caption={this.props.translate(TLCode.ANALYSIS_MATCHES_HARD)}
                              width={120}
                            />
                            <Column
                              dataField="mediumScore"
                              caption={this.props.translate(TLCode.ANALYSIS_MATCHES_MED)}
                              width={120}
                            />
                            <Column
                              dataField="softScore"
                              caption={this.props.translate(TLCode.ANALYSIS_MATCHES_SOFT)}
                              width={120}
                            />
                            <Column />
                          </DataGrid>
                          {/* <BaseGridXL
                            height="600px"
                            keyName="constraintMatchId"
                            columnDefs={this.solutionDetailColumns}
                            rowData={matchList}
                            loading={this.notReadyYet()}
                            onRowDoubleClicked={this.onRuleSelected}
                            exportName="PharmagardeMatches"
                          /> */}
                        </span>
                      </span>
                    </span>
                  }
                />
                <Tab
                  id={TAB.TRANSGRESSIONS}
                  title={
                    <span style={{ backgroundColor: '#e5f7c3' }}>
                      <TranslatedMessage id={TLCode.ANALYSIS_TRANSGRESSIONS} />
                    </span>
                  }
                  panel={
                    <span>
                      <DivLine>
                        {previousScore ? (
                          <Tooltip content={this.getSolutionLabel(previousScore)} position={Position.LEFT}>
                            <Button
                              icon={IconNames.CHEVRON_LEFT}
                              large={true}
                              style={{ marginLeft: '2px' }}
                              onClick={() => this.goPrevious()}
                            />
                          </Tooltip>
                        ) : (
                          <span />
                        )}
                        {/* <DivBox>
                          {this.props.translate(TLCode.ANALYSIS_MATCHES_CURR)}
                          {this.getSolutionLabel(currentScore)}
                        </DivBox> */}
                        <DivBox>
                          <DivLine>
                            {this.props.translate(TLCode.ANALYSIS_MATCHES_CURR)}
                            {this.getSolutionLabel(currentScore)}
                          </DivLine>
                        </DivBox>
                        {nextScore ? (
                          <Tooltip content={this.getSolutionLabel(nextScore)} position={Position.RIGHT}>
                            <Button
                              icon={IconNames.CHEVRON_RIGHT}
                              large={true}
                              style={{ marginLeft: '2px' }}
                              onClick={() => this.goNext()}
                            />
                          </Tooltip>
                        ) : (
                          <span />
                        )}
                      </DivLine>
                      <span>
                        <DivLine>
                          <InputGroup
                            placeholder="Filtrer les deux grilles"
                            leftIcon="search"
                            value={this.state.ruleFilter}
                            onChange={(e) => this.setRuleFilterText(e.target.value)}
                          />
                          <p>{this.props.translate(TLCode.PHARMACY_FILTER_NOTICE)}</p>
                          <p>{this.props.translate(TLCode.PHARMACY_LINKS2_NOTICE)}</p>
                        </DivLine>
                        <ObservationGridContainer>
                          {/* <HalfContainer>
                            <p>
                              <b>{'Indictments'}</b>
                            </p>
                            <BaseGrid
                              height="600px"
                              keyName="apbNumber"
                              columnDefs={this.indictmentCountColumnDefs}
                              rowData={indictmentCountList}
                              loading={this.notReadyYet()}
                              onRowDoubleClicked={this.onApbNrSelected2}
                              quickFilterText={this.state.ruleFilter}
                            />
                          </HalfContainer>
                          <HalfContainer> */}
                          {/* <BaseGrid
                              height="600px"
                              keyName="indictmentId"
                              columnDefs={this.indictmentColumnDefs}
                              rowData={indictmentList}
                              loading={this.notReadyYet()}
                              onRowDoubleClicked={this.onApbNrSelected}
                              quickFilterText={this.state.ruleFilter}
                            /> */}
                          <DataGrid
                            dataSource={preFilteredIndictmentList}
                            allowColumnReordering={true}
                            rowAlternationEnabled={true}
                            showBorders={true}
                            width="100%"
                            allowColumnResizing={true}
                            columnResizingMode={'widget'}
                            onExporting={this.onExportingTransgressions}
                            onRowClick={this.onRuleSelectedV2}
                            height={600}
                          >
                            <FilterRow visible={true} applyFilter={'auto'} />
                            <FilterPanel visible={true} />
                            <HeaderFilter visible={true} />
                            <GroupPanel visible={true} />
                            <SearchPanel visible={true} highlightCaseSensitive={true} />
                            <Grouping autoExpandAll={false} />
                            <ColumnChooser enabled={true} />
                            <Export enabled={true} />
                            {/* <Scrolling mode="infinite" /> */}
                            <Column
                              dataField="rule"
                              caption={this.props.translate(TLCode.ANALYSIS_MATCHES_RULE)}
                              width={200}
                              calculateCellValue={(data) => {
                                return data.description.split('$')[1];
                              }}
                            />
                            <Column
                              dataField="description"
                              caption={this.props.translate(TLCode.ANALYSIS_MATCHES_TRANSGRESSIONS)}
                            // width={200}
                            />
                            <Pager
                              visible={true}
                              allowedPageSizes={[5, 10, 20, 50, 100]}
                              showPageSizeSelector={true}
                              showInfo={true}
                              showNavigationButtons={true}
                            />
                            <Paging defaultPageSize={20} />
                          </DataGrid>
                          {/* </HalfContainer> */}
                        </ObservationGridContainer>
                        <ObservationGridContainer>
                          <HalfContainer />
                          <HalfContainer />
                        </ObservationGridContainer>
                      </span>
                    </span>
                  }
                />
                <Tab
                  id={TAB.RULES}
                  title={this.props.translate(TLCode.ANALYSIS_RULES)}
                  panel={
                    <span>
                      <DivLine style={{ whiteSpace: 'pre-line' }}>
                        <div>{this.props.PlannerStore!.rules}</div>
                      </DivLine>
                    </span>
                  }
                />
              </Tabs>
            </Card>
          </Container>
        )}
      </MainSectionLayout>
    );
  }
}

export default withTranslate(AnalysisPage);

const Container = styled.div({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
});

const ObservationGridContainer = styled.div({
  marginTop: '5px',
  display: 'flex',
  flexDirection: 'row',
  height: '45%',
  justifyContent: 'space-between',
});

const HalfContainer = styled.div({
  flex: 0.49,
});

const CardStyle = css({
  height: '100%',
  '& .bp3-tabs': {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  '& .bp3-tab-panel': {
    flex: 1,
  },
});

const DivLine = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const DivColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const DivBox = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
  margin-right: 5%;
  border: black;
  border-style: solid;
  border-width: 1px;
  padding: 5px;
`;

const targetColor = css({
  backgroundColor: '#' + columnColors.targetColor,
});

const countColor = css({
  backgroundColor: '#' + columnColors.countColor,
});

const dayTargetColor = css({
  backgroundColor: '#' + columnColors.dayTargetColor,
});

const dayCountColor = css({
  backgroundColor: '#' + columnColors.dayCountColor,
});

const nightTargetColor = css({
  backgroundColor: '#' + columnColors.nightTargetColor,
});

const nightCountColor = css({
  backgroundColor: '#' + columnColors.nightCountColor,
});

const saturdayCountColor = css({
  backgroundColor: '#' + columnColors.saturdayCountColor,
});

const sundayCountColor = css({
  backgroundColor: '#' + columnColors.sundayCountColor,
});

const summaryAverageFormat = { type: 'fixedPoint', precision: 3 };

const CustomTooltip = ({
  active,
  payload,
}: {
  active?: boolean;
  payload?: { payload: any }[];
}) => {
  if (!active || !payload || !payload.length) return null;

  const point = payload[0].payload;

  return (
    <div
      style={{
        background: "white",
        padding: "10px 14px",
        border: "1px solid #ccc",
        borderRadius: 4,
      }}
    >
      <div><strong>APB :{point.apbNumber}</strong></div>
      <div>nbr : {point.ecartCnt}</div>
      <div>moy : {point.ecartMoy}</div>
      <div>eType : {point.ecartStdev.toFixed(2)}</div>
      <div>{point.group}</div>
{/* 
      <div style={{ marginTop: 6, opacity: 0.7 }}>
        x = {point.x}, y = {point.y}
      </div> */}
    </div>
  );
};